var _style, _g, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _g2, _tspan6, _g3, _tspan7, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 392",
    width: 1080,
    height: 392,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rasnas Final-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #fab447 } \n\t\t.t1 { font-size: 48px;line-height: 1296px;fill: #f8b95d;font-weight: 300;font-family: \"Helvetica\" } \n\t\t.t2 { font-size: 274px;line-height: 137px;fill: #fab447;font-family: \"Beverly\" } \n\t\t.t3 { font-size: 48px;line-height: 58px;fill: #ffffff;font-weight: bold;font-family: \"Helvetica\" } \n\t\t.t4 { font-size: 52px;line-height: 62px;fill: #ffffff;font-family: \"Helvetica\" } \n\t\t.s5 { fill: #ffffff } \n\t\t.s6 { opacity: 0;fill: #ffffff } \n\t\t.t7 { font-size: 40px;line-height: 48px;fill: #ffffff;font-family: \"Helvetica\" } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m491.9 73.2c-20.3 10.2-44.9 2-55.1-18.2 20.2-10.2 44.9-2.1 55.1 18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m507.4 36.9c6.3 12.5 1.3 27.8-11.2 34.1-6.3-12.5-1.3-27.7 11.2-34.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LADIES BOUTIQUE ",
    style: {
      transform: "matrix(1,0,0,1,192.972,363.941)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t1",
    dx: "0 10 10 10 10 10 10 10 10 10 10 10 10 10 10 10"
  }, "LADIES BOUTIQUE\n"))), /*#__PURE__*/React.createElement("text", {
    id: "Rasnas",
    style: {
      transform: "matrix(1,0,0,1,77.138,223.382)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t2"
  }, "R")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "t2"
  }, "asnas\n")))), /*#__PURE__*/React.createElement("text", {
    id: "Kuwait, India ",
    style: {
      transform: "matrix(1,0,0,1,328.992,1388.292)"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "Kuwait, India\n"))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("text", {
    id: 96597616809,
    style: {
      transform: "matrix(1,0,0,1,-201.239,1232.285)"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t4",
    dx: "0 10 10 10 10 10 10 10 10 10 10 10 10"
  }, "+96597616809\n"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-231.1 1213.3c0 9.6-8.2 17.5-18.3 17.5q-2.6 0-5-0.7l-11.7 2.2 1.3-9.7c-1.8-2.7-2.8-5.9-2.8-9.3 0-9.7 8.1-17.6 18.2-17.6 10.1 0 18.3 7.9 18.3 17.6zm-26.2-12.7c-0.6 0.3-1.2 0.8-1.7 1.2-0.5 0.4-1.1 0.9-1.5 1.4-1 1-1.8 2.2-2.4 3.4-0.7 1.2-1.1 2.5-1.4 3.9-0.1 0.7-0.3 1.4-0.3 2.1q0 1 0 2.1 0.2 2.1 0.9 4.1 0.7 1.7 1.7 3.3l-1.1 6.2-0.2 1.2 1.2-0.3 7.4-1.6c4.2 1.4 8.9 1 12.7-1 4-2.2 7-6.1 7.8-10.5 0.8-4.4-0.5-9.2-3.4-12.5-3-3.3-7.4-5.3-11.8-5.2-2.8 0-5.5 0.7-7.9 2.2zm18.1 4.4c2.5 2.9 3.5 6.9 2.7 10.7-0.7 3.7-3.3 7-6.6 8.7-3.4 1.8-7.5 2-11 0.6l-0.3-0.1-0.4 0.1-6.1 2 1.4-5.1 0.2-0.5-0.4-0.5c-1.6-1.7-2.7-4-3-6.4-0.2-2.4 0.2-4.9 1.3-7.1 0.6-1.1 1.3-2.1 2.2-3 0.4-0.4 0.9-0.8 1.3-1.2 0.5-0.4 1-0.7 1.5-1 2.1-1.3 4.6-1.9 7-1.9 3.9 0 7.7 1.8 10.2 4.7zm-16.9 1.3c-0.4 0.4-1.4 1.4-1.4 3.3 0 1.9 1.4 3.8 1.6 4.1 0.2 0.2 2.8 4.2 6.9 5.9 0.9 0.4 1.6 0.7 2.2 0.9 1 0.3 1.8 0.2 2.5 0.1 0.8-0.1 2.4-0.9 2.7-1.9 0.4-0.9 0.5-1.3 0.5-2.1l-4.2-1.7c-0.2 0.4-1.5 1.9-2 2.3-0.9-0.2-2.2-0.8-3.8-2.2-1.1-1-2.1-2.5-2.4-3.1 0.4-0.5 1-1 1.6-1.9l-1.6-4.2c0 0-1.2 0-1.7 0-0.2 0-0.5 0.1-0.9 0.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("text", {
    id: 917909105730,
    style: {
      transform: "matrix(1,0,0,1,754.624,1232.285)"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t4",
    dx: "0 10 10 10 10 10 10 10 10 10 10 10 10 10"
  }, "+917909105730\n"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m718.1 1231.4c-15.3 0-27.7-12.5-27.8-27.8 0.1-3.4 2.8-6.2 6.2-6.2h1.5l2.5 10.8-1.8 0.9c-2.1 1.1-2.1 1.3-1.9 1.8 2.3 6.6 7.3 11.6 13.8 13.9q0.3 0.2 0.5 0.2c0.4 0 0.8-0.7 1.4-1.7l0.1-0.4 0.9-1.7 1 0.2 9.8 2.3v1.5c0 3.4-2.7 6.2-6.2 6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m699.2 1197.9l2.1 9.3 0.3 1.5-1.4 0.7-1.1 0.6c-0.4 0.2-1 0.5-1.3 0.7 2.2 6.2 7 11 13.1 13.2 0.3-0.3 0.6-0.9 0.8-1.3v-0.1l0.6-1.1 0.7-1.3 1.5 0.3 0.2 0.1 9.1 2.1 1.5 0.3v2.3c0 3.9-3.2 7.1-7.2 7.2-15.8 0-28.7-13-28.8-28.8 0.1-4 3.3-7.2 7.2-7.2h2.3zm-2.6 0.4c-2.9 0-5.2 2.4-5.2 5.2 0 14.8 12 26.8 26.8 26.8 2.9 0 5.2-2.3 5.2-5.2v-0.6l-9.1-2.1-0.2-0.1-0.6 1.1q0 0 0 0.1 0 0 0 0c-0.7 1.4-1.3 2.4-2.4 2.4q-0.3 0-0.8-0.2c-6.7-2.4-12-7.7-14.4-14.4-0.7-1.5 0.7-2.3 2.4-3.2l1.1-0.5-2.2-9.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m718.1 1231.4c-8.2 0-16.4-3.7-21.8-9.8-4.6-5.3-6.7-11.7-5.9-18.2 0.5-4.5 3.7-6.1 6.4-6.1q0.5 0.1 0.5 0.1h0.7l0.2 0.7 2.3 10.1-1.8 0.9c-2.1 1.1-2.1 1.3-1.9 1.8 2.3 6.6 7.3 11.6 13.8 13.9q0 0 0 0c0.2 0 1.1-0.2 2.7-2.8l0.5-0.7 10.5 2.4v1.5c0 3.4-2.7 6.2-6.2 6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m697.4 1196.4l1.4 0.1 0.4 1.4 2.1 9.3 0.3 1.5-1.4 0.7-1.1 0.6c-0.4 0.2-1 0.5-1.3 0.7 2.1 6.1 6.8 10.8 12.8 13.1 0.3-0.2 0.9-0.8 1.9-2.3q0-0.1 0.1-0.2l0.7-1.2 1.4 0.4 9.1 2.1 1.5 0.3v2.3c0 3.9-3.2 7.1-7.2 7.2-8.5 0-17-3.8-22.6-10.2-4.8-5.4-7-12.1-6.1-18.9 0.6-5.1 4.2-7 7.4-7 0.4 0 0.6 0.1 0.6 0.1zm-6.1 7.2c-1.8 14.7 12 26.8 26.8 26.8 2.9 0 5.2-2.4 5.2-5.2v-0.7l-9.1-2.1c-0.1 0.3-2 3.5-3.5 3.5q-0.3 0-0.5-0.1c-6.7-2.4-11.9-7.7-14.3-14.4-0.7-1.6 0.6-2.3 2.3-3.2l1.1-0.6-2.1-9.2q0 0-0.4-0.1c-1.1 0-4.9 0.4-5.5 5.3z"
  })))))), /*#__PURE__*/React.createElement("text", {
    id: "Connect with me ",
    style: {
      transform: "matrix(1,0,0,1,298.045,941.32)"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t7",
    dx: "0 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4"
  }, "Connect with me\n"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m512.4 704.9c0 6 0.3 12-0.1 18-0.6 10.3-8.4 17.7-18.8 18-8.9 0.3-17.7 0.5-26.6 0.4-4-0.1-8.1-0.5-12-1.5-7.2-1.9-11.6-6.8-13-14.1-0.6-3.4-0.9-6.9-0.9-10.4 0-9.1-0.2-18.3 0.5-27.4 0.9-11.3 8.1-17.8 19.4-18.2 10.7-0.3 21.3-0.5 31.9 0.1 12.8 0.7 19.6 8.1 20 21 0.1 4.7 0 9.4 0 14.1q-0.2 0-0.4 0zm-35.2 30q0-0.2 0-0.4c4.9 0 9.8 0.1 14.6 0 8.3-0.2 13-4.1 14.2-12.2 0.5-3 0.4-6.2 0.4-9.2-0.1-8.2 0.1-16.4-0.5-24.6-0.6-7.7-5.4-12.1-13.2-12.3q-16-0.3-31.9 0c-7.7 0.2-12.8 5.5-12.9 13.1-0.2 10.9-0.2 21.8 0 32.6 0.1 6.4 4.4 11.4 10.8 12.1 6.1 0.6 12.3 0.6 18.5 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m584 576.7c3.2 0 6.4-0.1 9.5 0 7.1 0.3 11.6 4 12.1 10.9 0.5 7 0.6 14.1 0.1 21.1-0.6 7.8-5 11.6-12.9 11.8q-9.2 0.4-18.3 0c-7.6-0.3-12.1-4.7-12.4-12.3-0.3-6.5-0.3-13.1 0-19.6 0.3-7.2 4.7-11.5 11.9-11.9 3.4-0.2 6.7 0 10 0q0 0 0 0zm-0.1 5.9c-3.1 0-6.3-0.1-9.5 0.1-4.1 0.2-6.3 2.4-6.4 6.4q-0.1 9.5 0 18.9c0.1 4.1 2.1 6.3 6.1 6.5q9.7 0.3 19.5 0c3.9-0.2 6.1-2.3 6.3-6.1 0.3-6.5 0.3-13 0-19.5-0.2-4-2.6-6.1-6.7-6.2-3.1-0.2-6.2-0.1-9.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m370.1 576.7c2.6 0 5.3-0.1 8 0 8.7 0.1 13 3.6 13.7 12.2 0.6 6.7 0.5 13.6-0.1 20.4-0.7 7-4.4 10.6-11.5 11-7.3 0.5-14.6 0.3-21.9-0.2-5.6-0.4-9.7-4.5-10-10.1-0.4-7.6-0.4-15.3 0-23 0.4-5.6 4.3-9.1 9.8-10 2-0.3 4.1-0.3 6.1-0.3 1.9-0.1 3.9-0.1 5.9-0.1q0 0 0 0.1zm-0.3 38c3 0 6 0 9-0.1 4.6-0.1 7.2-2.5 7.3-7.1q0.3-9 0-18c-0.2-4.6-2.5-6.8-7.1-6.9q-9.1-0.2-18.1 0c-4.5 0.1-6.9 2.3-7.1 6.7q-0.4 9.2 0 18.5c0.1 4.4 2.8 6.7 7.2 6.8 3 0.1 5.9 0.1 8.8 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m370.1 834.2c-4-0.3-8-0.3-11.9-0.7-5.2-0.6-9.6-4.8-9.9-9.9-0.3-7.5-0.4-15 0.1-22.4 0.4-6.9 5.1-10.8 12.8-11.1q8.9-0.3 17.8 0c7.7 0.3 12.6 4.7 12.9 12.2 0.4 7.1 0.1 14.2-0.3 21.2-0.4 5.5-4.3 9.2-9.8 10-3.9 0.5-7.8 0.4-11.7 0.7zm0-38.2q0-0.1 0-0.1c-2.8 0-5.7 0-8.5 0-5 0.1-7.6 2.2-7.8 7.1-0.3 6.3-0.3 12.5-0.1 18.7 0.2 4.2 2.6 6.2 6.7 6.3q9.6 0.2 19.2 0c4-0.1 6.3-2.2 6.5-6.2 0.2-6.4 0.2-12.9 0-19.4-0.1-3.8-2.9-6.3-6.7-6.4-3.1-0.1-6.2 0-9.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.7 583.2c1.8 0.1 2.8 1.1 2.8 2.9 0 1.8-1.2 2.7-2.8 2.7-1.8 0-2.8-1.1-2.8-2.8 0-1.8 1-2.6 2.8-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.3 648.8c-0.2 1.7-1.1 2.8-2.9 2.8-1.8 0.1-2.8-1-2.8-2.7 0-1.6 0.8-2.9 2.6-2.9 1.8-0.1 2.8 1 3.1 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m514.7 582.6c-1.8-0.3-2.9-1.2-2.8-3 0-1.7 1.1-2.7 2.8-2.7 1.7 0 2.8 1 2.8 2.7 0 1.8-1 2.8-2.8 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.8 773.8c1.1-0.7 2.1-1.9 3.2-2.1 1.7-0.3 2.8 0.9 2.8 2.6 0 1.8-1.1 3.1-2.8 2.8-1.2-0.1-2.2-1.4-3.2-2.2q0-0.5 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m571.9 758.6c0.8 1 2 2 2.2 3.2 0.2 1.6-1 2.7-2.7 2.8-1.6 0.1-3.2-1.4-2.8-2.9 0.3-1.2 1.4-2.1 2.2-3.1q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m486.4 592.8c-1 0.8-2 2-3.1 2.2-1.7 0.3-2.9-0.9-2.9-2.7 0-1.8 1.1-2.8 2.9-2.9 1.8 0 2.6 1.1 3.1 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.5 642c-0.6 2.3-1.5 3.3-3.2 3.3-1.8 0-2.8-0.9-2.8-2.7 0-1.8 1.2-3.1 2.9-2.8 1.1 0.2 2.1 1.4 3.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m602.7 664.9c1.7 0.1 3.1 1 2.7 2.8-0.2 1-1.4 2.4-2.4 2.6-1.7 0.4-2.9-0.7-3-2.6-0.1-1.8 0.9-2.7 2.7-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m564.6 714.8c-0.8-1-2-1.9-2.3-3-0.5-1.5 1.1-3.1 2.7-3 1.6 0.1 3 1 2.8 2.7-0.2 1.1-1.3 2.1-2 3.2q-0.6 0.1-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.8 717.2c1.1-0.7 2.1-1.8 3.3-2 1.6-0.3 2.6 1.1 2.7 2.7 0.2 1.5-1.5 3.2-2.9 2.8-1.2-0.4-2.1-1.6-3.1-2.4q0-0.5 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.8 585c0.8-0.5 1.9-1.6 3-1.7 1.7-0.2 2.7 1.1 2.7 2.8-0.1 1.6-1.1 2.8-2.8 2.7-1.9 0-2.6-1.3-2.9-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m482.7 589.3c-0.8-1.1-2-2-2.2-3.2-0.3-1.7 0.9-2.9 2.7-2.9 1.7-0.1 2.9 1.1 2.7 2.7-0.2 1.2-1.3 2.2-2 3.3q-0.6 0-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m455 649.3c-1 0.7-2 1.9-3.1 2.2-1.5 0.2-2.9-0.8-3-2.5 0-1.8 1.1-3.1 2.8-2.9 1.2 0.1 2.2 1.3 3.3 2q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m515.3 645.7c-2.2-0.5-3.4-1.2-3.4-3.1 0.1-1.7 1-2.9 2.9-2.9 1.7 0.1 2.9 1.2 2.6 2.8-0.2 1.2-1.3 2.1-2.1 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m415 588.9c-2.6-0.2-3.9-1.3-3.6-2.9 0.1-1.1 1.4-2.5 2.4-2.7 1.7-0.4 3.1 0.9 2.9 2.6-0.1 1.2-1.2 2.2-1.7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m499 775.1c-1.1 0.7-2.2 1.9-3.3 2-1.6 0.2-2.7-1-2.8-2.7 0-1.6 1.5-3.2 3-2.7 1.2 0.4 2.1 1.5 3.1 2.3q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.7 649.4c-1.1 0.7-2.1 1.9-3.3 2.1-1.6 0.2-2.8-1-2.8-2.7 0-1.8 1.2-3 2.9-2.7 1.2 0.2 2.1 1.4 3.2 2.2q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m515.3 658.2c0.7 1 1.9 2 2.1 3.2 0.3 1.8-1.1 2.8-2.9 2.7-1.7 0-2.8-1.2-2.5-2.8 0.2-1.1 1.4-2.1 2.2-3.1q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.1 632.7c-1.7-0.1-2.6-1.1-2.5-2.8 0-1.7 1-2.8 2.7-2.7 1.6 0 2.7 1 2.8 2.7 0 1.8-1.1 2.8-3 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m398.3 649.4c-1 0.7-2 1.9-3.2 2.1-1.6 0.2-2.7-1-2.8-2.6-0.1-1.6 1.5-3.3 2.9-2.8 1.2 0.3 2.1 1.4 3.2 2.2q0 0.6-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404.5 649.8c-1.1 0.5-2.2 1.6-3.4 1.6-1.6 0.1-2.6-1.2-2.4-2.9 0.2-1.7 1.4-2.9 3.1-2.4 1.1 0.3 1.9 1.7 2.9 2.5q-0.1 0.6-0.2 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m562.1 804.9c0.8-0.5 1.9-2 2.8-1.8 1.1 0.2 2.5 1.5 2.8 2.6 0.5 1.6-0.9 2.7-2.5 2.8-1.9 0.1-2.7-1.1-3.1-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.6 648.3c1-0.8 1.9-1.9 3.1-2.3 1.4-0.4 3 1.3 2.9 2.8-0.2 1.7-1.1 3-2.8 2.7-1.1-0.1-2.1-1.3-3.2-2q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.3 599.2c-1 0.8-2.2 2.1-3.2 2-1-0.1-2.3-1.5-2.7-2.7-0.5-1.3 1.5-3.1 2.9-2.7 1.1 0.4 2.1 1.5 3.1 2.3q0 0.6-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m408.5 689.3c-2.5-0.3-3.6-1.2-3.6-3 0.1-1.7 1.3-3 2.8-2.6 1.1 0.3 2.5 1.7 2.6 2.8 0.2 0.9-1.2 2-1.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m518 655.6c0.5-2.5 1.6-3.5 3.4-3.3 1.7 0.2 2.6 1.4 2.4 3.1-0.2 1.7-1.5 2.7-3.1 2.3-1.1-0.2-2-1.5-2.7-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m463.9 645.7c-0.7-1-2-1.9-2.2-3.1-0.4-1.5 0.7-2.8 2.4-2.9 1.8-0.1 3.2 0.9 3 2.7-0.1 1.1-1.3 2.2-2 3.3q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.9 705.9c-1.1 0.7-2 1.9-3.2 2.1-1.6 0.3-2.8-1-2.8-2.6 0-1.8 1.1-3.2 2.9-2.8 1.1 0.2 2.1 1.4 3.1 2.2q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.5 660.8c1.1-0.8 2-1.9 3.2-2.2 1.5-0.3 3 1.4 2.8 2.9-0.2 1.7-1.2 2.9-2.9 2.6-1.1-0.3-2.1-1.4-3.1-2.2q0-0.6 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.7 654.2c-0.3 2.5-1.2 3.7-3 3.7-1.7 0-2.8-1.1-2.7-2.8 0-1.7 1.1-2.9 2.7-2.7 1.1 0.2 2.2 1.3 3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m471.4 771.2c0.7 1.1 2.1 2.3 1.9 3.2-0.2 1.1-1.6 2.5-2.8 2.7-1.5 0.3-2.9-1.1-2.5-2.8 0.2-1.1 1.4-2.1 2.2-3.1q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m546.5 708.4c0.8 1 2.1 1.9 2.3 3 0.3 1.8-0.9 2.9-2.7 3-1.7 0-2.9-1.1-2.7-2.7 0.2-1.2 1.3-2.2 2-3.3q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m477.7 639.1c-2.6-0.2-3.5-1.2-3.5-2.9 0-1.6 1-2.9 2.7-2.8 1.7 0.1 3.1 1.2 2.7 3-0.2 1.1-1.4 2.1-1.9 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.7 762.4c-1.1 0.8-2 2-3.2 2.2-1.5 0.2-2.8-0.8-2.8-2.6 0-1.8 1-3.1 2.8-2.9 1.1 0.2 2.1 1.4 3.1 2.2q0 0.5 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.7 806.2c-1.1 0.8-2 2-3.2 2.3-1.7 0.3-2.7-0.9-2.9-2.6-0.2-1.5 1.5-3.2 3-2.8 1.1 0.3 2 1.3 3 2q0 0.6 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m521.8 733.1c-2.6-0.1-3.6-0.9-3.6-2.7 0-1.7 1-2.7 2.7-2.7 1.7 0.1 3.1 0.9 2.8 2.6-0.2 1.2-1.4 2.2-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m408.5 727.4c0.7 1 1.7 1.9 2 3 0.3 1.4-1.7 3.4-2.8 2.9-1.2-0.6-2.5-1.9-2.6-3-0.1-0.9 1.5-2 2.3-3q0.5 0 1.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m394.6 702.2c-0.7-1-2-2-2.2-3.1-0.3-1.6 1-2.8 2.7-2.8 1.6-0.1 3 0.9 2.7 2.6-0.1 1.2-1.3 2.2-2 3.2q-0.6 0.1-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m444.9 645.7c-0.8-1.1-2-2-2.2-3.2-0.3-1.6 0.9-2.7 2.6-2.8 1.8 0 2.8 1.1 2.9 2.8 0.1 1.7-1.1 2.6-3.3 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m356.9 645.7c-0.7-1.1-2-2-2.2-3.1-0.4-1.7 1-2.8 2.6-2.9 1.7-0.1 3 1 2.8 2.6-0.1 1.2-1.3 2.2-2 3.3q-0.6 0.1-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.5 819c-1.1 0.7-2.1 1.9-3.3 2-1.6 0.2-2.7-1-2.7-2.7 0.1-1.8 1.2-2.9 2.9-2.6 1.1 0.3 2.1 1.4 3.2 2.2q0 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.9 775.2c-0.7 0.5-1.7 1.7-2.9 1.9-1.6 0.3-2.7-1-2.7-2.7 0-1.6 1-2.7 2.7-2.8 1.8 0 2.6 1.1 2.9 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m354.3 705.8c-1.1 0.8-2 2-3.2 2.2-1.6 0.3-2.7-1-2.8-2.7-0.1-1.7 1.2-2.9 2.7-2.7 1.2 0.2 2.2 1.4 3.3 2.1q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m565.6 765c0.7 1 1.9 2 2.2 3.1 0.3 1.7-1.1 2.7-2.7 2.8-1.7 0-3-1-2.7-2.7 0.1-1.1 1.3-2.2 2-3.2q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.7 736c-0.5 2.3-1.3 3.4-3.1 3.4-1.7 0.1-2.8-0.8-2.9-2.5-0.1-1.9 1.1-3.1 2.8-2.9 1.1 0.1 2.1 1.3 3.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m518.2 680.1c0.1-1.8 1.1-2.6 2.8-2.6 1.7 0.1 2.8 1.1 2.7 2.8 0 1.6-1 2.7-2.7 2.7-1.9 0.1-2.7-1.2-2.8-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.3 756.2c-1.1 0.7-2.1 1.9-3.3 2-1.6 0.2-2.7-1.1-2.7-2.8 0.1-1.7 1.4-2.8 2.9-2.5 1.2 0.2 2.1 1.4 3.2 2.2q-0.1 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m564.6 746.2c-0.8-1.1-2-2-2.3-3.1-0.3-1.6 0.9-3.1 2.5-2.8 1.1 0.2 2.6 1.5 2.9 2.6 0.2 0.9-1.2 2.1-1.9 3.2q-0.6 0-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.8 718.2c-1 0.9-1.9 2.2-3 2.4-1.7 0.4-2.9-0.9-3-2.7 0-1.7 1-2.9 2.7-2.7 1.1 0.2 2.2 1.3 3.2 2q0.1 0.5 0.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m521.4 802.6c0.8 1 2.1 2 2.3 3.1 0.3 1.7-1 2.7-2.7 2.8-1.7 0-2.9-1.1-2.7-2.7 0.2-1.1 1.3-2.2 2-3.2q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m515.5 613.9c-2.6-0.1-3.5-1-3.6-2.7 0-1.7 1-2.8 2.7-2.8 1.8-0.1 3 1.1 2.8 2.8-0.1 1.1-1.4 2.1-1.9 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.7 712.3c0.3-2.5 1.2-3.5 2.9-3.5 1.8 0 2.6 1.1 2.6 2.8 0 1.9-1 3-2.7 2.7-1.1-0.2-2.1-1.4-2.8-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.8 764.3c1.3 1.8 2.5 2.8 2.6 3.9 0.3 1.6-1 2.7-2.7 2.7-1.8-0.1-3-1.3-2.7-3 0.2-1.1 1.5-1.9 2.8-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.7 599.3c-0.7 0.5-1.7 1.8-2.8 2-1.7 0.2-2.9-1-2.9-2.8 0-1.8 1.2-2.6 2.8-2.7 1.8-0.1 2.6 1 2.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m543.2 704.7c0.7-0.6 1.7-1.9 2.8-2.1 1.6-0.4 2.8 0.9 2.9 2.6 0.1 1.7-1 2.7-2.7 2.9-1.7 0.1-2.6-1-3-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m485.9 630.1c-0.1 1.7-1 2.7-2.8 2.6-1.7 0-2.8-1-2.8-2.7 0.1-1.7 1.2-2.6 2.9-2.7 1.8 0 2.7 1 2.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m486 579.1c-0.2 2.6-1.3 3.7-2.9 3.3-1.1-0.3-2.3-1.6-2.7-2.8-0.5-1.2 1.6-3.1 3-2.6 1.1 0.4 2 1.6 2.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.5 660.7c1.1-0.7 2.1-1.8 3.3-2 1.6-0.2 2.7 1.1 2.6 2.8 0 1.7-1.2 2.9-2.8 2.6-1.2-0.2-2.1-1.4-3.1-2.2q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m446.1 752.4c0.7 1.1 1.9 2.1 2 3.3 0.2 1.6-1 2.7-2.8 2.6-1.6-0.1-2.7-1.1-2.7-2.8 0.1-1.8 1.2-2.6 3.5-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.3 635.8c-0.6 2.4-1.5 3.4-3.3 3.2-1.6-0.3-2.6-1.4-2.4-3.1 0.2-1.7 1.4-2.8 3-2.4 1.1 0.3 2 1.7 2.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.3 817.6c-0.3 2.5-1.1 3.6-2.9 3.5-1.6 0-2.7-1-2.7-2.7 0.1-1.7 1.1-3 2.8-2.7 1.1 0.2 2.1 1.4 2.8 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m414.6 695.9c0.7 1 2 2 2.1 3.2 0.2 1.6-1 2.6-2.7 2.6-1.7 0.1-3-1.1-2.7-2.7 0.2-1.1 1.4-2.1 2.2-3.1q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m562.1 674.8c0.2-2.5 1.1-3.5 2.8-3.6 1.7 0 2.7 0.9 3 2.6 0.1 1.4-1.5 3.2-2.9 2.9-1.2-0.4-2.1-1.4-2.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m592.9 636.2c-0.1 1.8-0.9 2.8-2.7 2.9-1.8 0-2.6-1.1-2.7-2.8-0.1-1.6 0.8-2.8 2.5-2.9 1.8-0.1 2.8 1.1 2.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m436 586.5c-1 0.8-2 2-3.1 2.2-1.8 0.4-2.7-0.9-2.7-2.6 0-1.7 0.9-3.1 2.6-2.8 1.1 0.1 2.1 1.3 3.2 2.1q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m408.4 670.8c0.7 1.1 2.1 2.3 2 3.2-0.2 1-1.7 2.4-2.8 2.6-1.6 0.4-2.9-1.1-2.6-2.7 0.2-1.1 1.5-2.1 2.2-3.1q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m524.1 717.4c1-0.8 2-2 3.1-2.2 1.6-0.3 2.8 0.9 2.8 2.6 0 1.7-1.1 3-2.7 2.8-1.1-0.1-2.1-1.3-3.2-2.1q0-0.6 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m469.9 632.8c-0.5-0.7-1.7-1.7-1.9-2.8-0.3-1.7 0.9-2.8 2.6-2.8 1.6 0 2.7 1 2.8 2.7 0 1.7-1 2.7-3.5 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.6 655.5c-1.1 0.8-2.1 2-3.2 2.2-1.7 0.4-2.8-0.8-2.8-2.6-0.1-1.7 1.1-2.9 2.7-2.7 1.1 0.1 2.2 1.3 3.3 2q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m477.7 626.8c-2.3-0.5-3.4-1.2-3.5-3-0.1-1.7 0.9-2.7 2.6-2.8 1.7 0 3.1 0.9 2.9 2.6-0.1 1.1-1.3 2.1-2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.9 597.8c-0.3 2.7-1.3 3.6-3 3.5-1.7-0.1-2.7-1.2-2.6-2.9 0.1-1.6 1.2-2.9 2.9-2.5 1.1 0.2 2 1.4 2.7 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m372.7 692c-0.2 2.6-1.1 3.6-2.9 3.5-1.7 0-2.5-1.2-2.5-2.7-0.1-1.7 1-3 2.6-2.7 1.2 0.2 2.1 1.4 2.8 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m458.8 613.9c-2.5-0.1-3.6-1.1-3.5-2.8 0-1.7 1.1-2.7 2.8-2.7 1.6 0 3 1.1 2.7 2.7-0.2 1.2-1.5 2.1-2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m361.2 761.8c-1.7 1.3-2.5 2.5-3.6 2.7-1.7 0.3-2.9-0.8-3-2.5-0.1-1.7 0.9-3.1 2.6-2.9 1.2 0.2 2.2 1.4 4 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.9 762.4c-1 0.7-1.9 1.9-3 2.1-1.6 0.3-2.9-0.8-2.9-2.5-0.1-1.7 0.9-3 2.6-2.8 1.1 0.1 2.2 1.3 3.2 2q0.1 0.6 0.1 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m514.8 833.6c-1.8-0.1-2.9-1-2.8-2.7 0-1.6 0.9-2.8 2.7-2.7 1.7 0 2.7 1 2.8 2.7 0 1.8-1.1 2.6-2.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m537 736c0.7-0.6 1.6-1.8 2.8-2 1.6-0.3 2.7 0.8 2.7 2.6 0 1.7-0.8 2.8-2.6 2.8-1.8 0-2.7-1-2.9-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m406.9 727.3c-0.7-1.1-1.8-2.2-1.9-3.3 0-1.8 1.4-3 3.1-2.4 1 0.3 2.2 1.8 2.2 2.8-0.1 1-1.4 2-2.2 3q-0.6-0.1-1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.3 736c-0.4 2.3-1.2 3.4-3 3.4-1.8 0.1-2.7-1-2.8-2.7 0-1.7 1-3 2.6-2.8 1.2 0.2 2.2 1.4 3.2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m461.5 618.3c0.2-2.5 1.1-3.6 2.8-3.6 1.7 0 2.8 1 2.8 2.7 0 1.7-1.1 3-2.7 2.7-1.2-0.1-2.2-1.3-2.9-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m394.5 633.1c-0.7-1.1-1.9-2-2.1-3.2-0.3-1.7 1-2.6 2.7-2.6 1.8 0 3 1 2.7 2.6-0.2 1.2-1.4 2.2-2.1 3.2q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m486.3 749.9c-1.1 0.7-2.1 1.9-3.2 2-1.6 0.2-2.8-1-2.7-2.7 0.1-1.7 1.2-2.9 2.8-2.6 1.2 0.2 2.1 1.4 3.1 2.1q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.6 775.1c-1.1 0.7-2.1 2-3.2 2.1-1.7 0.2-2.6-1.2-2.6-2.9 0-1.7 1-3 2.7-2.6 1.2 0.3 2.1 1.5 3.1 2.3q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.1 815.2c-0.7-1-1.9-2.1-2-3.2-0.3-1.8 1.2-2.5 2.9-2.5 1.6-0.1 2.7 1.1 2.4 2.6-0.2 1.1-1.4 2.1-2.1 3.2q-0.6-0.1-1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m565.7 670.4c-2.5-0.3-3.5-1.2-3.5-2.9 0.1-1.8 1.2-2.6 2.9-2.6 1.7 0.1 3 1.1 2.7 2.7-0.3 1.2-1.5 2.1-2.1 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m448.6 749.9c-1.1 0.7-2.1 1.8-3.2 2-1.7 0.3-2.7-1-2.7-2.6 0-1.7 1.1-2.9 2.8-2.7 1.1 0.2 2.1 1.4 3.1 2.1q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m417.1 774c1.1-0.8 2-2 3.1-2.2 1.6-0.4 2.7 0.8 2.8 2.5 0 1.7-1 3-2.6 2.8-1.1 0-2.1-1.2-3.2-1.9q0-0.6-0.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404.5 655.9c-1.1 0.7-2.1 1.8-3.3 1.9-1.5 0.1-2.7-1.2-2.6-2.9 0.2-1.7 1.4-2.8 3-2.5 1.1 0.3 2 1.6 3 2.4q0 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.7 671.2q2.9 0.1 2.9 2.7c-0.1 1.8-1.1 2.8-2.8 2.8-1.7 0.1-2.6-1.1-2.7-2.8 0-1.8 1.1-2.6 2.6-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m354.2 654.7c-0.6 2.2-1.5 3.3-3.3 3.2-1.7-0.1-2.6-1.3-2.6-2.9 0-1.8 1.3-2.9 2.9-2.6 1.1 0.2 2 1.5 3 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m549.3 655.8c-1.1 0.7-2.1 1.8-3.3 2-1.6 0.2-2.7-1.1-2.6-2.8 0.1-1.6 1.1-3 2.8-2.6 1.1 0.2 2.1 1.4 3.1 2.2q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.6 812.7c-1.1 0.7-2.1 1.9-3.3 2.1-1.6 0.3-2.6-1.1-2.6-2.7 0-1.8 1.2-2.9 2.8-2.7 1.1 0.2 2.1 1.4 3.1 2.2q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m515.4 752.2c-2.4-0.4-3.5-1.2-3.4-3 0.1-1.6 1-3.1 2.7-2.6 1.1 0.3 2.5 1.7 2.6 2.8 0.1 0.9-1.3 2-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m369.9 627.2c1.8 0.2 2.7 1.1 2.7 2.8 0 1.7-1 2.7-2.7 2.7-1.7 0-2.7-1-2.7-2.7 0.1-1.7 1-2.7 2.7-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m366.8 710.9c1.1-0.7 2-1.7 3.1-1.9 1.6-0.2 2.9 0.8 2.8 2.5 0 1.8-1.2 3-2.8 2.7-1.1-0.2-2.1-1.4-3.1-2.2q0-0.5 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.2 711.6c-0.1 1.7-1 2.8-2.7 2.7-1.7-0.1-2.8-1.1-2.8-2.7 0.1-1.7 1.2-2.7 2.9-2.7 1.7-0.1 2.5 1.1 2.6 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.6 712c-1 0.8-2.1 2.3-3 2.2-1.1-0.1-2.6-1.4-2.9-2.5-0.4-1.6 1-2.9 2.6-2.7 1.2 0.1 2.2 1.2 3.3 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m539.2 715c2.4 0.3 3.4 1.3 3.3 3-0.1 1.6-1.1 2.8-2.9 2.6-1.6-0.1-2.8-1.2-2.5-2.9 0.3-1.1 1.5-2 2.1-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.9 819.1c0.1-2.5 1.1-3.5 2.8-3.5 1.7 0 2.6 1.1 2.6 2.6 0.1 1.7-0.9 3.1-2.6 2.8-1.1-0.1-2.1-1.4-2.8-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m427 815.2c0.8 1 2.1 2 2.3 3.1 0.2 1.6-1 2.8-2.7 2.8-1.8 0-2.8-1.2-2.6-2.8 0.2-1.1 1.2-2 1.9-3.1q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m357.9 651.9c0.7 1.1 1.9 2.1 2.1 3.3 0.2 1.6-1.1 2.7-2.8 2.7-1.8 0-2.7-1.4-2.5-3 0.2-1.1 1.4-2 2.1-3q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.6 806.5c-1 0.7-1.9 1.8-3 2-1.7 0.2-2.8-1.1-2.7-2.9 0-1.7 1.2-2.9 2.8-2.5 1.1 0.2 2 1.5 3 2.3q-0.1 0.6-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.9 806.4c-1.1 0.7-2.2 2-3.3 2-0.9-0.1-2.6-1.8-2.5-2.5 0.2-1.1 1.6-2.6 2.6-2.7 1-0.1 2.1 1.3 3.2 2.1q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m486.3 762.4c-1.1 0.8-2.1 2-3.2 2.1-1.5 0.2-3-1.1-2.6-2.7 0.3-1.1 1.7-2.5 2.8-2.6 0.9-0.1 2 1.3 3 2.1q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.6 685.8c-0.5 2.2-1.2 3.4-3 3.4-1.8 0-2.7-1-2.7-2.7-0.1-1.7 0.9-3 2.6-2.8 1.1 0.2 2.1 1.4 3.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m540.3 752.4c0.8 1 2 2 2.2 3.1 0.2 1.6-1 2.8-2.7 2.8-1.6 0.1-2.9-1-2.7-2.6 0.2-1.2 1.4-2.2 2.1-3.3q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m419.6 752.4c-0.7-1.1-1.8-2.2-1.9-3.3-0.2-1.6 1-2.6 2.6-2.6 1.6 0.1 2.9 1.1 2.7 2.8-0.2 1.1-1.4 2.1-2.2 3.1q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.8 611.7c0.5-2.3 1.3-3.4 3.1-3.3 1.6 0.1 2.7 0.9 2.7 2.7 0 1.7-1 3-2.7 2.7-1.1-0.2-2.1-1.3-3.1-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m362.8 752.3c-0.6-1.1-1.8-2.3-1.7-3.3 0.2-1 1.7-2.2 2.7-2.4 1.5-0.4 3.1 1.7 2.5 3.1-0.4 1-1.5 1.8-2.3 2.7q-0.6 0-1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.4 620.5c-0.8-1-2.1-1.8-2.4-3-0.3-1.6 0.9-2.7 2.6-2.8 1.6 0 3 0.8 2.9 2.5-0.2 1.2-1.3 2.2-2 3.3q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m546.2 745.7c-1.8-0.1-2.9-1-2.9-2.8 0.1-1.7 1.3-2.6 3-2.5 1.6 0 2.6 0.9 2.6 2.6 0 1.7-1.1 2.5-2.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m435.6 623.9c-0.1 1.7-1.1 2.6-2.8 2.5-1.8-0.1-2.7-1.1-2.6-2.8 0.1-1.8 1.1-2.7 2.8-2.7 1.8 0.1 2.6 1.2 2.6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m521.7 626.8c-2.3-0.5-3.5-1.2-3.5-3-0.1-1.8 1-2.7 2.6-2.7 1.8-0.1 3.1 0.9 2.9 2.5-0.1 1.1-1.3 2.1-2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.7 704.4c1.1-0.7 2.2-1.8 3.4-1.8 1.6 0 2.6 1.3 2.4 3-0.2 1.7-1.5 2.8-3 2.4-1.2-0.3-2-1.6-2.9-2.5q0-0.6 0.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m520.3 739.8c-0.7-1-1.8-2-2-3.2-0.3-1.7 0.9-2.6 2.7-2.6 1.7 0.1 2.9 1.1 2.7 2.7-0.2 1.2-1.4 2.1-2.2 3.1q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m587.1 704.6c1.1-0.7 2.1-1.9 3.2-2 1.7-0.2 2.6 1.1 2.6 2.8-0.1 1.7-1.2 2.9-2.8 2.6-1.1-0.2-2-1.5-3.1-2.3q0.1-0.5 0.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m581.1 767.3c0.7-0.5 1.7-1.7 2.9-1.9 1.7-0.2 2.6 1.2 2.5 2.9-0.1 1.6-1 2.6-2.6 2.6-1.7 0-2.7-1.1-2.8-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m473.8 806.4c-1 0.7-2 1.9-3.1 2-1.6 0.3-2.8-0.9-2.7-2.6 0-1.7 0.9-3 2.7-2.7 1.1 0.3 2.1 1.5 3.1 2.2q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.5 762.2c-1.1 0.8-2.1 2.1-3.2 2.3-1.6 0.2-2.8-1-2.7-2.8 0.2-1.6 1.1-2.9 2.8-2.6 1.1 0.2 2.1 1.3 3.1 2q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360.5 692.1c1-0.7 1.9-1.8 3-2 1.6-0.3 2.7 0.9 2.7 2.6 0.1 1.7-0.8 3-2.5 2.7-1.2-0.2-2.1-1.4-3.2-2.2q0-0.5 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.7 752.4c0.7 1.1 1.9 2.1 2.1 3.2 0.3 1.6-1 2.5-2.5 2.6-1.7 0.1-3.1-0.9-2.9-2.5 0.2-1.2 1.4-2.2 2.2-3.2q0.5-0.1 1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530 700c-0.7 0.4-1.6 1.5-2.7 1.7-1.7 0.2-2.7-1-2.8-2.7 0-1.7 1.1-2.7 2.8-2.7 1.8 0 2.6 1.2 2.7 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530 812.9c-0.6 0.4-1.5 1.7-2.5 1.9-1.8 0.2-2.9-1-2.9-2.8-0.1-1.6 0.9-2.6 2.5-2.6 1.7-0.1 2.7 0.9 2.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m529.9 668.8c-0.8 0.4-1.9 1.4-3 1.5-1.7 0.1-2.6-1.2-2.5-2.9 0.2-1.7 1.4-2.6 3.1-2.4 1.7 0.1 2.5 1.2 2.4 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.4 745.7c-1.7-0.2-2.8-1-2.7-2.8 0.1-1.7 1.2-2.6 2.9-2.5 1.7 0 2.6 1.1 2.6 2.6 0 1.8-1.2 2.6-2.8 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m366.8 755c1.1-0.7 2.1-1.9 3.2-2.1 1.6-0.2 2.6 1.1 2.6 2.8 0 1.6-1 2.5-2.6 2.6-1.7 0-2.6-1.1-3.2-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m545.4 733.9c2.5 0.4 3.6 1.2 3.4 3-0.1 1.6-1 2.5-2.7 2.5-1.7 0-3-1.1-2.7-2.7 0.2-1.1 1.4-2.1 2-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.8 812.7c-1 0.7-1.9 1.8-3 2-1.6 0.2-2.9-0.9-2.8-2.6 0-1.7 1-3 2.7-2.7 1.1 0.3 2.1 1.5 3.2 2.3q-0.1 0.5-0.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.1 768.1c-0.2 1.7-1 2.8-2.7 2.8-1.7-0.1-2.8-1.1-2.8-2.8 0-1.6 1-2.6 2.6-2.6 1.7-0.1 2.7 0.9 2.9 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.8 811.5c1-0.7 1.9-1.8 3-2 1.6-0.3 2.8 0.8 2.9 2.5 0.1 1.8-1.1 2.9-2.7 2.7-1.1-0.1-2.1-1.3-3.2-2q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m540.7 765.1c0.6 1.1 1.7 2.2 1.7 3.3 0.1 1.6-1.1 2.8-2.8 2.5-1.6-0.3-2.9-1.4-2.4-3 0.2-1.1 1.5-2 2.3-3q0.6 0.1 1.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m379 641.7c-0.2 2.5-1 3.6-2.8 3.6-1.6-0.1-2.6-0.9-2.6-2.6-0.1-1.7 0.9-3 2.5-2.8 1.2 0.1 2.2 1.3 2.9 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m477.6 833.7c-2.4-0.3-3.7-1.3-3.2-2.9 0.2-1.1 1.6-2.3 2.6-2.5 1.6-0.3 2.9 1 2.7 2.7-0.2 1.1-1.5 2-2.1 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m385.4 654.4c-0.3 2.5-1.4 3.7-3 3.3-1-0.3-2.3-1.6-2.5-2.7-0.4-1.6 1-2.9 2.6-2.6 1.2 0.2 2.1 1.4 2.9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m537.3 774.3c-1.6 1.3-2.4 2.5-3.5 2.9-1.4 0.4-3.1-1.3-3-2.8 0.1-1.7 1.2-2.9 2.8-2.7 1.1 0.2 2 1.4 3.7 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m470.6 607.6c-1.8-0.2-2.7-1.2-2.7-2.9 0.1-1.7 1.1-2.7 2.8-2.6 1.7 0.1 2.7 1.1 2.7 2.8-0.1 1.8-1.1 2.6-2.8 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m406.9 802.6c-0.7-1-1.7-1.9-1.9-3-0.2-1.7 1-2.7 2.7-2.7 1.7 0 3 1.1 2.6 2.7-0.2 1.1-1.5 2-2.3 3.1q-0.5-0.1-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.5 797c-1.3-1.7-2.6-2.6-2.7-3.7-0.3-1.6 0.9-2.7 2.7-2.7 1.8 0 2.9 1.1 2.6 2.8-0.2 1-1.4 1.9-2.6 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.6 717.1c-0.4 2.5-1.4 3.5-3.2 3.5-1.7-0.1-2.5-1.3-2.5-2.8 0.1-1.7 1.3-2.8 2.9-2.5 1.1 0.1 2 1.2 2.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m485.9 786.8c0 1.8-0.9 2.8-2.7 2.8-1.7 0-2.7-1-2.8-2.7 0-1.6 1-2.5 2.6-2.6 1.7-0.1 2.8 0.8 2.9 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.4 742.2c-0.2 2.5-1.1 3.5-2.9 3.5-1.6-0.1-2.6-1.1-2.5-2.7 0-1.6 0.9-3 2.6-2.7 1.1 0.2 2.1 1.4 2.8 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m533.5 745.7c-1.7-0.2-2.7-1-2.6-2.8 0-1.8 1.1-2.7 2.8-2.7 1.6 0.1 2.5 1.1 2.5 2.7 0 1.8-1 2.7-2.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m385.7 668.1c-1.1 0.8-2 2-3.1 2.2-1.7 0.3-2.7-0.9-2.7-2.6 0-1.8 1.1-2.9 2.7-2.7 1.1 0.2 2 1.3 3 2q0.1 0.6 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m448.3 781.5c-0.7 0.5-1.7 1.5-2.8 1.7-1.6 0.2-2.8-0.8-2.8-2.5 0-1.7 1.1-2.7 2.8-2.7 1.7 0 2.6 1.1 2.8 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m435.6 781.6c-0.7 0.5-1.6 1.6-2.7 1.7-1.6 0.2-2.7-0.9-2.7-2.7 0.1-1.7 1-2.7 2.8-2.6 1.7 0 2.5 1.2 2.6 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.3 742.1c-0.2 2.5-1.1 3.6-2.8 3.6-1.7 0.1-2.8-0.9-2.8-2.7 0-1.7 1.1-2.9 2.8-2.6 1.1 0.2 2.1 1.2 2.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360.9 654.1c0.7-0.4 1.8-1.6 2.9-1.7 1.7-0.1 2.9 1.3 2.5 2.9-0.3 1-1.7 2.2-2.7 2.4-1.6 0.2-2.7-1-2.7-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m392 655.9c-1.1 0.6-2.2 1.8-3.3 1.8-1.7 0.2-2.5-1.2-2.4-2.9 0-1.6 1.1-2.7 2.6-2.4 1.2 0.3 2.1 1.5 3.1 2.3q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m402 727.3c0.7 1 1.7 1.9 2 3 0.4 1.4-1.4 3.4-2.7 2.9-1.1-0.4-2.4-1.7-2.5-2.7-0.1-1 1.3-2.1 2-3.2q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m366.3 674.8c-0.6 0.4-1.4 1.5-2.5 1.8-1.5 0.4-3-1.3-2.8-2.8 0.1-1.6 0.9-2.6 2.6-2.6 1.8 0 2.6 1.1 2.7 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m473.8 654.6c1-0.8 2-2 3.1-2.2 1.6-0.3 2.7 1 2.8 2.6 0.1 1.7-1.1 2.9-2.7 2.7-1.1-0.1-2.1-1.3-3.2-2q0-0.5 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m529.9 680.1c-0.1 2-1.1 2.9-2.8 2.8-1.8-0.1-2.6-1.2-2.6-2.9 0.1-1.7 1.1-2.4 2.7-2.5 1.8 0 2.6 1.1 2.7 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m373.1 661.8c-1.1 0.8-2 2-3.1 2.2-1.7 0.3-2.7-0.9-2.7-2.6 0-1.7 1.1-2.9 2.7-2.7 1.1 0.2 2 1.3 3 2q0 0.5 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.3 611.1c-0.1 1.7-1 2.7-2.8 2.7-1.6-0.1-2.6-1-2.6-2.6 0-1.7 0.9-2.8 2.7-2.8 1.7 0 2.6 1 2.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m385.8 692.2c1.1-0.8 2-2 3.1-2.2 1.7-0.2 2.7 1.2 2.6 2.8 0 1.7-1.1 2.9-2.8 2.6-1-0.2-1.9-1.4-2.9-2.1q0-0.6 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m495 802.3c-0.5-0.7-1.7-1.6-1.9-2.8-0.3-1.4 0.9-2.5 2.5-2.6 1.7-0.1 2.8 0.8 2.9 2.5 0.1 1.7-1 2.6-3.5 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.2 784.4c-1.4-1.8-2.6-2.7-2.8-3.8-0.2-1.6 1.2-2.6 2.8-2.6 1.7 0 2.9 1.1 2.6 2.8-0.2 1-1.4 1.9-2.6 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m464.9 790.2c0.7 1 2.1 2.1 2 3.1 0 0.9-1.5 2.3-2.5 2.5-1.7 0.3-3-1-2.7-2.7 0.2-1 1.3-1.9 2.1-2.9q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m417 687c-0.9 0.7-1.8 1.9-2.8 2.1-1.8 0.3-3.1-1.1-2.8-2.8 0.2-1 1.6-2.5 2.5-2.5 1 0 2.1 1.3 3.1 2.1q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.3 789.6c-1.6-0.1-2.7-1-2.6-2.8 0.1-1.5 1-2.6 2.6-2.5 1.7 0 2.9 0.9 2.9 2.6 0 1.7-1 2.7-2.9 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m545.4 796.3c-0.7-1-1.8-2-1.9-3-0.3-1.7 0.9-2.8 2.6-2.7 1.7 0 3 1 2.7 2.7-0.3 1.1-1.5 2.1-2.3 3.1q-0.6-0.1-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m421.2 789.7c-2.6 0-3.5-1.1-3.6-2.7 0-1.6 0.9-2.6 2.5-2.7 1.7 0 3.1 0.8 2.8 2.5-0.1 1.2-1.2 2.2-1.7 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m424 812.2c-1.7 1.2-2.7 2.4-3.7 2.5-1.7 0.2-2.7-1.1-2.7-2.8 0-1.7 1.3-2.8 2.9-2.5 1 0.2 1.9 1.5 3.5 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m350.4 758.7c-0.7-1.1-2-2.3-1.9-3.3 0.1-0.9 1.6-2.3 2.7-2.4 1.5-0.2 2.9 1.1 2.5 2.7-0.2 1.1-1.4 2-2.2 3q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.2 786.9c0 1.9-1 2.7-2.8 2.7-1.6-0.1-2.6-0.9-2.5-2.6 0-1.7 1-2.7 2.7-2.7 1.8-0.1 2.6 1 2.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.5 767.5c1.1-0.7 2.1-1.8 3.2-2 1.5-0.3 2.6 0.8 2.7 2.4 0 1.7-1 3-2.6 2.8-1.2-0.2-2.2-1.3-3.3-2q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.5 802.1c1.4 1.6 2.6 2.5 2.8 3.6 0.2 1.6-0.9 2.8-2.6 2.8-1.8 0-2.9-1.1-2.7-2.8 0.2-1 1.3-1.9 2.5-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m480 806.3c-1 0.7-1.9 1.9-2.9 2.1-1.6 0.3-2.9-0.7-2.9-2.5 0-1.8 1-2.9 2.7-2.6 1.1 0.2 2 1.2 3.1 1.9q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m480.1 805.3c1-0.7 1.9-1.8 3-2 1.7-0.3 2.8 0.8 2.8 2.6 0 1.7-1.2 2.8-2.8 2.5-1.1-0.1-2-1.3-2.9-2q-0.1-0.6-0.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m367.4 724.1c-1.7 1.3-2.6 2.5-3.6 2.7-1.6 0.2-2.8-0.9-2.8-2.7 0-1.7 1.1-2.8 2.8-2.6 1 0.2 1.9 1.4 3.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.8 793.8c-1 0.7-1.9 1.8-3 2-1.6 0.2-2.8-0.9-2.8-2.6 0-1.7 1.2-2.8 2.8-2.5 1.1 0.2 2.1 1.3 3 2q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.7 749.9c-0.6 0.5-1.5 1.8-2.5 2-1.7 0.3-3.1-0.9-2.8-2.5 0.1-1 1.3-2.5 2.3-2.7 1.6-0.5 2.7 0.7 3 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m578.5 790.5c0.4 0.7 1.4 1.6 1.6 2.7 0.3 1.7-0.8 2.8-2.6 2.7-1.6-0.1-2.6-1-2.6-2.6 0-1.8 1-2.7 3.6-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m448.6 812.7c-1.1 0.7-2.1 1.8-3.3 2-1.5 0.2-2.6-0.9-2.6-2.6 0.1-1.7 1.2-2.8 2.9-2.5 1 0.2 2 1.3 3 1.9q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m436 768.7c-1.1 0.8-2.1 1.9-3.3 2.1-1.5 0.2-2.4-1.1-2.4-2.6 0-1.8 1.1-2.9 2.7-2.7 1.1 0.2 2 1.4 3 2.1q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.6 768.7c-0.9 0.7-1.8 1.9-2.9 2-1.7 0.3-2.7-0.9-2.8-2.6 0-1.5 0.9-2.8 2.5-2.6 1.2 0.2 2.2 1.3 3.2 2q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m370.5 765.1c0.7 1 1.8 1.9 2 3 0.3 1.7-1 2.8-2.7 2.7-1.5 0-2.7-1.1-2.4-2.7 0.2-1.1 1.3-2 2-3q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m490.2 796.5c0.7 1 1.8 2 1.9 3.1 0.2 1.6-1.1 2.6-2.8 2.5-1.7-0.1-2.7-1.2-2.3-2.7 0.2-1.1 1.3-2 2.1-3q0.5 0.1 1.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m366.3 768.9c-0.6 0.5-1.5 1.7-2.6 1.9-1.6 0.3-2.9-1.1-2.6-2.7 0.2-1 1.3-2.3 2.3-2.6 1.6-0.3 2.7 0.8 2.9 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m540.5 677.3c0.6 0.9 1.7 1.8 1.8 2.9 0.2 1.5-1 2.5-2.6 2.5-1.6-0.1-2.6-1.2-2.3-2.7 0.2-1 1.3-1.8 2-2.7q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m595.9 683.2c-0.6-1.1-1.8-2.1-1.8-3.1 0.1-0.9 1.4-2.2 2.4-2.4 1.5-0.2 2.6 1.1 2.4 2.6-0.2 1-1.2 1.9-1.9 2.9q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.5 630.6c-1 0.7-1.9 1.7-2.9 1.8-1.6 0.2-2.9-0.9-2.5-2.5 0.2-0.9 1.6-2.3 2.4-2.3 1 0 2 1.2 3 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.4 731c-0.9 0.6-1.9 1.8-2.8 1.8-0.9-0.1-2.3-1.3-2.5-2.3-0.4-1.5 1-2.7 2.5-2.5 1 0.1 1.9 1.2 2.8 1.9q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.7 674.5c-1 0.6-2.1 1.8-3.1 1.8-0.8-0.1-2-1.5-2.2-2.4-0.2-1.5 1-2.8 2.6-2.5 1 0.2 1.8 1.3 2.7 2q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.7 618c-0.9 0.7-1.9 1.7-2.9 1.8-1.6 0.2-2.6-1.2-2.3-2.6 0.1-0.9 1.5-2.2 2.2-2.2 1.1 0.1 2 1.2 3 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m376.9 721.3c0.6 0.9 1.8 2 1.7 2.8-0.2 0.9-1.4 2.3-2.4 2.4-1.4 0.3-2.7-1-2.4-2.5 0.2-1 1.3-1.9 2-2.8q0.5 0.1 1.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.7 627c0.7 1 1.8 1.8 2 2.8 0.2 1.6-1 2.8-2.5 2.6-0.9-0.2-2.3-1.4-2.3-2.2 0-1 1.1-2.1 1.7-3.1q0.6 0 1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.8 630.4c-0.9 0.7-1.8 1.8-2.8 2-1.6 0.3-2.8-1-2.5-2.5 0.2-0.9 1.5-2.2 2.4-2.3 0.9-0.1 1.9 1.1 2.9 1.8q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m521 576.2c1.2 1.6 2.4 2.6 2.3 3.4-0.1 0.9-1.6 2.5-2.2 2.4-1-0.2-2.4-1.4-2.6-2.4-0.2-0.7 1.2-1.8 2.5-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m505.6 629.8c-1.6 1.3-2.4 2.5-3.4 2.6-1.5 0.2-2.5-0.9-2.5-2.5-0.1-1.6 0.9-2.6 2.3-2.4 1.1 0.2 1.9 1.2 3.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.8 724.2c-1.6 1.1-2.5 2.2-3.5 2.4-1.6 0.2-2.8-1.1-2.4-2.6 0.2-0.9 1.5-2.2 2.4-2.2 0.9-0.1 1.9 1.2 3.5 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.5 636.7c-0.9 0.7-1.8 1.7-2.8 2-1.5 0.3-2.4-0.7-2.5-2.2-0.1-1.6 0.7-2.8 2.3-2.6 1.1 0.1 2 1.1 2.9 1.7q0.1 0.6 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m548.9 611.8c-0.9 0.6-2 1.8-2.8 1.7-0.9-0.2-2.2-1.5-2.4-2.4-0.3-1.6 1-2.7 2.6-2.4 1 0.2 1.8 1.3 2.7 2q0 0.6-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m539.1 639.1c-0.6-1-1.5-1.9-1.7-2.9-0.1-1.6 1-2.5 2.7-2.4 1.5 0.1 2.4 1.2 2.1 2.6-0.3 1-1.3 1.8-1.9 2.8q-0.6-0.1-1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m379.1 687.1c-1 0.7-2.1 1.9-2.9 1.7-0.9-0.1-2.1-1.4-2.3-2.4-0.3-1.5 0.9-2.6 2.4-2.3 1 0.2 1.9 1.3 2.8 2q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.7 787.5c-1 0.7-2 1.9-2.8 1.8-0.9-0.1-2.3-1.3-2.5-2.2-0.3-1.5 0.9-2.8 2.5-2.6 1 0.2 1.8 1.3 2.8 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.8 629.6c1-0.7 2-2 2.9-2 0.8 0 2.3 1.5 2.3 2.3-0.1 0.9-1.3 2.2-2.3 2.4-0.8 0.2-1.9-1-2.8-1.6q0-0.5-0.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.7 605.5c-0.9 0.6-2 1.8-2.8 1.7-1-0.1-2.3-1.4-2.5-2.3-0.3-1.5 1-2.7 2.6-2.4 1 0.2 1.8 1.2 2.8 1.9q-0.1 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m526.7 745.8c-0.6-0.9-1.9-1.9-1.8-2.7 0.1-1 1.5-2.4 2.3-2.4 0.9 0 2.3 1.4 2.4 2.3 0.1 0.8-1.1 1.9-1.7 2.8q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m589.9 695.5c1.3 1.6 2.5 2.4 2.7 3.4 0.3 1.6-1 2.7-2.4 2.5-1-0.2-2.3-1.4-2.4-2.3-0.1-0.9 1-1.9 2.1-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m570.8 701.9c-0.7-0.9-1.7-1.8-1.9-2.8-0.3-1.6 0.9-2.8 2.5-2.4 0.9 0.2 2.1 1.5 2.2 2.4 0.1 0.9-1.1 1.9-1.7 2.8q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.7 825.3c-1 0.6-1.9 1.5-2.9 1.7-1.6 0.2-2.4-1-2.4-2.4 0-1.6 1-2.6 2.5-2.3 1 0.2 1.9 1.2 2.8 1.9q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.3 825.3c-1 0.6-2 1.8-2.9 1.7-0.9-0.1-2.2-1.5-2.2-2.4 0-0.8 1.4-2.3 2.2-2.3 1 0 2 1.3 3 2q-0.1 0.5-0.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593.7 686.4c-1.6 1.2-2.5 2.4-3.5 2.5-1.5 0.3-2.7-1-2.4-2.5 0.2-0.9 1.5-2.2 2.4-2.3 0.8-0.1 1.8 1.1 3.5 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593.1 781c-1 0.7-1.9 2-2.8 2-0.9-0.1-1.8-1.4-2.6-2.2 0.8-0.9 1.4-2.3 2.3-2.5 0.9-0.1 2 1 3 1.6q0 0.6 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m372.8 668.3c-1 0.6-2.1 1.8-2.9 1.6-0.9-0.1-2.1-1.4-2.3-2.4-0.3-1.4 1-2.5 2.4-2.2 1 0.2 1.9 1.2 2.8 1.9q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.8 579.2c0.9-0.6 1.9-1.9 2.7-1.8 1 0.2 1.8 1.5 2.6 2.3-0.8 0.8-1.5 2.2-2.5 2.4-0.8 0.1-1.9-1.1-2.8-1.7q0-0.6 0-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m483.2 627.2c-1.2-1.6-2.4-2.6-2.4-3.5 0.1-0.8 1.4-2.1 2.3-2.3 1.5-0.3 2.8 0.7 2.6 2.3-0.2 1.1-1.3 1.9-2.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593.1 693.3c-1 0.7-2 1.9-2.8 1.8-1-0.1-2.3-1.3-2.5-2.2-0.3-1.5 0.9-2.8 2.5-2.5 1 0.1 1.9 1.2 2.8 1.9q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m483.9 595.8c0.6 1 1.9 2 1.7 2.8-0.2 0.9-1.5 2.1-2.5 2.3-1.4 0.2-2.6-0.9-2.3-2.4 0.2-1 1.3-1.8 2-2.7q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m427.3 790.4c0.6 1 1.8 2.1 1.6 2.9-0.1 0.9-1.6 2.2-2.4 2.2-0.8-0.1-2.1-1.5-2.2-2.4 0-0.9 1.2-1.8 1.9-2.7q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593.7 736.7c-1.6 1.2-2.5 2.4-3.5 2.5-1.5 0.2-2.7-1.1-2.4-2.6 0.3-0.9 1.6-2.1 2.5-2.2 0.8-0.1 1.8 1.2 3.4 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m379.1 743.6c-1 0.6-2 1.8-2.9 1.7-0.9-0.1-1.6-1.4-2.5-2.3 0.9-0.8 1.6-2.2 2.6-2.3 0.8-0.1 1.9 1.2 2.8 1.8q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m586.6 750c-1 0.6-2.1 1.7-2.9 1.5-0.9-0.2-1.6-1.6-2.4-2.4 0.9-0.8 1.8-2.1 2.8-2.1 0.8-0.1 1.7 1.2 2.6 1.8q0 0.6-0.1 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m520.4 752c-0.7-0.9-1.9-2-1.8-2.8 0.1-0.9 1.5-2.2 2.4-2.2 0.8 0 2.1 1.4 2.3 2.3 0.1 0.8-1.2 1.8-1.8 2.7q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m427.1 595.8c0.6 0.9 1.9 1.8 1.8 2.7 0 0.9-1.3 2.1-2.2 2.4-1.4 0.4-2.7-0.7-2.4-2.2 0.1-1 1-1.9 1.6-2.9q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.4 800.1c-1 0.6-2 1.9-2.9 1.7-0.9-0.1-1.7-1.5-2.5-2.3 0.9-0.8 1.6-2.2 2.5-2.3 0.9 0 1.9 1.2 2.9 1.8q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.2 636.8c-0.9 0.7-2 2-2.8 1.9-0.9-0.1-2.1-1.5-2.3-2.5-0.3-1.4 0.8-2.6 2.3-2.4 1 0.2 1.9 1.3 2.8 1.9q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.2 724.7c-0.9 0.7-2 1.9-2.7 1.8-1-0.2-2.3-1.5-2.3-2.4 0-0.8 1.4-2.2 2.3-2.3 0.8-0.1 1.8 1.1 2.7 1.8q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.1 592.9c-0.9 0.6-1.8 1.6-2.8 1.7-1.6 0.2-2.8-1-2.5-2.5 0.2-0.9 1.7-2 2.6-2.1 0.9-0.1 1.9 1.1 2.8 1.8q0 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m391.7 731c-1 0.7-2 1.9-2.8 1.8-1-0.2-2.2-1.5-2.4-2.4-0.1-0.7 1.4-2.4 2.1-2.3 1 0.1 2 1.2 3.1 1.9q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m603.2 633.4c0.7 0.9 1.9 1.8 1.9 2.7-0.1 0.9-1.2 2.3-2.1 2.6-1.6 0.4-2.7-0.9-2.6-2.4 0.1-1 1.1-1.9 1.7-2.9q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593 806.5c-1 0.6-2 1.7-2.9 1.6-0.9-0.2-2.3-1.6-2.2-2.4 0.1-0.8 1.5-2.1 2.4-2.2 0.9-0.1 1.8 1.2 2.7 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m372.8 680.8c-0.9 0.6-2 1.8-2.8 1.7-0.9-0.1-2.4-1.5-2.3-2.3 0-0.8 1.4-2.2 2.3-2.3 0.8-0.1 1.8 1.2 2.8 1.8q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m570.7 645.3c-0.6-0.9-1.7-1.8-1.8-2.8-0.2-1.6 1-2.7 2.5-2.4 1 0.3 2.2 1.6 2.2 2.5 0.1 0.8-1.1 1.8-1.8 2.7q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m526.8 758.3c-0.7-0.9-2-1.8-1.9-2.7 0.1-0.9 1.4-2.3 2.3-2.3 0.8 0 2.2 1.3 2.4 2.2 0.1 0.8-1.1 1.9-1.7 2.8q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.2 580.3c-1 0.7-2 1.9-2.9 1.8-0.9-0.2-2.1-1.5-2.3-2.5-0.4-1.5 1-2.5 2.4-2.3 1 0.2 1.9 1.3 2.8 2q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m505.6 780c1-0.6 2-1.8 2.8-1.6 0.9 0.1 2.1 1.4 2.3 2.4 0.3 1.4-0.9 2.6-2.4 2.3-1-0.2-1.8-1.3-2.7-2q0-0.6 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.2 737.2c-0.9 0.7-1.9 2-2.7 1.9-0.9-0.1-2.3-1.5-2.3-2.3-0.1-0.9 1.3-2.3 2.2-2.4 0.8-0.2 1.9 1.1 2.8 1.7q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m586.7 781.2c-0.9 0.7-1.9 1.9-2.8 1.8-0.9-0.1-2.2-1.4-2.4-2.3-0.3-1.5 0.9-2.6 2.3-2.4 1.1 0.2 2 1.2 2.9 1.8q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m572.1 777.9c0.5 1 1.7 2.1 1.5 2.9-0.2 0.9-1.6 2.1-2.5 2.2-0.7 0.1-2.2-1.5-2.2-2.2 0.1-1.1 1.3-2 2-3q0.6 0 1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m432.1 582.4c-0.6-0.9-1.8-2-1.6-2.8 0.2-0.9 1.7-2.2 2.5-2.2 0.9 0.1 2.2 1.5 2.3 2.4 0 0.9-1.3 1.8-2.1 2.7q-0.5 0-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m486.1 649.4c-1 0.6-1.9 1.5-3 1.7-1.4 0.2-2.7-0.8-2.3-2.3 0.2-0.9 1.5-2.1 2.4-2.2 0.9-0.1 2 1.1 2.9 1.7q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.7 696.2c-1.2-1.6-2.6-2.5-2.5-3.3 0.1-1 1.3-2.3 2.3-2.5 1.5-0.3 2.7 0.9 2.5 2.5-0.1 0.9-1.2 1.7-2.3 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.4 699.7c-0.9 0.6-1.9 1.7-2.7 1.5-1-0.1-2.4-1.2-2.6-2.1-0.3-1.5 1-2.7 2.5-2.4 1.1 0.2 1.9 1.3 2.8 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.1 706c-0.8 0.6-1.7 1.5-2.6 1.6-1.5 0.3-2.5-0.7-2.5-2.3 0-1.5 0.9-2.6 2.4-2.3 1 0.2 1.9 1.2 2.8 1.9q0 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m602.1 714.4c-0.6-0.9-1.6-1.8-1.7-2.9-0.3-1.5 1-2.5 2.4-2.2 0.9 0.3 2.2 1.5 2.3 2.4 0.1 0.9-1.2 1.8-1.9 2.8q-0.5 0-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m417.6 623.3c0.8-0.7 1.8-2.1 2.6-2 0.9 0.1 2.4 1.4 2.4 2.3 0 0.8-1.3 2.2-2.2 2.4-0.8 0.2-1.9-1-2.8-1.6q0-0.6 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.9 724.1c1.6-1.2 2.6-2.5 3.3-2.3 1 0.2 2.3 1.4 2.4 2.3 0 0.8-1.4 2.2-2.3 2.4-0.8 0.1-1.8-1.2-3.4-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m382.7 739.5c1 1.7 2.1 2.6 2.2 3.6 0.2 1.5-1.1 2.6-2.5 2.2-0.9-0.3-2-1.6-2.1-2.5-0.1-0.8 1.1-1.7 2.4-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m559.2 627c0.6 1 1.9 1.9 1.8 2.8-0.1 0.9-1.4 1.8-2.2 2.6-0.8-0.8-2.2-1.5-2.4-2.4-0.1-0.9 1.1-1.9 1.6-2.9q0.6 0 1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.1 762.3c-1 0.7-1.9 1.7-2.9 1.8-1.5 0.3-2.7-0.9-2.3-2.3 0.2-0.9 1.4-2.1 2.2-2.2 1 0 2 1 3 1.6q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.5 592.9c-1 0.6-1.9 1.6-2.9 1.7-1.5 0.2-2.6-1-2.2-2.4 0.3-1 1.5-2.2 2.4-2.3 0.9 0 1.8 1.2 2.8 1.9q-0.1 0.6-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m589.7 777.2c-0.6-0.9-1.9-1.9-1.8-2.8 0-0.9 1.4-1.7 2.1-2.6 0.9 0.8 2.3 1.5 2.4 2.4 0.2 0.9-1 2-1.5 3q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.2 623.8c1.5-1.2 2.5-2.5 3.3-2.4 1 0.1 2.3 1.3 2.5 2.2 0.4 1.6-1 2.7-2.5 2.5-0.9-0.1-1.7-1.2-3.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m567.8 699.7c-1 0.6-2 1.7-2.9 1.6-0.8-0.1-2-1.4-2.2-2.3-0.3-1.4 0.8-2.6 2.3-2.4 1 0.2 1.9 1.3 2.8 1.9q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m458.7 576.9c0.6 1 1.6 1.9 1.7 2.9 0.2 1.5-1.1 2.6-2.5 2.2-0.9-0.3-2.1-1.5-2.1-2.4 0-0.9 1.1-1.8 1.8-2.8q0.6 0.1 1.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.2 796c-0.6-0.9-1.6-1.8-1.8-2.8-0.2-1.4 0.8-2.5 2.4-2.4 1.5 0.1 2.5 1.1 2.2 2.5-0.2 1-1.1 1.8-1.7 2.7q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m559.4 765.4c0.6 0.9 1.5 1.9 1.6 2.9 0.2 1.5-1.1 2.5-2.5 2.1-0.9-0.2-2-1.5-2.1-2.3 0-0.9 1.2-1.9 1.8-2.8q0.6 0 1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m433 802.9c-1.2-1.6-2.5-2.5-2.4-3.4 0.1-0.9 1.5-2.2 2.3-2.2 0.9 0 2.1 1.4 2.3 2.4 0.2 0.7-1.1 1.7-2.2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.7 812.6c-0.9 0.6-1.9 1.8-2.6 1.6-1-0.1-1.8-1.4-2.7-2.1 0.8-0.8 1.6-2.2 2.5-2.3 0.9-0.1 1.9 1.1 2.9 1.8q-0.1 0.5-0.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m438.5 777.2c-0.6-1-1.7-2-1.7-2.9 0.1-0.8 1.4-1.9 2.3-2.1 1.4-0.3 2.7 0.7 2.4 2.2-0.2 1-1.2 1.9-1.9 2.8q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m455.2 786.8c-1.6 1.2-2.5 2.6-3.3 2.5-1-0.1-1.7-1.5-2.6-2.3 0.9-0.8 1.6-2.1 2.5-2.3 0.7-0.2 1.8 1 3.4 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m439.6 821.9c0.7 0.9 1.9 1.9 1.9 2.8-0.1 0.8-1.4 2.3-2.1 2.3-1-0.1-2.4-1.3-2.5-2.2-0.2-0.8 1-1.9 1.6-2.9q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m596.9 708.8c0.7 0.9 1.9 1.9 1.8 2.7-0.1 0.9-1.4 1.7-2.2 2.6-0.8-0.8-2.2-1.5-2.4-2.4-0.1-0.9 1.1-1.9 1.7-2.9q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m413.5 639.1c-0.6-1-1.6-1.9-1.7-3-0.3-1.4 0.9-2.6 2.3-2.2 0.9 0.2 2.2 1.4 2.2 2.3 0 0.9-1.1 1.9-1.7 2.9q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m364.1 627.1c0.6 0.9 1.9 1.9 1.9 2.8-0.1 0.9-1.5 1.7-2.3 2.5-0.8-0.7-2.1-1.4-2.2-2.2-0.1-1 0.9-2 1.4-3q0.6-0.1 1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.5 825.4c-1 0.5-2 1.6-2.9 1.5-0.8-0.1-2-1.4-2.2-2.3-0.3-1.4 0.9-2.5 2.3-2.3 1.1 0.2 1.9 1.2 2.8 1.9q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.1 737.4c-1 0.6-2.1 1.8-2.9 1.6-0.9-0.2-2-1.6-2.2-2.5-0.1-0.7 1.5-2.1 2.3-2.1 1 0.1 1.9 1.3 2.8 1.9q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m455.2 636.4c-1.6 1.1-2.5 2.1-3.4 2.2-1.6 0.2-2.5-0.9-2.5-2.6 0.1-1.5 1.1-2.5 2.5-2.2 1 0.3 1.8 1.4 3.4 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m356.8 739.6c-0.6-0.9-1.5-1.7-1.7-2.7-0.2-1.5 0.9-2.8 2.4-2.5 0.9 0.1 2.1 1.5 2.1 2.3 0.1 1-1.1 1.9-1.7 2.9q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m394.4 770.9c-0.6-1-1.5-1.9-1.6-2.9-0.2-1.5 1.1-2.5 2.5-2.1 0.8 0.2 2 1.5 2 2.3 0 0.9-1.1 1.8-1.7 2.7q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m473.5 825.1c-0.9 0.6-1.9 1.9-2.8 1.8-0.9-0.1-1.7-1.5-2.5-2.3 0.7-0.8 1.5-2.1 2.3-2.2 0.9-0.1 2 1 2.9 1.5q0.1 0.6 0.1 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m364.3 715.2c0.6 0.9 1.8 2 1.6 2.8-0.2 0.9-1.6 1.6-2.5 2.3-0.7-0.9-1.9-1.7-2-2.7-0.1-0.7 1.2-1.6 1.8-2.5q0.6 0.1 1.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m408.2 608.3c0.7 0.9 1.9 2 1.8 2.8-0.2 0.9-1.6 1.7-2.4 2.5-0.8-0.8-2.1-1.6-2.1-2.4-0.1-0.9 1-1.9 1.6-2.9q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m391.6 718.3c-0.9 0.7-1.9 2-2.7 1.9-0.9-0.1-2.2-1.4-2.4-2.3-0.4-1.5 0.9-2.5 2.4-2.3 0.9 0.2 1.7 1 2.6 1.6q0 0.5 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m499.2 780.7c-1.6 1.1-2.6 2.4-3.2 2.3-1-0.2-2.4-1.5-2.4-2.3-0.1-0.8 1.3-2.2 2.2-2.4 0.8-0.1 1.8 1.2 3.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.2 762.3c-0.9 0.7-1.8 1.7-2.8 1.8-1.5 0.3-2.6-0.9-2.3-2.3 0.2-0.9 1.4-2.1 2.2-2.2 0.9-0.1 1.9 1 2.9 1.6q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m370.7 646c0.6 1 1.7 2.1 1.6 2.9-0.1 0.9-1.6 2.3-2.2 2.2-1-0.1-2.3-1.4-2.4-2.3-0.1-0.8 1.2-1.9 1.9-2.8q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593 655.6c-0.9 0.6-2 1.9-2.8 1.8-0.9-0.2-2.2-1.4-2.4-2.4-0.3-1.5 0.9-2.5 2.4-2.3 1 0.2 1.9 1.2 2.8 1.8q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.2 768.7c-1 0.6-1.8 1.6-2.9 1.8-1.5 0.2-2.5-1-2.2-2.4 0.2-0.9 1.4-2.2 2.2-2.2 0.9-0.1 1.9 1 2.8 1.6q0.1 0.6 0.1 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m357 701.9c-0.7-1-1.8-2-1.8-3 0-0.8 1.4-1.5 2.2-2.3 0.8 0.9 2 1.6 2.2 2.6 0.2 0.8-1 1.8-1.5 2.7q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.3 626.5c-0.7-0.8-1.7-1.6-1.9-2.5-0.3-1.6 0.7-2.9 2.3-2.7 0.9 0.2 2.2 1.4 2.3 2.3 0.1 0.9-1 1.9-1.6 2.9q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.2 673.9c1.6-1.2 2.6-2.5 3.4-2.4 0.9 0.2 2.3 1.6 2.3 2.4 0 0.8-1.4 2.1-2.4 2.3-0.7 0.2-1.7-1.1-3.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.9 765.3c0.6 1 1.8 2 1.7 2.9-0.1 0.9-1.6 2.3-2.2 2.2-1-0.2-2.3-1.4-2.4-2.3-0.1-0.8 1.1-1.8 1.8-2.8q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m400.8 664.2c-0.6-1-1.6-1.9-1.7-2.9-0.2-1.5 1.1-2.5 2.5-2.2 0.9 0.3 2.1 1.5 2.1 2.3 0 0.9-1.1 1.8-1.8 2.8q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m439.2 815.5c-1.2-1.6-2.5-2.6-2.3-3.3 0.2-1 1.4-2.2 2.4-2.4 0.6-0.1 2.2 1.4 2.2 2.2 0 0.9-1.2 1.8-2.3 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m427.2 683.6c0.6 1 1.8 2.1 1.7 2.9-0.2 0.9-1.5 1.7-2.4 2.5-0.7-0.8-2-1.6-2-2.4-0.1-0.9 1-2 1.5-2.9q0.6 0 1.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.2 714.4c-0.6-0.9-1.6-1.7-1.8-2.8-0.3-1.5 0.9-2.6 2.3-2.3 0.9 0.2 2.2 1.4 2.3 2.2 0 0.9-1 1.9-1.6 2.9q-0.6 0-1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m509 790.4c0.6 1 1.7 2 1.6 2.9 0 0.8-1.3 2-2.2 2.2-1.4 0.4-2.6-0.8-2.3-2.2 0.1-1.1 1.1-1.9 1.8-2.9q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.9 792.7c0.9-0.6 1.9-1.8 2.8-1.7 0.8 0.1 1.6 1.4 2.4 2.2-0.8 0.8-1.5 2.1-2.5 2.3-0.7 0.2-1.8-1-2.6-1.6q-0.1-0.6-0.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.5 699.5c-0.9 0.6-1.9 1.9-2.6 1.7-1-0.1-2.3-1.2-2.5-2.2-0.4-1.4 0.7-2.6 2.2-2.4 1 0.2 1.9 1.2 2.9 1.8q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.2 812.5c-1 0.6-1.9 1.8-2.8 1.7-0.8 0-2.1-1.2-2.3-2.1-0.4-1.5 0.8-2.5 2.3-2.4 1 0.2 1.8 1.1 2.7 1.6q0 0.6 0.1 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.1 762.3c-0.9 0.7-1.9 1.9-2.8 1.8-0.9-0.1-1.7-1.5-2.5-2.3 0.8-0.8 1.5-2.1 2.3-2.2 1-0.1 2 1 3 1.6q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404.1 819c-0.9 0.6-1.7 1.5-2.7 1.6-1.5 0.2-2.6-0.9-2.3-2.4 0.3-0.8 1.5-2.1 2.3-2.1 0.9 0 1.9 1.1 2.8 1.8q0 0.5-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.1 831.6c-0.9 0.6-2 1.7-2.9 1.6-0.8-0.1-1.9-1.4-2.1-2.3-0.2-1.5 1-2.6 2.5-2.3 0.9 0.2 1.7 1.2 2.6 1.9q-0.1 0.6-0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m589.5 821.1c-0.6-1-1.7-2-1.6-2.9 0-0.8 1.5-2.2 2.2-2.1 0.9 0.1 2.2 1.3 2.4 2.2 0.1 0.9-1.2 1.9-1.9 2.8q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m515.2 765.3c0.7 1 1.9 2 1.8 2.8-0.2 0.9-1.5 2.1-2.4 2.3-0.6 0.1-2.1-1.4-2.2-2.2 0-0.9 1.1-1.9 1.7-2.8q0.5 0 1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.2 783.5c-0.6-0.9-1.8-1.8-1.7-2.6 0.2-1 1.4-1.8 2.1-2.7 0.9 0.8 2.2 1.6 2.4 2.5 0.1 0.8-1.1 1.8-1.7 2.8q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.6 774.9c-0.9 0.6-1.8 1.7-2.8 1.8-1.4 0.3-2.6-0.9-2.3-2.3 0.2-0.9 1.4-2.2 2.2-2.2 0.9-0.1 1.9 1 2.9 1.6q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.5 831.4c-0.9 0.7-1.9 1.9-2.7 1.8-1-0.1-2.1-1.4-2.3-2.3-0.1-0.6 1.3-2.1 2.1-2.2 0.9 0 1.9 1 2.9 1.6q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m413.9 808.6c1.2 1.6 2.3 2.6 2.4 3.5 0 0.8-1.6 2.2-2.2 2.1-1-0.1-2.3-1.3-2.5-2.2-0.1-0.7 1.2-1.8 2.3-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m564.5 708.1c-0.7-1-1.7-1.9-1.8-2.9-0.2-1.5 1-2.4 2.5-2.3 1.5 0.1 2.5 1.1 2.1 2.6-0.2 0.9-1.1 1.7-1.8 2.6q-0.5 0-1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.9 698.1c1-0.5 2.1-1.5 3-1.3 0.9 0.1 2.2 1.7 2 2.3-0.3 0.9-1.6 2-2.5 2.1-0.8 0.1-1.7-1.2-2.6-1.9q0.1-0.6 0.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m492.2 624.1c-0.8 0.7-1.6 1.8-2.5 2-1.6 0.3-2.8-1-2.6-2.4 0.1-0.9 1.4-2.2 2.3-2.3 0.8-0.1 1.8 1 2.8 1.6q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m539.9 708.1c1.2 1.7 2.4 2.7 2.2 3.4-0.2 1-1.3 2.2-2.3 2.4-1.4 0.3-2.6-0.8-2.3-2.3 0.1-1 1.2-1.8 2.4-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m584.5 828.2c0.6 0.9 1.7 1.9 1.6 2.8 0 0.9-1.5 2.3-2.1 2.2-0.9-0.2-2.2-1.3-2.4-2.2-0.1-0.8 1.1-1.9 1.7-2.8q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m565.6 689.9c0.6 1 1.7 2 1.7 2.9-0.1 0.8-1.3 2-2.2 2.2-1.4 0.3-2.6-0.7-2.4-2.2 0.1-1 1.2-1.9 1.8-2.9q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m502.6 620.9c0.6 0.9 1.8 1.8 1.7 2.6-0.1 1-1.4 1.8-2.1 2.7-0.9-0.8-2.3-1.6-2.4-2.5-0.1-0.8 1.1-1.9 1.7-2.9q0.6 0.1 1.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m388.8 764.7c1.2 1.6 2.5 2.6 2.4 3.3-0.2 1-1.5 2.2-2.4 2.3-0.7 0.1-2.2-1.3-2.2-2.1-0.1-0.9 1.1-1.9 2.2-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m367.1 642.6c-1.6 1.1-2.6 2.3-3.4 2.1-1-0.2-1.7-1.5-2.5-2.3 0.9-0.8 1.7-2 2.7-2.1 0.7-0.1 1.7 1.2 3.2 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m448.2 586.6c-0.9 0.6-1.9 1.7-2.8 1.6-0.9 0-2.1-1.2-2.3-2.1-0.3-1.4 0.7-2.6 2.2-2.4 1.1 0.1 2 1.1 2.9 1.7q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m413.6 645.3c-0.7-0.9-1.9-1.9-1.8-2.7 0.1-1 1.4-2.2 2.3-2.4 0.6-0.1 2.1 1.3 2.2 2.1 0.1 0.9-1 2-1.5 2.9q-0.6 0.1-1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m463.9 639.1c-0.6-0.9-1.6-1.8-1.8-2.8-0.3-1.5 0.8-2.7 2.2-2.4 0.9 0.2 2.2 1.4 2.3 2.2 0.1 0.9-1 2-1.6 3q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m548.9 762.4c-0.9 0.6-1.8 1.6-2.8 1.7-1.6 0.3-2.6-1-2.3-2.3 0.2-0.9 1.5-2 2.5-2.2 0.7-0.1 1.7 1.1 2.6 1.7q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.8 661.9c-0.9 0.6-1.9 1.9-2.7 1.8-0.9-0.2-2.1-1.4-2.3-2.4-0.1-0.6 1.3-2 2.1-2.1 0.9-0.1 2 1 2.9 1.5q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.4 825.3c-1 0.6-2 1.6-2.9 1.6-0.9-0.1-1.6-1.4-2.4-2.2 0.8-0.8 1.6-2.2 2.5-2.3 0.8-0.1 1.9 1.1 2.8 1.7q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m414.5 821.9c0.7 0.9 1.8 1.9 1.8 2.8-0.1 0.8-1.4 2.1-2.2 2.1-0.7 0.1-2.1-1.2-2.2-2-0.2-0.9 0.9-1.9 1.4-2.9q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m388.1 708c-0.6-0.9-1.7-2-1.6-2.9 0.1-0.8 1.4-1.9 2.4-2.1 1.5-0.2 2.5 1 2.2 2.5-0.2 0.9-1.2 1.7-1.9 2.5q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m457.4 601.3c-0.6-0.9-1.5-1.7-1.7-2.6-0.2-1.5 0.8-2.5 2.3-2.5 1.5 0 2.7 0.9 2.4 2.4-0.2 1-1.3 1.9-1.9 2.8q-0.6 0-1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m414.6 646c0.6 0.9 1.6 1.8 1.7 2.7 0.3 1.5-0.7 2.7-2.3 2.4-0.9-0.2-2.1-1.4-2.2-2.2 0-0.9 1.1-1.9 1.7-2.9q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.5 818.7c-0.9 0.7-1.9 1.9-2.8 1.9-0.8 0-2-1.3-2.3-2.2-0.3-1.4 0.8-2.5 2.3-2.3 1 0.1 1.8 1 2.7 1.6q0.1 0.5 0.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558 701.8c-0.5-0.9-1.5-1.8-1.6-2.7-0.2-1.5 0.8-2.8 2.3-2.4 0.9 0.2 2.1 1.5 2.2 2.4 0.1 0.8-1.1 1.8-1.8 2.7q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m402.1 602.2c0.6 0.9 1.6 1.9 1.6 2.8-0.1 0.8-1.3 2-2.2 2.2-1.4 0.3-2.7-0.8-2.4-2.3 0.1-1 1.2-1.8 1.8-2.8q0.6 0 1.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.2 749.9c-1 0.6-2 1.8-2.9 1.7-0.8-0.1-2.2-1.5-2.1-2.2 0.1-1 1.3-2.3 2.2-2.4 0.9-0.1 1.9 1.2 2.8 1.8q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.5 655.6c-1 0.6-1.9 1.8-2.9 1.7-0.8 0-2-1.3-2.2-2.2-0.3-1.4 0.9-2.5 2.4-2.3 1 0.2 1.8 1.1 2.7 1.7q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m400.8 814.7c-0.6-0.9-1.7-1.9-1.6-2.8 0-0.8 1.3-1.9 2.3-2.1 1.4-0.3 2.5 0.9 2.2 2.4-0.2 0.9-1.2 1.7-1.8 2.5q-0.5 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.3 655.6c-0.9 0.6-1.9 1.9-2.7 1.8-1-0.2-1.7-1.5-2.6-2.3 0.9-0.8 1.7-2.1 2.7-2.3 0.7-0.1 1.7 1.1 2.6 1.7q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m597 652.3c0.6 0.9 1.8 1.9 1.8 2.8-0.1 0.8-1.5 2.4-2.2 2.3-0.9-0.2-2.3-1.3-2.5-2.2-0.1-0.8 1.1-1.9 1.7-2.9q0.6 0 1.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360.2 668.1c-0.9 0.7-1.8 1.8-2.8 1.9-0.8 0-2-1.2-2.3-2.1-0.3-1.5 0.8-2.6 2.3-2.4 0.9 0.1 1.8 1 2.7 1.5q0.1 0.6 0.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m432.9 758.5c1.1 1.5 2.2 2.3 2.3 3.3 0.2 1.5-1 2.6-2.4 2.3-1-0.3-2.1-1.5-2.2-2.5-0.2-0.7 1.2-1.7 2.3-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m350.4 770.9c-0.5-1-1.6-2.1-1.5-3 0.1-0.8 1.4-1.9 2.3-2 1.5-0.3 2.4 1 2.1 2.4-0.2 1-1.2 1.7-1.8 2.6q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.8 658.7c0.6 1 1.6 2 1.5 2.9-0.1 0.8-1.7 2.2-2.2 2-1-0.3-2.1-1.5-2.2-2.5-0.2-0.7 1.1-1.6 1.8-2.4q0.6 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.1 705.9c-0.9 0.6-1.9 1.7-2.9 1.7-0.8-0.1-2-1.5-2-2.3 0-0.8 1.3-2.2 2.1-2.2 0.9-0.1 1.9 1.1 2.8 1.7q0 0.6 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.5 599.1c-0.9 0.6-1.9 1.7-2.8 1.7-0.9-0.1-2.1-1.3-2.3-2.2-0.3-1.5 0.9-2.6 2.4-2.3 1 0.1 1.8 1.1 2.7 1.7q0 0.5 0 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m571.8 803c0.6 0.9 1.8 1.9 1.8 2.8 0 0.8-1.5 2.2-2.1 2.1-1-0.1-2.3-1.2-2.5-2.1-0.1-0.8 1.1-1.9 1.7-2.8q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.8 749.9c-1 0.6-1.8 1.5-2.8 1.6-1.5 0.2-2.6-1-2.2-2.4 0.2-0.9 1.5-2.1 2.2-2.1 1 0 1.9 1.2 2.8 1.9q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m483.3 651.7c1.1 1.6 2.4 2.6 2.3 3.5-0.2 0.9-1.6 2.2-2.5 2.1-0.8 0-2.1-1.5-2.2-2.4-0.1-0.8 1.2-1.7 2.4-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.1 712.3c-1 0.6-2 1.6-2.9 1.5-0.8 0-2-1.4-2-2.3 0-0.7 1.3-2.1 2.1-2.1 0.9 0 1.9 1.1 2.8 1.7q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m502.5 752.8c0.7 0.9 1.7 1.7 1.9 2.6 0.3 1.5-0.8 2.7-2.3 2.4-0.9-0.2-2.2-1.3-2.3-2.1-0.1-0.9 1.1-1.9 1.7-2.9q0.5 0 1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.9 658c1 1.6 2.2 2.6 2.1 3.3-0.3 1-1.5 1.7-2.4 2.5-0.7-0.9-2-1.7-2.1-2.7-0.1-0.7 1.2-1.6 2.4-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m379 655.7c-1 0.6-2 1.7-2.9 1.6-0.9-0.1-1.6-1.4-2.3-2.2 0.8-0.8 1.6-2.1 2.6-2.2 0.7-0.1 1.7 1.1 2.6 1.8q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m357.9 702.6c0.6 0.9 1.6 1.7 1.8 2.7 0.2 1.5-1 2.6-2.4 2.2-0.9-0.1-2-1.4-2.1-2.3-0.1-0.8 1-1.7 1.6-2.6q0.5 0 1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m448.1 800.1c-0.9 0.5-1.8 1.6-2.6 1.5-0.9-0.1-1.7-1.3-2.5-2 0.8-0.8 1.4-2.2 2.3-2.3 0.9-0.1 1.9 1 2.8 1.6q0 0.6 0 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m417.4 743.1c-1.6 1.1-2.6 2.3-3.3 2.2-0.9-0.3-2.1-1.5-2.2-2.4-0.1-0.7 1.3-2.2 2.1-2.2 0.9 0 1.8 1.2 3.4 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m463.8 833.7c-0.6-0.9-1.7-1.9-1.7-2.7 0.1-0.8 1.4-2.2 2.1-2.2 0.8 0 2.3 1.2 2.4 2 0 0.9-1.1 1.9-1.7 2.9q-0.6 0-1.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m385.9 774.5c-1.6 1.1-2.7 2.3-3.3 2.2-1-0.3-1.7-1.6-2.5-2.4 0.8-0.7 1.6-1.9 2.5-2 0.8-0.1 1.7 1.1 3.3 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m489.7 828c-1.2-1.5-2.6-2.4-2.5-3.2 0.2-0.9 1.5-1.7 2.3-2.5 0.7 0.8 2 1.5 2.1 2.3 0.1 0.8-0.9 1.8-1.9 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.8 642.6c1.5-1.1 2.3-2.2 3.1-2.2 0.8 0.1 2.1 1.3 2.1 2 0 0.7-1.1 2.2-1.8 2.2-0.9 0.1-1.8-1-3.4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m565 645.7c1 1.4 2.1 2.2 2.1 3-0.1 0.8-1.3 1.5-2 2.2-0.7-0.7-2-1.3-2.2-2.2-0.1-0.7 1.1-1.6 2.1-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.3 582.8c-1-1.4-2.2-2.4-2.1-3 0.2-0.9 1.4-1.6 2.2-2.3 0.6 0.7 1.8 1.4 1.8 2.3 0.1 0.7-0.9 1.6-1.9 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m586.9 824.6c-1.4 1-2.2 2.2-2.9 2.1-0.9-0.1-2-1.3-2.1-2.1-0.1-0.6 1.2-1.9 1.9-2 0.8-0.1 1.7 1 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.5 639.5c1 1.4 2.1 2.4 2 3.1-0.1 0.8-1.4 1.4-2.1 2.1-0.7-0.7-1.9-1.4-2-2.3 0-0.7 1.1-1.6 2.1-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m568.2 630.1c-1.6 0.9-2.5 2-3.3 1.9-0.8-0.1-1.4-1.4-2.1-2.1 0.7-0.7 1.5-1.8 2.3-1.9 0.8 0 1.6 1 3.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.5 649c-1.5 0.9-2.4 1.9-3.2 1.8-0.8-0.1-1.5-1.3-2.2-2 0.8-0.7 1.6-1.9 2.5-2 0.7-0.1 1.5 1.1 2.9 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m539.9 582.8c-1.1-1.4-2.1-2.3-2.1-3.1 0.1-0.8 1.3-1.5 2-2.2 0.7 0.7 1.9 1.4 2 2.2 0.1 0.7-1 1.6-1.9 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m351.1 664.2c-1-1.3-2.1-2.2-2.1-2.9 0.1-0.8 1.4-2 2.1-1.9 0.8 0.1 1.8 1.2 2 2.1 0.1 0.6-1 1.5-2 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.4 667.9c-1.5 0.9-2.5 1.9-3.2 1.7-0.8-0.2-1.4-1.4-2.1-2.1 0.8-0.7 1.5-1.9 2.3-1.9 0.8 0 1.6 1.1 3 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m568.1 824.8c-1.5 0.9-2.4 1.9-3.2 1.8-0.8-0.2-1.4-1.4-2.1-2.1 0.8-0.7 1.5-1.9 2.3-1.9 0.7-0.1 1.6 1.1 3 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.5 784c1 1.3 2.2 2.3 2 2.8-0.3 0.9-1.3 1.7-2.3 2.1-0.3 0.1-1.8-1.3-1.7-1.9 0-0.9 1-1.7 2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m414.1 664.5c0.9 1.5 1.9 2.4 1.8 3.2 0 0.7-1.4 2-1.8 1.9-0.9-0.2-2-1.3-2.1-2-0.1-0.8 1-1.6 2.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m498.8 642.4c-1.3 1.1-2.1 2.2-2.9 2.2-0.7-0.1-2-1.3-2-2 0-0.8 1.1-2 1.9-2.2 0.7-0.1 1.6 1 3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m593.2 642.4c-1.4 1.1-2.2 2.3-2.9 2.3-0.8-0.1-2-1.3-2.1-2-0.1-0.7 1.1-2.1 1.8-2.2 0.8-0.1 1.7 1 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.3 636.3c-1.5 1-2.4 2.1-3.1 2-0.8-0.1-2-1.3-2-2 0.1-0.8 1.3-2 2.1-2.1 0.7-0.1 1.6 1.1 3 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.7 680.3c-1.6 1-2.5 2-3.2 1.9-0.8-0.1-1.4-1.3-2.1-2.1 0.7-0.7 1.4-1.8 2.2-1.9 0.8 0 1.6 1.1 3.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m477.1 645.7c-1.1-1.5-2.2-2.3-2.2-3.1 0.1-0.8 1.2-1.5 1.9-2.3 0.7 0.7 2 1.3 2.1 2.1 0.1 0.8-0.9 1.8-1.8 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404.6 629.9c-1.5 1-2.4 2.1-3.2 2.1-0.8-0.1-1.4-1.4-2.2-2.1 0.8-0.7 1.5-1.8 2.3-1.9 0.8 0 1.6 1 3.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.4 614.3c0.9 1.5 1.9 2.4 1.8 3.2-0.1 0.7-1.3 1.4-2.1 2-0.6-0.7-1.8-1.4-1.9-2.2 0-0.8 1.1-1.6 2.2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.8 585.9c-1.4 1-2.2 2.1-3.1 2.1-0.6 0-2.1-1.3-2-1.7 0.3-1 1.2-2.1 2.1-2.4 0.5-0.2 1.5 1 3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m461 592.3c-1.4 1-2.3 2.1-3 2-0.8-0.1-2-1.4-2-2.1 0-0.7 1.2-1.9 2-2 0.7-0.1 1.6 1.1 3 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m391.9 742.8c-1.4 1.1-2.2 2.3-3 2.2-0.8-0.1-1.5-1.3-2.3-2 0.8-0.6 1.5-1.7 2.3-1.9 0.7-0.2 1.6 0.9 3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.4 598.4c-1.4 1-2.3 2.1-3 2.1-0.8-0.1-1.6-1.2-2.3-1.9 0.7-0.7 1.3-2 2.1-2.1 0.7-0.1 1.7 0.9 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m586.9 692.6c-1.4 1.1-2.2 2.2-2.9 2.2-0.8-0.1-1.6-1.3-2.3-2 0.7-0.7 1.4-1.8 2.3-2 0.6-0.1 1.5 0.9 2.9 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m533.5 783.7c-1-1.4-2-2.3-2-3 0.1-0.8 1.3-1.5 2-2.2 0.7 0.7 1.9 1.4 2 2.1 0.1 0.8-1 1.7-2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.6 692.8c-1.5 1-2.4 2.1-3.1 2-0.8-0.1-1.8-1.3-2-2.1-0.1-0.5 1.2-1.9 1.9-1.9 0.8 0 1.7 1 3.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.8 629.8c-1.3 1.1-2.1 2.3-2.9 2.2-0.7 0-2-1.2-2-2 0-0.7 1.1-2 1.9-2.1 0.7-0.2 1.6 1 3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.3 674c-1.5 1-2.4 2-3.1 1.9-0.8-0.1-1.4-1.3-2.1-2.1 0.7-0.7 1.4-1.8 2.2-1.9 0.7-0.1 1.5 1.1 3 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m533.7 764.9c-1-1.4-2.2-2.3-2.1-3.1 0.1-0.7 1.2-1.8 2.1-2 0.5-0.1 1.8 1.2 1.8 1.9 0.1 0.8-0.8 1.7-1.8 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m584 702.1c-1.1-1.4-2.2-2.3-2.1-3 0.1-0.8 1.2-1.5 1.9-2.2 0.8 0.7 1.9 1.3 2.1 2 0.1 0.8-0.9 1.7-1.9 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.9 743.1c-1.5 1-2.3 1.9-3.1 1.9-0.7 0-2-1.3-1.9-1.9 0.1-0.8 1.1-2 1.9-2.1 0.8 0 1.6 1 3.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.9 815.2c1 1.5 2 2.4 1.9 3.1 0 0.8-1.2 1.5-1.9 2.2-0.7-0.7-1.9-1.4-2-2.2-0.1-0.8 1-1.6 2-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.5 752.5c1 1.4 2.2 2.2 2.1 3 0 0.8-1.2 2-1.9 2-0.8 0.1-2-1.1-2.1-1.9-0.1-0.7 0.9-1.6 1.9-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.9 648.9c-1.5 0.9-2.4 2-3.2 1.9-0.7-0.1-1.9-1.4-1.9-2.1 0.1-0.7 1.3-1.9 2.1-2 0.7 0 1.6 1.1 3 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.6 629.7c-1.4 1.2-2.2 2.3-2.9 2.3-0.8-0.1-1.6-1.2-2.3-1.9 0.7-0.7 1.3-1.9 2.1-2.1 0.7-0.1 1.6 0.9 3.1 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m448.6 648.9c-1.5 0.9-2.5 1.8-3.2 1.7-0.8-0.1-1.4-1.3-2.1-2 0.7-0.7 1.5-1.8 2.2-1.9 0.8 0 1.6 1.1 3.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m568.1 636.2c-1.5 1.1-2.4 2.2-3 2.1-0.9-0.2-1.6-1.4-2.3-2.2 0.8-0.7 1.5-1.8 2.3-1.9 0.8 0 1.6 1 3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m492.5 755.4c-1.4 1.1-2.2 2.2-3 2.2-0.7-0.1-1.8-1.3-1.9-2.1-0.1-0.6 1.1-2 1.7-2 0.9 0 1.7 1 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m549.2 818.2c-1.5 1-2.3 2.1-3.1 2.1-0.7 0-2-1.2-1.9-1.8 0.1-0.9 1.1-2.1 1.8-2.2 0.8-0.1 1.7 1 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m587 742.9c-1.5 1.1-2.4 2.2-3.1 2.1-0.8-0.1-1.9-1.2-2-2-0.1-0.6 1.1-1.9 1.8-1.9 0.8-0.1 1.7 0.9 3.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m539.9 620.6c1 1.5 2 2.4 1.9 3.2 0 0.7-1.3 2-1.8 1.9-0.9-0.2-2-1.2-2.1-2-0.1-0.7 1-1.6 2-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.2 830.8c-1.4 1-2.2 2.2-3 2.1-0.7 0-1.8-1.2-1.9-2-0.1-0.6 1.1-1.9 1.8-2 0.8 0 1.7 1 3.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.9 733.6c1 1.5 2.1 2.5 1.9 3.2-0.1 0.8-1.3 1.8-2.1 1.9-0.6 0-1.9-1.3-1.9-2 0.1-0.8 1.1-1.6 2.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m533.7 739.8c-1.1-1.4-2.2-2.3-2.1-3 0-0.8 1.1-1.9 2-2.1 0.5-0.1 1.9 1.1 1.9 1.8 0.1 0.8-0.9 1.7-1.8 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m499.1 604.9c1.4-1 2.3-2.1 3.1-2.1 0.7 0.1 2 1.3 1.9 1.9-0.1 0.9-1.1 2.1-2 2.2-0.6 0.2-1.6-1-3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.4 755.4c-1.4 1.1-2.3 2.2-3.1 2.1-0.8 0-1.5-1.2-2.2-2 0.8-0.6 1.5-1.7 2.3-1.8 0.7-0.2 1.6 0.8 3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m392 680.3c-1.5 0.9-2.4 1.9-3.3 1.8-0.7 0-1.3-1.2-2-1.8 0.7-0.7 1.4-1.9 2.2-2 0.7-0.1 1.6 1 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404 699.5c-0.9 0.5-1.7 1.5-2.6 1.5-0.7 0-1.4-1.2-2.2-1.8 0.7-0.7 1.4-1.9 2.2-2 0.8-0.1 1.7 0.9 2.6 1.4q0 0.4 0 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m565 783.6c-1-1.4-2.1-2.2-2-2.9 0-0.8 1.2-1.5 1.9-2.2 0.7 0.7 1.8 1.4 2 2.3 0.1 0.6-0.9 1.5-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m602.8 815.2c-1-1.5-2-2.3-2-3.1 0-0.7 1.3-2 1.8-1.9 0.9 0.1 2.1 1.1 2.2 1.9 0.1 0.7-1 1.6-2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.8 780.8c-1.5 1-2.3 2-3.2 2-0.6-0.1-1.8-1.4-1.7-2 0.1-0.9 1.2-2 2-2.1 0.7-0.1 1.5 1.1 2.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m363.6 708.3c-0.9-1.3-2-2.1-1.9-2.8 0.1-0.8 1.2-1.6 1.8-2.3 0.8 0.7 2.1 1.3 2.2 2.1 0.1 0.7-1 1.6-2.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m470.7 752.3c-1.1-1.4-2.2-2.3-2.1-2.9 0.1-0.8 1.2-1.8 2.1-2 0.5-0.1 1.8 1.1 1.8 1.7 0.1 0.8-0.9 1.7-1.8 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.9 822.2c0.5 0.8 1.5 1.8 1.4 2.5-0.1 0.8-1.3 1.4-2 2.2-0.6-0.8-1.7-1.4-1.8-2.2 0-0.8 1-1.7 1.5-2.5q0.4 0 0.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m436 724c-1.5 1.1-2.3 2-3.1 2.1-0.7 0-2-1.3-2-1.8 0.2-0.8 1.1-2 1.9-2.1 0.7-0.1 1.7 0.9 3.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.7 721c0.9 1.6 1.9 2.5 1.8 3.3 0 0.7-1.4 1.9-1.9 1.8-0.8-0.2-2-1.3-2.1-2 0-0.8 1.1-1.6 2.2-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m549.2 636.1c-1.4 1.1-2.3 2.2-3 2.2-0.8-0.1-1.8-1.3-2-2.1-0.1-0.5 1.1-1.8 1.8-1.9 0.8 0 1.7 0.9 3.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.5 761.9c-1.5 1-2.4 2-3.1 1.9-0.8-0.1-1.8-1.3-1.9-2.2 0-0.5 1.3-1.8 1.9-1.8 0.9 0.1 1.7 1.1 3.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.4 780.6c-1.2 1-2 2.1-2.7 2-0.8-0.1-1.5-1.2-2.3-1.8 0.7-0.8 1.2-2.1 2-2.1 0.7-0.1 1.6 0.9 3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.3 598.5c-1.4 1-2.2 2.1-2.8 1.9-0.9-0.1-1.6-1.1-2.4-1.8 0.8-0.7 1.4-2 2.2-2.1 0.7-0.1 1.6 1 3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m549.3 730.4c-1.5 1-2.4 2.1-3.2 2-0.7-0.1-1.7-1.3-1.9-2.2 0-0.5 1.3-1.8 1.9-1.8 0.9 0 1.7 1 3.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.4 627c1.1 1.4 2.2 2.2 2.2 3 0 0.7-1.2 2-1.8 2-0.8-0.1-2-1.1-2.2-1.8-0.1-0.8 0.9-1.7 1.8-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.5 830.9c-1.4 1-2.3 2.2-3 2.1-0.8-0.1-1.8-1.4-1.9-2.2-0.1-0.6 1.2-1.9 1.8-1.9 0.8 0 1.7 1 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m571.4 683.5c1 1.4 2 2.4 1.9 3.1-0.1 0.8-1.4 1.9-2.1 1.9-0.8-0.1-1.9-1.3-2-2.1 0-0.7 1.1-1.6 2.2-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m473.6 812.1c-1.4 1-2.2 2-2.8 1.9-0.9-0.1-1.6-1.1-2.4-1.7 0.7-0.8 1.3-2 2.1-2.2 0.7-0.1 1.6 1 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.6 717.8c-1.5 1-2.3 2-3.2 2-0.6 0-1.9-1.3-1.9-1.8 0.2-0.9 1.2-2.1 1.9-2.2 0.8-0.1 1.7 1 3.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m382.3 651.8c-0.9-1.4-1.9-2.3-1.7-2.9 0.2-0.9 1.3-1.5 2-2.2 0.7 0.7 1.9 1.4 1.9 2.2 0.1 0.8-1.1 1.6-2.2 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.5 686.4c-1.4 1-2.3 2.2-3 2.1-0.7-0.1-1.8-1.2-2-2.1-0.1-0.5 1.1-1.8 1.8-1.9 0.8 0 1.7 0.9 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m523.9 692.6c-1.3 1.1-2.2 2.2-2.9 2.2-0.8-0.1-1.5-1.3-2.2-2 0.7-0.7 1.3-1.8 2.2-2 0.6-0.1 1.5 0.9 2.9 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.2 787c-1.5 0.9-2.3 1.9-3.1 1.8-0.7 0-2-1.4-1.8-1.8 0.2-0.9 1.2-1.9 2-2 0.7-0.2 1.5 1 2.9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m439.1 614.3c1 1.5 2.1 2.3 2.1 3.1 0 0.7-1.2 2-1.7 2-0.9-0.2-2.1-1.1-2.2-1.9-0.2-0.7 0.8-1.7 1.8-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.3 661.2c-1.4 1.1-2.3 2.1-3.1 2.1-0.7 0-2-1.3-1.9-1.8 0.1-0.8 1.1-2 1.9-2.1 0.7-0.2 1.6 0.9 3.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.3 790.2c1 1.4 2 2.2 1.9 2.9-0.2 0.8-1.2 1.5-1.9 2.2-0.7-0.7-1.9-1.3-1.9-2 0-0.8 0.9-1.6 1.9-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.6 802.6c-1-1.5-2.1-2.4-2-3.1 0.1-0.8 1.2-1.8 2.1-1.9 0.5-0.1 1.8 1.2 1.8 1.9 0 0.8-1 1.6-1.9 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m584 658c-1.1-1.4-2.2-2.2-2.1-3 0.1-0.7 1.3-1.4 2.1-2.1 0.6 0.8 1.7 1.4 1.9 2.3 0.1 0.6-1 1.5-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.5 812c-1.3 1-2.1 2.2-2.7 2.1-0.9-0.2-1.6-1.3-2.3-2 0.7-0.7 1.4-1.7 2.2-1.9 0.6-0.1 1.5 0.9 2.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m477.1 815.4c0.9 1.4 1.9 2.3 1.8 2.9-0.2 0.8-1.3 1.4-2.1 2.1-0.6-0.7-1.7-1.5-1.8-2.3-0.1-0.6 1-1.4 2.1-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.5 827.7c-1.1-1.4-2.3-2.3-2.2-3 0-0.8 1.1-1.8 2-2.1 0.4-0.1 1.8 1.1 1.9 1.8 0 0.8-0.9 1.8-1.7 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.2 834c-1-1.5-2.1-2.4-2-3.1 0.1-0.8 1.3-1.7 2.2-1.9 0.5-0.1 1.8 1.2 1.8 1.9 0 0.8-1 1.6-2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.4 620.6c1.1 1.5 2.2 2.4 2.1 3.1-0.2 0.8-1.3 1.8-2.2 2-0.4 0.1-1.7-1.2-1.8-2 0-0.8 1-1.6 1.9-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m369.9 721.1c1 1.4 2.1 2.2 2 2.9-0.2 0.8-1.3 1.4-2 2.2-0.6-0.7-1.8-1.3-1.9-2 0-0.8 1-1.7 1.9-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m568 749.2c-1.5 1.1-2.4 2.2-3.1 2.1-0.8-0.2-1.8-1.3-2-2.2-0.1-0.4 1.2-1.7 1.9-1.8 0.8 0 1.7 1 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.3 749.3c-1.5 1-2.4 2.1-3.1 2-0.8-0.1-1.8-1.3-2-2.1-0.1-0.5 1.2-1.8 1.9-1.8 0.8-0.1 1.7 0.9 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.7 683.4c1.1 1.5 2.2 2.4 2 3.1-0.1 0.8-1.3 1.8-2.2 2-0.5 0.1-1.7-1.3-1.8-2 0-0.8 1-1.6 2-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.4 604.8c-1.5 1-2.4 2-3.2 1.9-0.7 0-2-1.3-1.9-1.8 0.2-0.8 1.2-2 2-2.1 0.7-0.1 1.6 1 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m480.1 604.7c1.5-1 2.4-1.9 3.2-1.9 0.7 0.1 2 1.4 1.9 1.9-0.2 0.8-1.2 1.9-2 2-0.7 0.1-1.6-1-3.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m414 677.2c1 1.5 1.9 2.4 1.9 3.2-0.1 0.7-1.3 1.3-2 1.9-0.6-0.7-1.7-1.4-1.9-2.2-0.1-0.7 1-1.5 2-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m372.9 761.6c-1.4 1.1-2.2 2.2-3 2.2-0.6 0.1-1.9-1.2-1.9-1.8 0.1-0.8 1.1-1.9 1.9-2.1 0.6-0.2 1.5 0.8 3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.1 677.2c1 1.4 2.2 2.3 2.1 2.9-0.2 0.8-1.4 1.5-2.2 2.2-0.6-0.8-1.7-1.5-1.8-2.3-0.1-0.7 0.9-1.5 1.9-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.1 674.3c-0.9 0.6-1.7 1.5-2.7 1.6-0.6 0.1-1.9-1.3-1.8-1.9 0.1-0.8 1.1-2 1.9-2.1 0.7-0.1 1.7 0.9 2.5 1.4q0.1 0.5 0.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.9 579.7c-1.3 1-2.1 2.2-2.7 2.1-0.9-0.2-2.1-1.3-2.2-2 0-0.7 1.2-2 2-2.1 0.7-0.1 1.6 1 2.9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m498.8 768.2c-1.5 1-2.3 2-3.1 2-0.7-0.1-1.9-1.4-1.8-2 0.1-0.8 1.1-2 1.9-2.1 0.7-0.1 1.6 1.1 3 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m350.9 670.6c-0.9-1.5-1.8-2.4-1.8-3.2 0-0.7 1.4-1.9 1.9-1.8 0.8 0.2 2 1.2 2.1 2 0.1 0.7-1.1 1.6-2.2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.7 780.5c-1.5 1.1-2.3 2.1-3.1 2.1-0.7 0-2.1-1.2-2-1.7 0.1-0.9 1.1-2 1.9-2.2 0.6-0.2 1.6 0.9 3.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m413.9 614.3c1 1.4 2 2.3 2 3.1 0 0.7-1.1 1.4-1.8 2.1-0.7-0.7-1.9-1.3-2.1-2-0.1-0.8 1-1.7 1.9-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m370 783.6c-1-1.4-2.1-2.3-2-2.9 0.2-0.8 1.4-1.4 2.1-2.1 0.6 0.7 1.7 1.4 1.8 2.1 0.1 0.7-1 1.5-1.9 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.3 705.2c-1.4 1-2.3 2.2-2.8 2.1-0.9-0.3-1.6-1.4-2.4-2.1 0.7-0.7 1.3-1.8 2.1-1.9 0.8 0 1.6 1 3.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360.4 711.6c-1.4 0.9-2.2 1.9-2.9 1.8-0.8-0.1-1.5-1.2-2.3-1.8 0.8-0.7 1.5-1.8 2.3-1.9 0.7-0.2 1.5 0.9 2.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.9 780.5c-1.4 1-2.2 2-3 2.1-0.7 0-2-1.4-1.9-1.8 0.2-0.9 1.1-1.9 2-2.1 0.6-0.2 1.5 0.9 2.9 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.3 793.1c-1.2 1-2 2.2-2.6 2.1-0.8-0.1-1.5-1.2-2.3-1.9 0.7-0.7 1.3-1.8 2.2-2 0.6-0.2 1.5 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m480.2 830.7c1.4-0.9 2.3-1.9 3-1.8 0.8 0.2 1.4 1.3 2.1 2-0.7 0.7-1.4 1.8-2.1 1.8-0.8 0-1.6-1-3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m398.2 718c-1.5 0.9-2.4 1.8-3.3 1.7-0.6 0-1.7-1.3-1.6-2 0-0.7 1.2-1.9 1.8-1.8 0.9 0 1.7 1 3.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.8 780.6c-1.4 1-2.2 2.1-2.8 2-0.9-0.2-1.9-1.2-2.1-2-0.1-0.5 1.1-1.9 1.8-1.9 0.8 0 1.7 1 3.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m398.3 636c-1.5 1.1-2.2 2.2-3.1 2.2-0.6 0.1-1.8-1.1-1.9-1.8-0.1-0.7 1-2 1.6-2.1 0.9 0 1.8 0.8 3.4 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m435.9 812.1c-1.5 1-2.3 2-3.1 2-0.6 0-2-1.4-1.8-1.8 0.2-0.9 1.1-1.9 2-2.1 0.6-0.1 1.5 0.9 2.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m596.7 752.3c-1.1-1.3-2.2-2.1-2.1-2.8 0.1-0.8 1-1.9 1.8-2.1 0.6-0.2 2 1 2 1.7 0.1 0.8-0.9 1.7-1.7 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m372.9 699c-1.3 1-2.1 2.1-2.8 2-0.8-0.1-1.5-1.2-2.2-1.8 0.6-0.7 1.2-1.9 1.9-2 0.8 0 1.6 0.9 3.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.4 802.5c-0.9-1.4-2-2.3-1.8-2.9 0.1-0.8 1.2-1.5 2-2.2 0.6 0.7 1.8 1.4 1.8 2.1 0 0.8-1 1.6-2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.5 777.3c-0.9-1.3-2.1-2.2-1.9-2.8 0.2-0.9 1.3-1.5 2-2.2 0.7 0.7 1.8 1.4 1.9 2.3 0.1 0.6-1 1.4-2 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m432.8 607.8c-1-1.5-1.9-2.4-1.9-3.2 0.1-0.7 1.4-1.8 2.1-1.7 0.7 0 1.9 1.2 1.9 1.9 0 0.8-1 1.6-2.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.2 607.9c-1-1.5-2.1-2.4-2-3.1 0.2-0.8 1.3-1.8 2.2-2 0.5-0.1 1.8 1.2 1.8 1.9 0 0.8-1 1.7-2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.5 758.7c-0.8-1.6-1.7-2.5-1.6-3.4 0.1-0.6 1.3-1.7 2-1.6 0.7 0 1.9 1.3 1.8 1.9 0 0.8-1.1 1.6-2.2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.8 774.3c-1.3 1-2.2 2.1-2.8 2-0.9-0.1-1.6-1.2-2.3-1.9 0.7-0.7 1.3-2 1.9-2 0.9 0 1.7 1 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m376.2 752.6c1 1.5 2 2.3 2 3.1 0 0.7-1.2 1.8-1.9 1.8-0.7 0-1.9-1-2-1.7 0-0.8 0.9-1.7 1.9-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m520.9 771.1c-1-1.5-2.1-2.4-1.9-3.1 0.1-0.8 1.4-1.3 2.2-2 0.6 0.8 1.6 1.5 1.7 2.3 0 0.7-1 1.4-2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511.5 818.3c-1.5 1-2.3 2-3.1 2-0.7 0-1.8-1.2-1.8-1.9 0-0.7 1-2 1.7-2.1 0.8 0 1.7 1 3.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m492.5 768c-1.3 1-2.1 2-2.8 1.9-0.8-0.1-1.5-1.1-2.3-1.8 0.7-0.7 1.3-2 1.9-2 0.9 0 1.7 0.9 3.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.3 783.7c-0.9-1.5-1.8-2.4-1.8-3.3 0.1-0.6 1.3-1.2 2-1.9 0.6 0.8 1.7 1.5 1.9 2.3 0.1 0.7-1 1.5-2.1 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.2 699.6c-0.8 0.5-1.7 1.4-2.6 1.4-0.7-0.1-1.7-1.3-1.7-2-0.1-0.7 1.1-1.8 1.8-1.8 0.9-0.1 1.7 0.9 2.5 1.4q0 0.5 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.1 749.2c-1.2 1-2.1 2.2-2.7 2.1-0.8-0.2-1.5-1.3-2.3-1.9 0.8-0.7 1.4-1.8 2.2-2 0.7-0.2 1.5 0.9 2.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m485.6 756.1c-0.8 0.5-1.7 1.5-2.5 1.4-0.7 0-1.8-1.2-1.8-1.8 0-0.7 1.1-1.9 1.8-2 0.8 0 1.7 0.9 2.5 1.5q0 0.4 0 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m476.8 752.7c1 1.4 2 2.1 2.1 3 0 0.6-1.3 2-1.8 1.9-0.9-0.2-1.9-1.2-2.1-2-0.2-0.6 0.8-1.5 1.8-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m369.9 739.6c-0.9-1.2-2-2.1-1.9-2.7 0.2-0.8 1.2-1.5 1.9-2.2 0.7 0.7 1.8 1.4 1.9 2.2 0.2 0.6-0.9 1.5-1.9 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m351.2 671c0.9 1.4 1.9 2.2 1.9 3 0 0.7-1.3 1.9-1.9 1.8-0.8-0.1-2-1.1-2.1-1.9-0.1-0.7 1.1-1.6 2.1-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m521.1 827.8c0.9 1.6 1.8 2.5 1.8 3.3-0.1 0.6-1.4 1.7-2 1.7-0.8-0.1-2-1.2-1.9-1.9 0-0.8 1-1.6 2.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.5 733.4c-1.1-1.3-2.3-2.1-2.2-2.7 0.2-0.9 1.2-1.6 1.9-2.3 0.7 0.6 2 1.2 2 1.8 0.1 0.8-0.9 1.7-1.7 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m549.2 749.3c-1.4 1-2.3 2-3.1 1.9-0.7 0-1.4-1.2-2-1.8 0.7-0.8 1.3-1.9 2.2-2 0.6-0.2 1.5 0.9 2.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m423.5 649c1.4-1.1 2.2-2.2 3.1-2.2 0.6 0 1.4 1.2 2.1 1.9-0.7 0.7-1.4 1.8-2.2 2-0.6 0.1-1.5-0.9-3-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m433 651.7c-1-1.2-2.1-2-2-2.7 0.1-0.8 1.2-1.5 1.8-2.3 0.8 0.7 1.9 1.4 2.1 2.2 0.1 0.6-1 1.5-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m376 708.1c-0.9-1.4-1.9-2.3-1.7-2.9 0.2-0.8 1.3-1.8 2-1.8 0.6-0.1 1.9 1.2 1.9 1.9-0.1 0.8-1.1 1.5-2.2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m458 758.9c0.9 1.4 1.9 2.3 1.9 3.1-0.1 0.7-1.3 1.3-1.9 1.9-0.7-0.7-1.8-1.4-2-2.2-0.1-0.6 1-1.4 2-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m508.5 652c1 1.5 1.9 2.4 1.9 3.2-0.1 0.7-1.3 1.3-2 1.9-0.7-0.8-1.8-1.5-1.9-2.3 0-0.6 1-1.5 2-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m413.9 783.5c-0.9-1.3-2-2.2-1.9-2.8 0.3-0.8 1.4-1.4 2.1-2.1 0.6 0.7 1.7 1.4 1.8 2.1 0 0.7-1 1.5-2 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.9 730.5c-1.4 0.9-2.2 1.9-2.9 1.9-0.8-0.1-1.4-1.2-2.1-1.8 0.7-0.8 1.4-1.9 2.2-2.1 0.6-0.1 1.5 1 2.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.8 815.2c0.9 1.5 1.8 2.3 1.7 3.1 0 0.7-1 1.4-1.6 2.1-0.7-0.7-1.8-1.4-2-2.2-0.1-0.7 0.9-1.5 1.9-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.4 714.5c-0.9-1.5-1.9-2.4-1.8-3.2 0.1-0.6 1.4-1.7 2.1-1.6 0.7 0 1.9 1.1 1.9 1.8-0.1 0.8-1.1 1.6-2.2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.7 655c-1.3 1-2.1 2.1-2.8 2-0.8-0.2-1.9-1.2-2-2-0.2-0.5 1-1.9 1.7-2 0.8 0 1.7 1 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m369.8 652.1c1 1.3 2.2 2.1 2.1 2.7-0.2 0.8-1.1 1.9-1.9 2.1-0.5 0.1-2-1-2-1.7-0.1-0.8 0.9-1.7 1.8-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395 764.8c-0.9-1.4-1.8-2.3-1.7-3 0.1-0.7 1.3-1.8 1.9-1.8 0.7 0.1 2 1.2 2 1.8-0.1 0.9-1.1 1.6-2.2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.8 759.1c0.9 1.2 2.1 2.1 1.9 2.7-0.2 0.8-1.4 1.4-2.1 2.1-0.7-0.7-1.7-1.4-1.9-2.3-0.1-0.6 1.1-1.4 2.1-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m369.9 702.5c1 1.3 2.1 2.2 1.9 2.8-0.2 0.8-1.3 1.4-2 2.2-0.7-0.8-1.7-1.4-1.8-2.2-0.1-0.7 1-1.5 1.9-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.5 815.3c0.9 1.4 2 2.3 1.9 2.9-0.2 0.9-1.3 1.5-2 2.3-0.6-0.8-1.7-1.5-1.8-2.3-0.1-0.7 1-1.5 1.9-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.9 758.6c-1.1-1.3-2.2-2.1-2.1-2.8 0.1-0.8 1.2-1.5 1.9-2.2 0.7 0.6 1.8 1.2 1.8 2 0.1 0.7-0.8 1.6-1.6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.8 818.3c-1.2 1-2 2.2-2.6 2-0.8-0.2-1.5-1.2-2.2-1.9 0.6-0.7 1.3-1.8 2-1.9 0.7-0.1 1.5 0.9 2.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m530.2 818.5c-1.4 0.9-2.3 2-2.9 1.8-0.9-0.2-1.5-1.3-2.2-2 0.7-0.6 1.5-1.7 2.2-1.7 0.7-0.1 1.5 0.9 2.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m379.2 761.7c-1.3 0.9-2.2 2-2.8 1.9-0.9-0.2-1.5-1.3-2.2-2 0.7-0.6 1.3-1.7 2.1-1.8 0.7 0 1.5 0.9 2.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m357.3 720.7c-0.9-1.3-2-2.2-1.9-2.8 0.2-0.8 1.3-1.4 2.1-2.1 0.6 0.7 1.7 1.4 1.7 2.1 0.1 0.7-0.9 1.5-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m363.8 645.8c0.9 1.4 1.8 2.3 1.7 3-0.1 0.7-1.2 1.3-1.9 2-0.7-0.8-1.8-1.5-1.9-2.3-0.1-0.6 1.1-1.4 2.1-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.7 802.9c1 1.3 1.9 2.2 1.9 2.8-0.2 0.8-1.2 1.9-1.8 2-0.7 0-2-1.1-2.1-1.7 0-0.8 1-1.7 2-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m517.5 805.9c-1.4 0.9-2.2 1.9-2.9 1.8-0.7 0-1.4-1.1-2.1-1.8 0.7-0.7 1.4-1.8 2.2-2 0.6-0.1 1.5 1 2.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.8 661.4c-1.3 0.9-2.1 1.9-2.8 1.9-0.7-0.1-1.4-1.2-2-1.9 0.7-0.7 1.3-1.8 2.2-2 0.5-0.2 1.4 1 2.6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m416.9 799.3c-1.3 1.1-2.2 2.3-2.7 2.1-0.8-0.2-1.7-1.1-2.1-2-0.1-0.4 1.1-1.8 1.6-1.8 0.9 0 1.7 0.9 3.2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360.2 780.5c-1.3 1-2.1 2-2.7 2-0.8-0.1-2-1.2-2-1.8 0-0.7 1.1-1.8 1.8-2 0.7-0.1 1.5 0.9 2.9 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.9 827.6c-1.1-1.4-2.1-2.2-2.1-3.1 0-0.6 1.2-1.7 1.9-1.7 0.7-0.1 1.7 1.1 1.9 1.8 0.1 0.7-0.9 1.5-1.7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.9 805.9c-1.4 0.9-2.2 1.9-2.9 1.8-0.7-0.1-1.3-1.2-2-1.8 0.7-0.7 1.3-1.8 2-1.9 0.7-0.1 1.5 0.9 2.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.4 598.5c-1.3 0.9-2 1.9-2.7 1.8-0.6 0-1.7-1-1.7-1.6-0.1-0.6 0.9-1.7 1.6-1.8 0.6-0.1 1.4 0.8 2.8 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.7 598.7c-1.4 0.8-2.2 1.7-2.8 1.6-0.7-0.1-1.3-1.1-1.9-1.7 0.7-0.6 1.2-1.6 1.9-1.7 0.7-0.1 1.4 0.9 2.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.1 617.6c-1.3 0.7-2.2 1.6-2.8 1.5-0.7-0.2-1.6-1.3-1.6-1.9 0.1-0.6 1.2-1.6 1.8-1.7 0.7 0 1.4 1 2.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m502.7 615.2c0.4 0.8 1.2 1.6 1.1 2.2-0.2 0.7-1.2 1.5-1.9 1.7-0.4 0.1-1.6-1.1-1.5-1.6 0.1-0.8 0.9-1.6 1.4-2.3q0.4 0 0.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m470.6 608.5c0.9 1.3 1.9 2.1 1.8 2.7-0.1 0.7-1.2 1.7-1.8 1.7-0.7 0-1.7-1.1-1.8-1.8 0-0.6 0.9-1.3 1.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.1 718c-1.4 0.8-2.2 1.7-2.8 1.6-0.7-0.1-1.5-1.1-1.7-1.9-0.1-0.4 1.1-1.5 1.7-1.5 0.7 0 1.4 0.9 2.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467 630c-1.3 0.8-2 1.6-2.8 1.6-0.5 0-1.1-1-1.7-1.6 0.7-0.6 1.3-1.5 2.1-1.8 0.4-0.2 1.2 0.9 2.4 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.1 579.8c-1.3 0.8-2.1 1.7-2.7 1.6-0.7-0.1-1.7-1.1-1.7-1.8 0-0.5 1.1-1.6 1.7-1.6 0.7-0.1 1.4 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m514.5 620.2c-0.8-1.4-1.7-2.2-1.6-2.8 0.2-0.7 1.2-1.3 1.8-1.9 0.6 0.7 1.6 1.3 1.6 1.9 0.1 0.7-0.9 1.4-1.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.4 674c-1.3 0.8-2.1 1.7-2.7 1.6-0.7-0.1-1.7-1.1-1.7-1.8 0-0.6 1.1-1.6 1.8-1.6 0.6-0.1 1.4 0.8 2.6 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555.1 749.3c-1.4 0.8-2.1 1.7-2.8 1.6-0.6 0-1.7-1.1-1.6-1.6 0.1-0.7 1-1.7 1.7-1.8 0.6-0.1 1.3 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m567.7 661.4c-1.3 0.9-2 1.8-2.6 1.7-0.7-0.1-1.7-1-1.8-1.7-0.1-0.5 1-1.6 1.6-1.7 0.7-0.1 1.5 0.8 2.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m439.1 646.1c0.9 1.4 1.7 2.1 1.7 2.8 0 0.5-1 1.7-1.4 1.6-0.8-0.1-1.8-0.9-2-1.6-0.1-0.6 0.8-1.4 1.7-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.3 780.7c-1.2 0.9-2 1.9-2.4 1.7-0.8-0.2-1.4-1.2-2.1-1.8 0.6-0.6 1.2-1.6 1.8-1.6 0.7 0.1 1.4 0.9 2.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.2 601.4c-0.8-1.5-1.6-2.3-1.5-3 0-0.5 1.2-1.6 1.6-1.5 0.7 0.2 1.6 1.1 1.7 1.7 0.1 0.7-0.8 1.4-1.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m449.1 610.9c1.3-0.8 2.2-1.7 2.8-1.6 0.6 0.2 1.6 1.2 1.6 1.9-0.1 0.6-1.2 1.5-1.8 1.6-0.7 0-1.4-0.9-2.6-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.5 751.9c-1-1.2-1.9-1.8-1.8-2.4 0.1-0.7 0.9-1.4 1.4-2 0.7 0.5 1.7 1 1.9 1.6 0.1 0.7-0.8 1.5-1.5 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m548.7 812.3c-1.3 0.7-2.1 1.6-2.6 1.4-0.7-0.2-1.2-1.1-1.9-1.7 0.7-0.6 1.3-1.6 2-1.6 0.6 0 1.3 0.9 2.5 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.1 588.8c-0.8-1.4-1.6-2.3-1.5-2.9 0.2-0.7 1.2-1.5 1.9-1.6 0.4-0.1 1.5 1.1 1.5 1.7-0.1 0.7-0.9 1.4-1.9 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m602.7 652.5c0.9 1.1 1.8 1.8 1.7 2.3-0.1 0.8-1 1.4-1.5 2-0.7-0.5-1.8-1-1.9-1.7-0.1-0.6 0.8-1.4 1.7-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m476.7 589.5c1 1.3 2 2 1.9 2.7 0 0.7-1 1.3-1.6 1.9-0.6-0.5-1.6-1-1.7-1.6-0.1-0.7 0.7-1.5 1.4-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m565.1 759.1c0.8 1.4 1.6 2.1 1.6 2.8 0 0.6-1.1 1.7-1.5 1.6-0.8-0.2-1.8-1-1.9-1.7-0.1-0.6 0.9-1.4 1.8-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.4 661.2c-1.4 1-2.2 1.9-2.8 1.8-0.7-0.1-1.3-1.1-1.9-1.7 0.6-0.6 1.2-1.5 1.8-1.6 0.7 0 1.5 0.7 2.9 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.7 648.9c-1.4 0.8-2.2 1.8-2.8 1.6-0.7-0.1-1.5-1.2-1.6-1.9 0-0.5 1.1-1.5 1.7-1.5 0.7 0 1.4 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404.2 617.2c-1.4 0.9-2 1.8-2.7 1.8-0.6 0-1.8-1.1-1.8-1.4 0.2-0.8 0.9-1.8 1.6-2 0.6-0.1 1.5 0.8 2.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m464.2 620.9c1 1.3 2 2 1.9 2.6-0.1 0.7-1.1 1.6-1.8 1.8-0.5 0.1-1.6-1-1.6-1.6-0.1-0.7 0.7-1.4 1.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.4 724.4c-1.4 0.7-2.3 1.6-2.9 1.4-0.7-0.1-1.4-1.2-1.5-1.9-0.1-0.4 1.1-1.4 1.7-1.4 0.7 0.1 1.4 0.9 2.7 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.4 621c0.9 1.3 1.7 2 1.7 2.7 0.1 0.5-1 1.6-1.5 1.6-0.7-0.1-1.8-0.9-1.9-1.5 0-0.7 0.8-1.5 1.7-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m445.5 582.4c-0.9-1.3-1.8-2-1.8-2.8 0-0.5 1.1-1.7 1.5-1.6 0.8 0.1 1.8 1 1.9 1.6 0.1 0.6-0.8 1.4-1.6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m574.1 711.5c-1.3 0.9-2 1.8-2.7 1.8-0.6 0-1.8-1-1.7-1.5 0-0.7 0.8-1.8 1.5-1.9 0.6-0.1 1.5 0.7 2.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m492.1 617.5c-1.3 0.8-2.1 1.7-2.7 1.6-0.7-0.2-1.7-1.3-1.6-1.9 0-0.6 1.1-1.6 1.8-1.6 0.6 0 1.3 1 2.5 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m483.3 639.9c0.8 1.3 1.7 2 1.7 2.7-0.2 0.6-1.2 1.1-1.8 1.7-0.6-0.6-1.4-1.3-1.6-2 0-0.5 0.8-1.2 1.7-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m498.5 654.9c-1.3 1-1.9 1.9-2.5 1.8-0.7-0.1-1.3-1-2-1.5 0.5-0.6 1-1.7 1.6-1.7 0.7-0.1 1.5 0.6 2.9 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m388.7 670.4c-0.8-1.5-1.6-2.3-1.5-3 0-0.6 1-1.1 1.6-1.7 0.6 0.7 1.6 1.2 1.7 1.9 0.1 0.7-0.9 1.4-1.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m464.3 663.9c-0.8-1.2-1.7-1.9-1.6-2.6 0.1-0.6 1.1-1.1 1.8-1.7 0.6 0.7 1.4 1.3 1.6 2 0.1 0.5-0.9 1.2-1.8 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m564.9 795.9c-0.8-1.3-1.6-2-1.6-2.7 0-0.6 1.3-1.6 1.6-1.5 0.8 0.2 1.6 1.1 1.8 1.8 0.1 0.5-0.9 1.2-1.8 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.4 759.2c0.9 1.2 1.8 1.9 1.7 2.5-0.1 0.7-1 1.3-1.6 1.9-0.6-0.5-1.6-1-1.6-1.6-0.1-0.7 0.7-1.5 1.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.5 711.6c-1.4 0.9-2.1 1.7-2.8 1.7-0.6 0-1.6-1.1-1.6-1.6 0-0.6 0.9-1.7 1.5-1.7 0.7-0.1 1.5 0.7 2.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m564.8 739.4c-0.8-1.3-1.6-2.1-1.5-2.8 0.1-0.6 1.2-1.5 1.7-1.4 0.7 0.1 1.7 1 1.7 1.6 0 0.7-0.9 1.3-1.9 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555 774.6c-1.3 0.7-2.1 1.5-2.8 1.5-0.5 0-1.5-1.3-1.4-1.7 0.2-0.7 1.1-1.5 1.9-1.6 0.5-0.1 1.2 0.8 2.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m464.3 764.4c-0.8-1.3-1.6-2-1.6-2.7 0-0.6 1.2-1.6 1.6-1.5 0.8 0.2 1.6 1 1.8 1.7 0.1 0.6-0.9 1.3-1.8 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m523.7 667.6c-1.3 1-2.1 1.9-2.7 1.8-0.7-0.1-1.5-1-1.7-1.8-0.1-0.4 1-1.5 1.5-1.6 0.7 0 1.5 0.8 2.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.9 620.9c0.8 1.4 1.7 2.2 1.5 2.9-0.1 0.6-1.1 1.4-1.8 1.5-0.5 0-1.5-1.1-1.5-1.7 0-0.7 0.9-1.4 1.8-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.7 664.1c-0.9-1.4-1.8-2.2-1.7-2.8 0.1-0.6 1.1-1.5 1.8-1.6 0.5-0.1 1.6 1 1.6 1.6 0 0.7-0.8 1.4-1.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.4 648.9c-1.4 0.9-2.2 1.7-2.8 1.6-0.7-0.2-1.5-1.2-1.6-1.9 0-0.5 1.1-1.5 1.7-1.5 0.7 0 1.4 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599.1 667.7c-1.4 0.9-2.2 1.8-2.8 1.7-0.6-0.2-1.4-1.2-1.5-1.9-0.1-0.5 1-1.5 1.6-1.5 0.7 0 1.4 0.8 2.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.7 579.7c-1.4 0.9-2.1 1.8-2.8 1.7-0.6-0.1-1.5-1.1-1.6-1.8-0.1-0.5 1-1.6 1.6-1.6 0.7 0 1.4 0.8 2.8 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m489.5 652.5c0.8 1.2 1.7 1.9 1.6 2.5-0.1 0.7-1 1.5-1.7 1.7-0.4 0.1-1.6-1-1.6-1.5 0-0.7 0.8-1.5 1.7-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.3 721.8c0.9 1 1.9 1.7 1.8 2.2-0.1 0.7-1 1.3-1.6 1.9-0.6-0.6-1.6-1.1-1.8-1.8-0.1-0.5 0.9-1.3 1.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m353.8 724.1c-1.3 0.9-2.1 1.8-2.8 1.8-0.5 0-1.5-1-1.6-1.6 0-0.6 0.9-1.7 1.5-1.7 0.7-0.1 1.5 0.7 2.9 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m467.1 592.4c-1.4 0.9-2.2 1.7-2.9 1.6-0.6-0.2-1.4-1.2-1.5-1.9-0.1-0.5 1.1-1.5 1.7-1.5 0.7 0 1.4 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m508.4 595c-0.9-1.3-1.7-2-1.7-2.7 0-0.7 1.1-1.8 1.5-1.7 0.7 0.1 1.7 1 1.8 1.6 0.2 0.7-0.7 1.5-1.6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m514.8 595c-0.9-1.3-1.9-2.1-1.8-2.7 0.1-0.7 1.1-1.6 1.8-1.7 0.5-0.1 1.6 1 1.6 1.6 0 0.7-0.8 1.5-1.6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m351.2 651.5c-0.9-1.3-1.9-2.1-1.8-2.7 0.1-0.6 1.1-1.5 1.8-1.6 0.5-0.1 1.6 0.9 1.6 1.5 0 0.7-0.8 1.5-1.6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.4 592.5c-1.3 0.8-2.1 1.7-2.7 1.5-0.6-0.1-1.4-1.2-1.4-1.9 0-0.5 1.1-1.6 1.6-1.6 0.7 0.1 1.3 1 2.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m554.8 812.1c-1.1 0.8-1.8 1.7-2.3 1.6-0.7-0.2-1.3-1.1-1.9-1.7 0.7-0.6 1.3-1.5 2-1.6 0.5-0.1 1.2 0.9 2.2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m510.8 831.1c-1.1 0.7-1.8 1.7-2.4 1.5-0.7-0.1-1.2-1.1-1.8-1.7 0.6-0.6 1.3-1.5 2-1.6 0.5-0.1 1.2 0.9 2.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.3 642.4c-1.3 1-2 1.8-2.7 1.8-0.6 0-1.7-1-1.6-1.5 0.1-0.7 0.9-1.8 1.5-1.9 0.6-0.1 1.4 0.8 2.8 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m499.6 642.5c1-0.8 1.7-1.8 2.3-1.7 0.7 0.1 1.3 1.1 1.9 1.7-0.6 0.6-1.1 1.5-1.9 1.7-0.5 0.1-1.2-0.9-2.3-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.4 620c-0.8-1.3-1.7-2.1-1.6-2.7 0.1-0.7 1.2-1.2 1.9-1.8 0.5 0.7 1.3 1.3 1.4 2.1 0.1 0.5-0.8 1.2-1.7 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.3 642.5c-1.2 0.8-1.9 1.7-2.6 1.7-0.6-0.1-1.7-1.3-1.6-1.7 0.2-0.7 1-1.5 1.8-1.7 0.5-0.1 1.2 0.9 2.4 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m441.6 642.6c-1.1 0.8-1.8 1.7-2.3 1.6-0.7-0.2-1.3-1.1-1.9-1.7 0.7-0.6 1.3-1.5 2-1.7 0.5-0.1 1.2 0.9 2.2 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m479.3 617.5c-1.1 0.8-2.1 1.8-2.3 1.7-0.8-0.5-1.5-1.3-1.7-2.1-0.1-0.4 1.1-1.6 1.6-1.5 0.7 0.1 1.3 1 2.4 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m546.2 632.7c-1-1.4-1.9-2.2-1.8-2.8 0.1-0.7 1.1-1.2 1.8-1.8 0.5 0.6 1.5 1.1 1.5 1.7 0.1 0.7-0.7 1.5-1.5 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m586.6 811.9c-1.3 0.9-2 1.8-2.7 1.8-0.5 0.1-1.7-1.1-1.6-1.5 0.2-0.7 1-1.6 1.7-1.8 0.5-0.2 1.3 0.7 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m445.5 627.2c0.9 1.4 1.7 2.3 1.6 2.9-0.1 0.6-1.1 1.4-1.9 1.5-0.4 0.1-1.4-1.1-1.4-1.6 0-0.7 0.8-1.4 1.7-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m580.4 636.2c-1.4 0.9-2.1 1.7-2.8 1.7-0.6 0-1.7-1-1.7-1.5 0.2-0.7 1-1.7 1.6-1.9 0.7-0.1 1.5 0.8 2.9 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.8 636.1c-1.3 0.9-2.1 1.8-2.7 1.8-0.6-0.1-1.5-1.1-1.7-1.8-0.1-0.4 1-1.6 1.5-1.6 0.7-0.1 1.5 0.7 2.9 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.7 638.8c-1-1.2-2-1.9-1.9-2.4 0.1-0.7 1-1.4 1.5-2 0.7 0.5 1.7 1 1.8 1.6 0 0.7-0.7 1.5-1.4 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m548.7 623.6c-1.2 0.8-1.9 1.8-2.4 1.7-0.7-0.1-1.3-1-2-1.6 0.6-0.6 1.1-1.7 1.7-1.8 0.7-0.1 1.4 0.8 2.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m605.4 818.3c-1.3 0.9-2.1 1.7-2.8 1.7-0.6 0-1.7-1.1-1.6-1.5 0.1-0.7 1-1.7 1.6-1.8 0.7-0.1 1.4 0.8 2.8 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m552.4 765.5c0.9 1.3 1.8 2 1.6 2.6-0.1 0.7-1.1 1.2-1.7 1.8-0.5-0.6-1.5-1.1-1.5-1.7 0-0.7 0.8-1.4 1.6-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.4 665c1 1.3 2 2 1.9 2.6 0 0.7-1 1.5-1.7 1.7-0.5 0.1-1.6-0.9-1.7-1.5 0-0.7 0.7-1.4 1.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.2 774.4c-1.1 0.8-1.7 1.7-2.3 1.6-0.7 0-1.3-0.9-1.9-1.4 0.6-0.6 1.1-1.6 1.8-1.8 0.5-0.2 1.3 0.8 2.4 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.5 682.7c-0.9-1.3-1.7-2-1.7-2.7 0-0.5 1.2-1.6 1.6-1.5 0.7 0.2 1.6 1 1.7 1.8 0.2 0.4-0.8 1.2-1.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m555 674.2c-1.3 0.8-2 1.5-2.7 1.5-0.6-0.1-1.6-1.2-1.5-1.7 0.1-0.7 1-1.7 1.7-1.8 0.6 0 1.3 1 2.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599 755.4c-1.2 1-1.9 1.9-2.4 1.8-0.7-0.2-1.6-1-1.8-1.7-0.2-0.3 0.9-1.6 1.5-1.6 0.7-0.1 1.4 0.7 2.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m376.1 778.2c0.8 1.1 1.7 1.8 1.7 2.4-0.1 0.6-0.9 1.2-1.4 1.9-0.7-0.6-1.7-1.1-1.9-1.9-0.2-0.4 0.8-1.2 1.6-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m401.5 783.3c-0.9-1.2-1.7-1.9-1.7-2.6-0.1-0.6 0.9-1.1 1.5-1.7 0.6 0.6 1.6 1.1 1.7 1.8 0.2 0.5-0.7 1.3-1.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m460.6 780.8c-1.2 0.8-2 1.7-2.5 1.6-0.7-0.2-1.5-1.1-1.6-1.8-0.1-0.4 1-1.5 1.6-1.5 0.7 0 1.3 0.9 2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.8 753c0.9 1.2 1.8 1.8 1.8 2.5 0.1 0.6-1 1.7-1.5 1.7-0.7-0.2-1.6-1-1.8-1.7-0.2-0.5 0.7-1.3 1.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.4 661.4c-1.3 0.8-2 1.7-2.7 1.6-0.6 0-1.7-1.2-1.6-1.6 0.2-0.7 1.1-1.6 1.8-1.7 0.5-0.1 1.3 0.8 2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.1 787c-1.1 0.8-1.8 1.7-2.6 1.7-0.5 0-1.6-1.1-1.5-1.5 0.1-0.8 0.9-1.7 1.6-1.8 0.6-0.2 1.3 0.7 2.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m470.6 758.2c-0.8-1.3-1.7-2-1.6-2.6 0.2-0.7 1.1-1.2 1.7-1.8 0.6 0.6 1.6 1.1 1.6 1.7 0 0.7-0.9 1.4-1.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m422.9 755.5c-1.2 0.8-1.9 1.8-2.4 1.7-0.7-0.2-1.5-1-1.8-1.7-0.1-0.3 0.9-1.6 1.5-1.6 0.7 0 1.4 0.8 2.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m389 753c0.7 1.3 1.5 2 1.5 2.7-0.1 0.6-1.3 1.6-1.6 1.5-0.7-0.3-1.6-1.1-1.7-1.8-0.1-0.5 0.9-1.2 1.8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m366.2 711.5c-1.1 0.9-1.8 1.9-2.3 1.8-0.7-0.2-1.6-1-1.8-1.7-0.1-0.4 0.9-1.6 1.5-1.7 0.7 0 1.4 0.8 2.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404 692.8c-1.3 0.8-2 1.6-2.7 1.5-0.6 0-1.1-1-1.6-1.6 0.6-0.6 1.2-1.5 1.9-1.6 0.5-0.1 1.2 0.8 2.4 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m511 805.6c-1.2 0.9-2 1.8-2.5 1.7-0.7-0.1-1.3-1-1.9-1.6 0.5-0.6 1-1.5 1.6-1.6 0.7 0 1.5 0.7 2.8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.1 746.7c0.8 1.2 1.7 1.9 1.7 2.6 0 0.5-1.1 1.7-1.5 1.6-0.7-0.2-1.6-1-1.8-1.7-0.1-0.5 0.8-1.3 1.6-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m529.9 692.7c-1.3 0.8-1.9 1.7-2.6 1.7-0.6 0-1.8-1.1-1.7-1.5 0.2-0.7 1-1.6 1.7-1.8 0.5-0.2 1.3 0.7 2.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m529.9 711.5c-1.2 0.9-2 1.8-2.5 1.7-0.7-0.1-1.5-1-1.7-1.7-0.2-0.4 0.9-1.6 1.5-1.6 0.7 0 1.4 0.8 2.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m378.6 699.1c-1.1 0.8-1.8 1.7-2.3 1.6-0.7-0.2-1.3-1.1-1.9-1.7 0.7-0.6 1.3-1.4 2-1.6 0.5-0.1 1.2 0.9 2.2 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m464.3 814.5c-0.8-1.2-1.6-1.9-1.6-2.5 0.1-0.6 1.1-1.1 1.6-1.7 0.6 0.6 1.6 1.2 1.7 1.9 0.1 0.5-0.9 1.2-1.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m592.8 761.9c-1.4 0.8-2.1 1.6-2.8 1.6-0.6-0.1-1.4-1.2-1.4-1.8 0-0.6 1-1.6 1.5-1.6 0.7 0 1.4 0.9 2.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m536.2 812c-1.3 0.9-2 1.7-2.7 1.7-0.5 0-1.6-1.2-1.5-1.6 0.2-0.7 1-1.5 1.7-1.8 0.5-0.1 1.3 0.8 2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m577.7 814.6c-0.8-1.2-1.7-1.9-1.7-2.6 0-0.6 1.2-1.7 1.6-1.6 0.7 0.2 1.6 1 1.8 1.7 0.1 0.5-0.9 1.3-1.7 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m546.3 582.5c-1-1.4-1.8-2-1.9-2.8 0-0.6 0.9-1.2 1.4-1.8 0.7 0.5 1.8 1 1.9 1.6 0.2 0.7-0.6 1.5-1.4 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m498.4 592.5c-1.3 0.8-2.1 1.6-2.8 1.5-0.5-0.1-1.5-1.2-1.5-1.7 0.2-0.7 1.1-1.7 1.7-1.7 0.7-0.1 1.4 0.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m451.8 607.4c-0.9-1.2-1.9-1.9-1.7-2.4 0.1-0.7 1-1.6 1.7-1.7 0.5-0.2 1.6 0.9 1.7 1.5 0 0.7-0.9 1.4-1.7 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m445.6 638.7c-0.9-1.1-1.8-1.7-1.8-2.3 0.1-0.7 1-1.4 1.6-2 0.6 0.6 1.5 1.1 1.7 1.8 0.1 0.6-0.8 1.4-1.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m504.6 818.5c-1.3 0.8-2 1.5-2.7 1.5-0.6 0-1.6-1.3-1.5-1.7 0.3-0.7 1.1-1.5 1.9-1.6 0.5-0.1 1.2 0.9 2.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m508.4 602.3c0.8 1.2 1.7 2 1.6 2.7 0 0.5-1.1 1.6-1.6 1.5-0.7-0.2-1.6-1-1.8-1.8-0.1-0.5 0.9-1.2 1.8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m533.4 626.3c-0.8-1.4-1.5-2.2-1.4-2.9 0-0.6 1.2-1.6 1.6-1.5 0.7 0.3 1.6 1.1 1.7 1.8 0.1 0.6-0.9 1.3-1.9 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m476.8 658.7c1 1.3 1.9 2 1.8 2.5-0.2 0.8-1.1 1.3-1.7 2-0.6-0.6-1.5-1.1-1.6-1.7 0-0.7 0.8-1.5 1.5-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m388.9 632.3c-0.9-1-1.9-1.7-1.8-2.2 0.2-0.7 1.1-1.3 1.7-1.9 0.6 0.6 1.5 1.2 1.7 1.9 0.1 0.5-0.8 1.2-1.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m382.4 764.2c-0.8-1.1-1.7-1.9-1.5-2.4 0.2-0.7 1.2-1.2 1.8-1.7 0.5 0.6 1.4 1.2 1.4 1.8 0 0.6-0.9 1.3-1.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m398.7 686.5c1.4-0.9 2.1-1.8 2.8-1.8 0.5 0.1 1.5 1.1 1.5 1.6 0.1 0.6-0.9 1.7-1.4 1.7-0.7 0.1-1.5-0.7-2.9-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m382.7 682.6c-0.9-1.1-2-1.8-1.9-2.3 0.2-0.7 1.1-1.3 1.7-1.9 0.6 0.6 1.5 1.1 1.6 1.7 0.1 0.6-0.7 1.3-1.4 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m376.3 633.6c0.8 1.3 1.6 2 1.5 2.6-0.2 0.7-1.1 1.2-1.7 1.8-0.6-0.6-1.6-1.2-1.6-1.8 0-0.7 0.9-1.4 1.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m545.9 701.7c-0.8-1.4-1.6-2.1-1.5-2.7 0.2-0.7 1.2-1.2 1.8-1.8 0.5 0.6 1.5 1.2 1.5 1.8 0 0.7-0.9 1.4-1.8 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.8 690.3c0.8 1.1 1.7 1.7 1.6 2.3 0 0.7-1 1.2-1.5 1.8-0.6-0.5-1.6-1.1-1.8-1.8-0.1-0.4 0.8-1.2 1.7-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m433 815.9c0.7 1.1 1.5 1.9 1.4 2.5-0.1 0.6-1 1.1-1.6 1.7-0.6-0.6-1.5-1.2-1.6-1.9-0.1-0.6 0.9-1.2 1.8-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m498.4 818.3c-1.3 0.9-2 1.7-2.7 1.7-0.6 0-1.5-1.1-1.5-1.6 0-0.6 0.9-1.7 1.4-1.7 0.7-0.1 1.4 0.7 2.8 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m382.5 778.2c0.8 1.1 1.7 1.8 1.6 2.4 0 0.6-0.9 1.2-1.4 1.8-0.7-0.5-1.6-1.1-1.8-1.8-0.2-0.4 0.8-1.2 1.6-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m376.2 720.3c-0.8-1.1-1.8-1.9-1.7-2.4 0.2-0.7 1.2-1.2 1.9-1.8 0.5 0.7 1.4 1.3 1.4 1.9 0 0.6-0.8 1.3-1.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m441.6 768c-1.1 0.8-1.7 1.8-2.3 1.7-0.6 0-1.3-0.9-1.9-1.4 0.6-0.7 1-1.6 1.8-1.9 0.4-0.1 1.2 0.8 2.4 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429.1 655c-1.2 0.9-1.9 1.8-2.4 1.7-0.7-0.1-1.6-0.9-1.8-1.6-0.1-0.4 0.9-1.6 1.5-1.6 0.7-0.1 1.4 0.7 2.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m388.6 640c0.9 1.1 1.9 1.8 1.8 2.3-0.1 0.7-1 1.3-1.6 2-0.6-0.6-1.5-1.1-1.6-1.8-0.1-0.6 0.7-1.3 1.4-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m435.3 699c-1.1 0.8-1.7 1.8-2.2 1.7-0.8-0.1-1.4-1-2-1.5 0.6-0.7 1.1-1.6 1.8-1.8 0.5-0.1 1.3 0.8 2.4 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m495.8 814.5c-0.8-1-1.8-1.8-1.7-2.2 0.2-0.8 1.1-1.4 1.7-2 0.6 0.6 1.5 1.2 1.6 1.9 0.1 0.5-0.8 1.2-1.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m527.3 651.4c-0.8-1.2-1.7-2-1.6-2.7 0-0.6 1-1.1 1.6-1.7 0.6 0.6 1.5 1.2 1.7 1.9 0.1 0.5-0.8 1.3-1.7 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m546 664.1c-0.7-1.3-1.5-2.1-1.4-2.7 0.2-0.7 1.1-1.2 1.7-1.8 0.5 0.6 1.4 1.2 1.4 1.7 0 0.8-0.8 1.5-1.7 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m599 793.3c-1.2 0.9-1.9 1.7-2.6 1.7-0.6 0-1.7-1.2-1.6-1.6 0.2-0.7 1-1.5 1.7-1.7 0.5-0.1 1.3 0.8 2.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m523.6 705.4c-1.3 0.8-2 1.6-2.7 1.6-0.6 0-1.1-1.1-1.7-1.7 0.6-0.5 1.2-1.4 1.9-1.6 0.6-0.1 1.3 0.8 2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m385 768.2c-1.2 0.8-1.9 1.6-2.5 1.5-0.6-0.1-1.2-1-1.7-1.5 0.6-0.6 1.2-1.5 1.9-1.7 0.5-0.1 1.2 0.9 2.3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m435.3 717.8c-1.1 0.8-1.8 1.8-2.3 1.7-0.7-0.2-1.3-1.1-2-1.7 0.7-0.5 1.2-1.4 2-1.6 0.5-0.1 1.2 0.8 2.3 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m432.8 751.7c-0.8-1.1-1.7-2-1.6-2.4 0.2-0.7 1.2-1.2 1.9-1.8 0.5 0.6 1.3 1.3 1.4 1.9 0 0.6-0.9 1.2-1.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m357.4 690.2c0.8 1.2 1.7 1.9 1.7 2.6 0 0.6-1.1 1.6-1.6 1.6-0.7-0.2-1.6-1-1.7-1.7-0.2-0.5 0.8-1.3 1.6-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m561.3 717.7c-1.2 1-1.9 1.9-2.4 1.8-0.8-0.1-1.4-1-2-1.6 0.5-0.6 1-1.6 1.6-1.7 0.7 0 1.5 0.8 2.8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.2 665.1c0.8 1.2 1.7 1.9 1.6 2.5-0.1 0.6-1 1.5-1.7 1.5-0.5 0.1-1.7-0.9-1.7-1.4 0.1-0.7 0.9-1.4 1.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m395.1 709.2c0.8 1.1 1.8 1.8 1.7 2.3-0.2 0.7-1.2 1.5-1.9 1.6-0.4 0.1-1.5-1-1.5-1.6 0-0.6 0.9-1.3 1.7-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m360 673.8c-1.3 0.8-1.9 1.6-2.5 1.6-0.7 0-1.3-0.9-1.9-1.4 0.5-0.6 1-1.7 1.6-1.7 0.7-0.1 1.5 0.7 2.8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m472.9 787c-1.1 0.9-1.9 1.8-2.2 1.7-0.7-0.3-1.5-1.1-1.7-1.8 0-0.5 1-1.5 1.6-1.5 0.6-0.1 1.3 0.8 2.3 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m428.9 787c-1 0.8-1.8 1.8-2.3 1.7-0.7-0.2-1.2-1.2-1.8-1.8 0.6-0.6 1.2-1.5 1.8-1.5 0.6-0.1 1.3 0.8 2.3 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m351.1 745.3c-0.8-1.1-1.8-1.9-1.6-2.3 0.2-0.7 1.1-1.2 1.8-1.8 0.5 0.6 1.4 1.2 1.5 1.8 0 0.6-0.9 1.2-1.7 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m545.9 670.2c-0.7-1.3-1.5-2.1-1.4-2.8 0-0.5 1.3-1.5 1.7-1.4 0.7 0.3 1.4 1.1 1.5 1.9 0.1 0.5-0.9 1.2-1.8 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.2 830.8c-1 0.9-1.7 1.9-2.2 1.8-0.7-0.2-1.5-1.1-1.7-1.8-0.1-0.4 1-1.5 1.6-1.5 0.6-0.1 1.2 0.7 2.3 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.3 793.5c-1.2 0.7-2.1 1.6-2.6 1.4-0.7-0.2-1.1-1.2-1.7-1.9 0.7-0.5 1.3-1.3 2-1.3 0.6 0 1.2 0.9 2.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m372.4 717.9c-1.1 0.8-1.9 1.8-2.3 1.6-0.7-0.2-1.5-1.1-1.7-1.8-0.1-0.4 1-1.4 1.7-1.4 0.6-0.1 1.2 0.8 2.3 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m590.2 664c-0.8-1.2-1.7-2-1.6-2.5 0.1-0.7 1-1.3 1.6-1.9 0.5 0.5 1.5 1.1 1.5 1.6 0.1 0.7-0.7 1.5-1.5 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.5 676.4c-0.9-1.2-1.8-1.8-1.8-2.4 0-0.6 0.9-1.2 1.4-1.9 0.7 0.6 1.6 1.1 1.9 1.8 0.1 0.4-0.7 1.3-1.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m404 736.8c-1.3 0.8-2 1.5-2.6 1.5-0.7-0.1-1.2-1-1.7-1.6 0.6-0.5 1.1-1.5 1.8-1.5 0.6-0.1 1.3 0.8 2.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m548.7 604.9c-1.3 0.8-2 1.6-2.7 1.6-0.5 0-1.4-1.1-1.4-1.7 0-0.6 1-1.5 1.6-1.6 0.6 0 1.3 0.8 2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m429 736.8c-1.1 0.8-1.9 1.8-2.4 1.6-0.7-0.2-1.2-1.1-1.8-1.7 0.6-0.6 1.1-1.4 1.8-1.5 0.6-0.1 1.3 0.8 2.4 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m432.8 670.2c-0.8-1.3-1.6-2.1-1.6-2.8 0-0.5 1.2-1.4 1.8-1.4 0.6 0.1 1.4 1.1 1.5 1.8 0 0.6-0.9 1.2-1.7 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m363.4 682.6c-0.7-1.2-1.5-2-1.3-2.5 0.1-0.6 1.2-1.4 1.8-1.4 0.5 0 1.5 1.1 1.4 1.6 0 0.7-0.9 1.2-1.9 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m542.2 786.9c-1 0.9-1.7 1.9-2.2 1.8-0.7-0.2-1.5-1-1.7-1.7-0.1-0.5 1-1.6 1.6-1.6 0.5-0.1 1.2 0.7 2.3 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m504.6 812.1c-1.2 0.8-1.9 1.6-2.5 1.6-0.6-0.1-1.5-1-1.6-1.6 0-0.6 0.9-1.7 1.4-1.7 0.7 0 1.4 0.8 2.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m366 699.1c-1.1 0.8-1.8 1.7-2.4 1.6-0.6-0.1-1.5-1.1-1.5-1.7 0-0.6 0.9-1.5 1.6-1.6 0.5-0.1 1.2 0.9 2.3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m483.1 795.6c-0.8-1.1-1.7-1.9-1.6-2.3 0.3-0.7 1.2-1.5 1.9-1.6 0.4-0.1 1.4 1 1.5 1.7 0 0.5-0.9 1.2-1.8 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m558.5 808.2c-0.7-1.2-1.6-1.9-1.5-2.5 0.1-0.6 1.2-1.4 1.8-1.4 0.6 0 1.5 1 1.5 1.6 0 0.6-0.9 1.2-1.8 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m410.3 787.1c-1.3 0.8-2.1 1.5-2.8 1.5-0.5 0-1.4-1.2-1.4-1.7 0.1-0.6 1.1-1.4 1.7-1.5 0.6 0 1.3 0.8 2.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.2 822.1c0.8 1.2 1.6 1.9 1.6 2.5-0.1 0.6-1 1.2-1.5 1.8-0.6-0.6-1.5-1.1-1.6-1.8-0.1-0.6 0.7-1.3 1.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m546.1 758.2c-0.8-1.3-1.6-2-1.6-2.6 0.1-0.7 1-1.2 1.5-1.8 0.6 0.5 1.7 1 1.7 1.5 0 0.7-0.8 1.5-1.6 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m436.7 793.4c1.1-0.9 1.7-1.8 2.3-1.8 0.6 0 1.7 0.9 1.7 1.5 0.1 0.5-0.8 1.5-1.4 1.6-0.6 0.2-1.4-0.6-2.6-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m357.4 726.7c-0.9-1.2-1.7-1.9-1.6-2.5 0.1-0.6 1-1.5 1.6-1.6 0.5 0 1.7 0.9 1.7 1.4-0.1 0.8-0.9 1.5-1.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m422.6 830.8c-1.1 0.9-1.8 1.8-2.3 1.7-0.6 0-1.5-1-1.5-1.6-0.1-0.5 0.8-1.5 1.4-1.6 0.6-0.1 1.3 0.8 2.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m407.8 739.1c-0.8-1.1-1.7-1.8-1.7-2.4 0.1-0.5 1-1.5 1.6-1.5 0.6 0 1.5 0.9 1.7 1.5 0.1 0.6-0.8 1.3-1.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m422.7 611.4c-1.1 0.7-1.9 1.5-2.4 1.4-0.7-0.1-1.2-1.1-1.7-1.7 0.6-0.5 1.2-1.5 1.9-1.6 0.5 0 1.2 1 2.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m388.7 783.1c-0.7-1.2-1.6-1.9-1.5-2.5 0.2-0.6 1.2-1.4 1.8-1.5 0.5 0 1.5 1.1 1.5 1.7-0.1 0.6-0.9 1.2-1.8 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m413.9 833.6c-0.7-1.3-1.5-2.1-1.4-2.7 0.1-0.6 1-1.1 1.6-1.7 0.4 0.6 1.3 1.2 1.3 1.8 0.1 0.6-0.7 1.3-1.5 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m489.7 783.2c-0.9-1.1-1.7-1.7-1.7-2.3 0-0.7 0.9-1.3 1.3-1.9 0.7 0.5 1.6 1 1.8 1.7 0.1 0.5-0.7 1.3-1.4 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m435.3 805.7c-1.2 0.9-1.9 1.7-2.5 1.6-0.6 0-1.1-0.9-1.7-1.5 0.6-0.6 1.1-1.5 1.7-1.6 0.6 0 1.3 0.8 2.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m596.7 802c-0.9-1.2-1.8-1.8-1.8-2.4 0.1-0.6 1-1.2 1.5-1.8 0.6 0.5 1.5 1 1.7 1.6 0.1 0.6-0.7 1.3-1.4 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m414 753c0.8 1.2 1.6 1.9 1.6 2.5-0.1 0.6-1 1.2-1.5 1.8-0.6-0.6-1.5-1.1-1.6-1.8-0.1-0.5 0.7-1.2 1.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m420.3 670.1c-0.8-1.1-1.6-1.8-1.6-2.4 0.1-0.6 1-1.2 1.5-1.7 0.6 0.5 1.5 1 1.6 1.6 0.1 0.6-0.7 1.3-1.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m426.4 822.1c0.9 1.2 1.7 1.9 1.7 2.5-0.1 0.6-1 1.2-1.6 1.8-0.5-0.6-1.4-1.1-1.4-1.6-0.1-0.7 0.6-1.4 1.3-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m495.3 705.2c0 10.1-8.3 18.7-18.3 18.6-10.2 0-18.5-8.4-18.5-18.5 0-10.1 8.2-18.4 18.5-18.5 10-0.1 18.2 8.2 18.3 18.4zm-18.5 11.8c6.6 0 12-5.1 12-11.4 0-6.7-5.1-12-11.8-12-6.7 0-12 5.1-12 11.7 0 6.5 5.2 11.7 11.8 11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m496.5 690.1c-2.4 0-4.5-2.1-4.4-4.5 0-2.3 2-4.2 4.4-4.2 2.5 0 4.4 2 4.4 4.5-0.1 2.4-2 4.3-4.4 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.8 588.7c5.6 0 10 4.4 10 9.8 0 5.3-4.6 9.9-10 9.9-5.5 0-10-4.5-9.9-10.1 0.1-5.4 4.4-9.7 9.9-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m370 588.8c5.6 0 9.9 4.3 9.9 9.9 0 5-4.8 9.7-10 9.7-5.3 0-10-4.8-10-10.2 0-5.2 4.6-9.4 10.1-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m370.3 821.7c-5.4 0.1-10.4-4.5-10.4-9.5 0.1-5.3 4.8-10 10.1-10 5.3 0.1 9.9 4.7 9.9 10 0 4.8-4.8 9.5-9.6 9.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m1036.9 735.8q-0.1 0-0.1 0-0.1 0-0.1-0.1zm0.4 8.4q0.1 0 0.2 0l-0.2 0.1q0 0 0-0.1zm-7.6 1.1c0 3 0 5.7 0 8.5 2.9 0 5.2 0 7.6 0 0 5.7 0 11.3 0 17.5 3.9 0 6.7 0 9.5 0 0 5.7 0 11.4 0 17.3-3.2 0.6-6 1-8.7 1.5 0 5.8 0 11.2 0 16.8 3.3 0.5 6.3 0.9 9.3 1.3-0.4 2.2-0.7 4.3-1.1 7.2-2.3 0.2-4.9 0.5-8.3 0.9-0.1 2.4-0.2 5-0.4 8 3 0.4 5.6 0.7 8.6 1.1 0 2.6 0 5.1 0 8.2-29.2 0-58.4 0-87.9 0-0.3-2.8-0.6-5.4-0.9-8.7-3 0.2-5.7 0.4-8.4 0.6-0.3-3-0.7-5.9-1-9.3-2.6-0.2-5-0.4-7.7-0.7 0-2.6 0-4.9 0-7.7 2.5-0.2 4.9-0.4 7.7-0.6 0-2.8 0-5.4 0-8.5q-3.4-0.4-7.7-1c-0.2-2.5-0.4-4.8-0.7-7.8-2.8 0-5.5 0-8.4 0-0.1 3-0.3 5.6-0.4 8.2-5.7 0-11.4 0-17.3 0 0-2.9 0-5.4 0-8.2 2.4-0.2 4.8-0.5 7.6-0.9 0-2.4 0-5 0-7.9-2.2-0.2-4.6-0.5-7.9-0.8q0.4-4.7 0.7-9.4c2.4 0.1 4.7 0.3 7.4 0.5 0.2-2.9 0.5-5.3 0.7-8 2.9-0.3 5.5-0.5 8.5-0.8 0-5.7 0-11.2 0-17.4-2.6-0.3-5.4-0.6-8.1-0.9-2-4.7-0.1-6.8 4.2-7.8 6.4-1.3 12.4 1.8 14.4 8 2.1 0 4.3 0 7 0-0.5-6.9 4.5-7 9.5-7.5 0 5.3 0 10.6 0 16.4-2.8 0.3-5.5 0.7-8.6 1-0.3 2.8-0.6 5.4-0.8 8.2-2.7 0.2-5.1 0.4-7.8 0.7 0 2.7 0 5 0 7.7 5.7 0 11.2 0 17.2 0 0.2-2.6 0.4-5 0.6-7.6 2.7 0 5 0 7.8 0 0.2 2.5 0.5 4.9 0.8 7.9 3.1 0 5.8 0 8.6 0q0.1 4.7 0.2 9.5-8.6 0-17.2 0c0 3.1 0 5.7 0 8.2 2.9 0.4 5.2 0.7 7.7 1.1 0 6.1 0 11.9 0 17.6q-3.8 0-7.7 0c0 3 0 5.5 0 7.9 2.9 0 5.3 0 7.7 0 0.7 10 0.7 10 9.3 8.4 0-2.7 0-5.6 0-8.4 6.3-0.4 11 1 9.6 8.9 2.9 0 5.2 0 7.7 0 0-14.8 0-29.1 0-43.7-2.9 0-5.3 0-7.8 0q0.1-4.8 0.2-9.5c2.4 0 4.8 0 8 0 0-5.7 0-11.2 0-17.3 9.2 0 17.6 0 26.5 0 0-6.1 0-11.6 0-17.5-2.6 0-5 0-7.8 0-0.4 2.5-0.8 5-1.3 7.9-2.5 0-4.9 0-7.7 0-0.2-2.7-0.4-5.1-0.6-7.8-2.9-0.3-5.5-0.5-8.5-0.7-0.4-5.5-0.8-11-1.2-16.5 3-0.3 6.1-1 9.1-0.9 6.1 0.3 11.5 0.3 9.7-8.7 2.9 0 5.3 0 8.4 0 0 5.6 0 11.2 0 17.2 3.4 0.3 6 0.6 9.1 0.8 0.3 2.7 0.6 5.2 1 8.3 2.4-0.1 4.8-0.2 7.1-0.3q0.3 4.2 0.5 8.4-3.7 0.5-7.6 1.1zm7.6 8.5q0-0.1 0-0.3l0.2 0.3q-0.1 0-0.2 0zm9.5 17.5q0-0.1 0-0.2l0.2 0.2q-0.1 0-0.2 0zm0.6 36.9q0 0 0-0.1l0.1 0.1q-0.1 0-0.1 0zm-98.4 17.3q0 0.1 0 0.2c0 0-0.2-0.2-0.2-0.2q0.1 0 0.2 0zm-18.2-27.4q0.1 0 0.2 0c0 0-0.2 0.1-0.2 0.1q0-0.1 0-0.1zm-16.9-27.2q-0.1-0.1-0.1-0.1c0 0 0.1-0.1 0.1-0.1q0 0.1 0 0.2zm61.4 0.4q0-0.1 0-0.2l0.2 0.2q-0.1 0-0.2 0zm9.7 0q-0.1 0-0.2 0l0.2-0.2q0 0.1 0 0.2zm7.4-51.9q-0.1 0-0.1 0c0 0 0.1 0 0.1 0q0 0 0 0zm-51.4 60.7q0 0 0 0.1 0 0 0.1 0 0-0.1 0-0.1-0.1 0-0.1 0zm-1.4 8.9c3.5 0 6 0 8.4 0 0-3 0-5.5 0-7.9-2.7-0.4-4.8-0.6-6.9-0.9-0.5 2.8-1 5.6-1.5 8.8zm-0.5-17.1c-2.7 0-5.2 0-7.7 0 0 3.1 0 5.7 0 8.9 3.5-0.2 6.6-0.5 9.6-0.7q-0.9-4.1-1.9-8.2zm63.6 17.2c9.2 0 17.6 0 26.1 0 0-8.8 0-17.2 0-25.6-9 0-17.5 0-26.1 0 0 8.8 0 17 0 25.6zm0.1 9.3c0 9 0 17.4 0 25.9 9 0 17.5 0 26.5 0-0.2-3-0.3-5.4-0.4-8.1-3.1-0.2-5.7-0.4-9.2-0.7 0-5.8 0-11.4 0-17.1-6.1 0-11.2 0-16.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m877.6 771.9c0 12.2 0 24 0 35.8 0 7.2-0.1 14.4 0.1 21.5 0 3.3-0.9 5-4.6 5-19-0.2-38-0.1-57.6-0.1 0-20.9 0-41.3 0-62.2 20.3 0 40.6 0 62.1 0zm-53 53c13.9 0 27.5 0.1 41.1-0.1 0.9 0 2.7-1.9 2.7-2.9 0.2-13.5 0.1-27.1 0.1-40.8-15.1 0-29.3 0-43.9 0 0 14.6 0 28.8 0 43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1002.6 674.5c-0.2-2.9-0.3-5.8-0.5-9-2.9-0.4-5.7-0.7-9.1-1.1 0-5.6 0-11.1 0-16.9-3 0-5.3 0-8.4 0 0 8.9 0 17.5 0 26.7-3.6 0-6.4 0-9.3 0l0.2 0.2c-0.2-3-0.4-6-0.6-9-3.1 0-5.6 0-8.3 0-0.3 3.3-0.5 6.2-0.8 9l0.1-0.2c-6.4 1.1-9.1-1.4-8.2-8 0.4-2.8 0.1-5.7 0.1-9.6 5.7 0 11.2 0 17.7 0 0-9.6 0-18.2 0-26.9l-0.2 0.2q5-0.3 10-0.5c-0.2 2.7-0.5 5.5-0.7 8.4 3.2 0 5.5 0 8.1 0 0-2.8 0-5.1 0-7.8-2.7-0.1-5.2-0.3-7.6-0.4 0-8.8 0-17.6 0-26.6 3 0 5.4 0 7.9 0l-0.2-0.2c0.1 2.6 0.3 5.3 0.5 8.5 2.8 0.3 5.6 0.7 9.1 1.1 0 14.5 0 28.9 0 43.9 6 0 11.3 0 16.9 0 0.3 3 0.6 5.3 1 8.6q8.5 0 17.1 0l-0.1-0.2q0 8.9 0 17.7l0.2-0.2c-2.4 0.2-4.8 0.4-7.7 0.7-0.4-2.8-0.7-5.2-1.1-8.6-8.7 0-17.5 0-26.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m815.4 576.6c20.7 0 41 0 61.8 0 0 20.6 0 40.8 0 61.3-20.7 0-41.1 0-61.8 0 0-20.4 0-40.5 0-61.3zm9.1 52.7c15 0 29.2 0 43.5 0 0-14.9 0-29.3 0-43.7-14.8 0-29 0-43.5 0 0 14.7 0 29 0 43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m1073.3 637.9c-21.2 0-41.4 0-62.2 0 0-19.6-0.1-38.8 0.2-58 0-1.3 2.6-3.5 4-3.5 17.8-0.3 35.5-0.3 53.2 0 1.6 0 4.6 2.5 4.6 3.8 0.3 19 0.2 38.1 0.2 57.7zm-9.4-8.5c0-15 0-29.4 0-43.6-14.9 0-29.3 0-43.7 0 0 14.8 0 29 0 43.6 14.7 0 29 0 43.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1063.8 657.4c2.8-0.4 5.6-0.8 9-1.2 0 6.3 0 11.7 0 17.6-2.5 0.2-4.9 0.5-7.8 0.8 0 2.5 0 5 0 7.8 2.4 0.3 4.8 0.5 7.7 0.8 0 8.6 0 17.1 0 26-2.6 0.2-5 0.3-7.9 0.5 0 2.8 0 5.3 0 8.2 2.6 0.3 4.9 0.6 7.9 1 0 8.3 0 16.6 0 25.3-2.6 0.3-5.2 0.7-8 1.1-0.1 2.7-0.3 5.1-0.5 8.1-2.5 0-5 0-7.8 0q0-8.7 0-17.2c0 0-0.2 0.1-0.2 0.1 2.6-0.1 5.3-0.3 7.7-0.4 0-3.1 0-5.6 0-8-2.9-0.4-5.3-0.7-7.5-1 0-8.9 0-17.3 0-25.5 3-0.4 5.3-0.6 7.6-0.9 0-3.1 0-5.7 0-8.5-2.7-0.2-5.1-0.4-8.3-0.7 0-5.8 0-11.2 0-16.6-3.4-0.4-6-0.6-8.7-0.9 0-3.3 0-6.2 0-9.1l-0.2 0.2c5.7 0 11.4 0 17.6 0-0.1-3-0.3-5.3-0.4-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m841.8 691.8c-8.7 0-17.4 0-26.5 0 0-3.2 0-5.6 0-8.4 2.8-0.3 5.6-0.7 8.7-1.1 0-2.6 0-5 0-7.7-2.9-0.2-5.6-0.4-8.6-0.7 0-8.7 0-17.3 0-26.3 2.8 0 5.3 0 8.4 0 0.3 2.6 0.6 5.2 0.9 8.2q3.8 0.5 7.7 1.1l-0.1-0.2c0.4 2.6 0.7 5.2 1.1 7.9 1.6 0.1 3 0.3 4.3 0.3 1.2 0 2.5-0.4 3.9-0.6 0.1-2.8 0.2-5.2 0.3-7.6l-0.1 0.2q5 0.3 10.1 0.5l-0.1-0.1c-0.2 2.3-0.5 4.7-0.8 7.5 9 0 17.2 0 26.1 0 0.2 3.2 0.3 5.9 0.5 9.4-12 0-23.5 0-36 0 0 6.4 0 12.1 0 17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m903.2 613c3-0.5 5.9-0.9 9.8-1.6 0 9.4 0 17.7 0 26.6 3.3 0 5.9 0 8.5 0l-0.2-0.2c0.1 3.8 0.3 7.6 0.3 11.3 0.1 8 1 8.6 9.4 6 0-5.7 0-11.5 0-17.3l-0.2 0.2c2.6 0.1 5.3 0.3 8.4 0.5 0.4 2.6 0.7 5.2 1.2 8.1 2.3 0.3 4.7 0.6 7.6 1 0 7.4 0 14.9 0 22.2-5.5 0.8-10.8 1.7-16.5 2.6-0.3-2.1-0.6-4.4-1-7.3-5.4 0-10.9 0-17.1 0 0-6 0-11.5 0-18-3.7 0-6.8 0-9.8 0l0.2 0.2q-0.3-17.2-0.6-34.3 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m869.2 753.4c2.6 0.2 5.1 0.4 8 0.6 0.3-3.2 0.6-5.8 0.9-8.6 6.3-0.5 12.4-1.1 18.5-1.7-0.6 3.2-1.3 6.4-2 9.8 4 0 6.6 0 9.2 0 0-2.9 0-5.5 0-7.9-2.7-0.7-5-1.2-7.3-1.8-0.6-2.2-1.2-4.5-1.7-6.2 1.3-0.9 1.4-1.1 1.6-1.1 16.6-1.6 16.7-1.4 16.8 15.2 0 6.4 0.3 12.8 0.5 19.2 0 0 0.2-0.2 0.2-0.2-3 0.4-6 0.8-9.4 1.3-0.2 2.8-0.4 5.4-0.7 8.3-2.7 0-5.3 0-8.2 0-0.4-2.6-0.7-5.2-1.1-8.3-2.5-0.3-5-0.7-7.9-1.1-0.2-2.5-0.3-4.9-0.6-7.9-5.7 0-11.2 0-17.6 0 0.4-3.8 0.7-6.8 1-9.8 0 0-0.2 0.2-0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m957.9 620.3c-2.9 0-5.7 0-9.4 0 0 6.1 0 11.6 0 17.4-3.1 0-5.4 0-8.2 0 0-8.3 0-16.5 0-25.2 2.5-0.4 5.1-0.8 7.8-1.2 0-5.8 0-11.3 0-17.2-2.7-0.3-5-0.6-7.8-0.9 0-2.5 0-4.8 0-7.6 2.6-0.2 4.9-0.5 7.7-0.7 0.3-2.8 0.5-5.4 0.9-8.3 8.7 0 17.1 0 26.4 0 0 3.2 0 6 0 8.9l0.2-0.2q-4.4 0-8.9 0c-0.3 3.5-0.5 5.8-0.6 8.2q-3.9 0.3-7.7 0.5c0 3.2 0 5.9 0 8.8 2.9 0 5.3 0 7.7 0 0 2.8 0 5.5 0 8.4-3.1 0.4-5.4 0.7-8.3 1.1 0 2.9 0 5.6 0 8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m914.5 734.5c0.6-2.2 0.8-3.7 1.3-5.1 1.7-5.8 2.3-11.2 0.3-17.5-4.2-12.9 2.1-26.3 14.1-33 11.7-6.5 26.2-4.3 35.8 5.5 8.9 9.1 10.7 23.8 4.2 34.8-7.2 12.1-21.1 18.5-33.9 13.6-7.8-3-13.9 1.1-21.8 1.7zm9.5-9c4.3 0.8 9.2 1.5 13.9 2.6 11.3 2.8 22.6-2 28-12.2 5-9.3 3-21-4.8-28.3-8.1-7.7-20.2-8.8-29.8-2.7-9.2 5.7-13 16.9-9.8 27.6 1.3 4.4 1.7 9.1 2.5 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m913.3 585.5c0-2.9 0-5.7 0-8.9 5.9 0 11.2 0 17.1 0 0 11.4 0 22.8 0 34.6-2.6 0-5.3 0-8.4 0-0.2-2.7-0.5-5.1-0.7-7.9-5.5 0-10.8 0-16.4 0q-0.9 4.8-1.7 9.7 0 0 0 0c-2.4-0.7-4.7-1.3-7.7-2.2 0-5.2 0-10.8 0-16.8 2.7-0.2 5.2-0.4 8.5-0.7q-0.3-3.7-0.6-7.5l-0.1 0.1q5.1-0.3 10.2-0.6c0 2.6 0 5.2 0 8 2.7 0 5.1 0 7.6 0 0-2.8 0-5.3 0-7.8-3 0-5.4 0-7.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m912.6 833.7c-8.8 0-17.2 0-25.9 0 0-2.9 0-5.5 0-8.4 2.7-0.2 5.1-0.5 7.9-0.7 0-2.8 0-5.3 0-8.3-2.6-0.3-5-0.5-7.8-0.7 0-2.4 0-4.8 0-7.6 2.3-0.3 4.6-0.5 7.8-0.9 0.1-2.6 0.3-5.3 0.4-8.4-2.9-0.3-5.3-0.6-8.1-0.9 0-2.5 0-5.1 0-8 5.6 0 11.1 0 17.3 0 0 11.6 0 22.9 0 34.6 3 0.3 5.4 0.6 8.4 1 0 2.4 0 5 0 8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1036.9 735.8c0.3-5.5 0.6-11 1-16.9-3.1-0.3-5.4-0.6-8.2-0.9 0-2.7 0-5.2 0-8.1 2.4-0.3 4.8-0.5 7.8-0.9 0-9 0-17.9 0-26.8 0 0-0.2 0.2-0.2 0.2 3 0.4 6.1 0.7 9.5 1.1 0 14.7 0 28.9 0 43.4 3.2 0.4 5.9 0.8 8.9 1.2 0.2 3 0.3 5.6 0.5 8.2 0 0 0.2-0.1 0.2-0.1q-9.8-0.3-19.6-0.5c-0.1 0 0.1 0.1 0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1002.4 674.3c0 5.6 0 11.1 0 17 2.9 0 5.3 0 8.1 0 0.4-2.5 0.7-5.1 1.1-8 2.5 0 4.9 0 7.8 0 0 5.6 0 11.2 0 17.3-2.6 0.2-5 0.4-7.8 0.7-0.3 2.4-0.6 4.8-1 7.6-2.5 0-5 0-7.9 0-0.2-2.4-0.4-4.8-0.6-7.5-2.9-0.3-5.5-0.5-8.6-0.8 0-8.5 0-16.9 0-26.1q4.5 0 9.1 0c0 0-0.2-0.2-0.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m841.6 692c2.8 0 5.7 0 9.7 0 0 9.1 0 17.9 0 26.8 0 0 0.2-0.2 0.2-0.2-11.9 0-23.7 0-36.1 0 0-3.3 0-5.8 0-9 8.5 0 17 0 26.4 0 0-6.3 0-12 0-17.8 0 0-0.2 0.2-0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1047 771.4c0-2.5 0-4.9 0-7.9 8.5 0 17 0 25.8 0 0 5.7 0 11.1 0 16.9-5.7 0-10.9 0-16.4 0-0.4-2.8-0.7-5.4-1-8.5-3-0.3-5.8-0.5-8.6-0.7 0 0 0.2 0.2 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m859.5 744.2q-4.2 0-8.3 0l0.2 0.2c-0.3-2.6-0.5-5.1-0.8-8.2-3.2 0-6 0-8.8 0l0.2 0.2c0-2.7 0-5.3 0-8.4 2.8-0.3 5.5-0.6 8.7-1 0.2-2.9 0.5-5.6 0.8-8.4 0 0-0.2 0.2-0.2 0.2 2.5-0.1 4.9-0.3 7.7-0.4 0.3 2.9 0.6 5.5 0.8 8.1 3.3 0.8 6.5 1.6 9.6 2.3q-0.3 3.8-0.6 7.5l0.1-0.1c-3 0-6 0-9.1 0-0.2 3.4-0.4 5.8-0.5 8.2 0 0 0.2-0.2 0.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m975.5 771.4q0.1-17.7 0.2-35.4l-0.2 0.2c2.6 0 5.2 0 9.3 0 0 12 0 23.6 0 35.2 0 0 0.1-0.2 0.1-0.2q-4.8 0-9.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m885.8 681.6c0.3-5.3 0.6-10.6 1-16.3 5.6 0 11.1 0 17.1 0 0 5.9 0 11.4 0 16.9 0 0 0.2-0.1 0.2-0.1q-9.2-0.3-18.4-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m885.7 681.6q0.1 5.3 0.3 10.6l0.2-0.2c-8.7 0-17.4 0-26.4 0 0-3.5 0-5.9 0-8.5 8.8-0.6 17.4-1.2 26-1.9 0 0-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1063.9 815.3c0.3 2.8 0.6 5.7 0.9 9.1 2.5 0.3 5.1 0.7 7.6 1 1.8 8.1 1.4 8.7-6.3 8.7-3.1 0-6.2 0-9.7 0 0-6.2 0-11.6 0-17.6q3.9-0.5 7.7-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1047.5 808.3c-0.4-3.1-0.7-6.1-1-9.6 3.2-0.3 5.7-0.6 8.8-0.9 0.3-2.5 0.7-5.1 1.1-7.9 5.5 0 10.8 0 16.4 0 0 2.7 0 5.1 0 8.1-5.4 0-10.7 0-16.4 0-0.4 3.3-0.7 6-1.1 9-2.8 0.4-5.4 0.7-8 1.1 0.1 0 0.2 0.2 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m975.5 629.7c-2.9 0-5.7 0-8.8 0-0.3 2.9-0.5 5.1-0.7 7.9-2.5 0-5 0-8.1 0q0-8.7 0-17.3c0 0-0.2 0.2-0.2 0.2 5.7 0 11.4 0 17.6 0 0 3.7 0 6.6 0 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m869.4 728.8c-0.3-3-0.7-6.1-1.1-9.8 6.1 0 11.5 0 17.5 0 0 5.3 0 10.7 0 16.7-2.4 0-4.9 0-7.7 0-0.3-2.5-0.5-4.8-0.9-8.5-2.8 0.6-5.3 1.1-7.8 1.6q0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m975.3 585.5c2.8-0.2 5.6-0.4 8.8-0.7 0.4-2.8 0.7-5.4 1-8.2 2.5-0.2 4.6-0.3 7.7-0.4 0 6 0 11.6 0 17.3l0.2-0.2q-8.8 0.1-17.7 0.2 0.1-4.1 0.2-8.2c0 0-0.2 0.2-0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m913 681.9c-1 8.8-2 17.5-3.1 27.3-2.1-0.2-4.4-0.3-6.6-0.5l0.1 0.1q0.3-13.3 0.7-26.7c0 0-0.2 0.1-0.2 0.1q4.6 0 9.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m851.2 744.2c0 6 0 11.9 0 18.3-3.4 0-5.9 0-9.2 0q0-9.2 0-18.4c0 0-0.2 0.3-0.2 0.3q4.8 0 9.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m903.3 708.7c0.4 5.9 0.8 11.9 1.2 18.3-3.5 0-6 0-9.1 0 0-5.8 0-11.2 0-17 2.8-0.4 5.4-0.8 8-1.1 0-0.1-0.1-0.2-0.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m931 807.8c0 5.5 0 11 0 16.8-3.4 0-6 0-9 0 0-5.6 0-10.8 0-17 3.2 0.1 6.2 0.3 9.1 0.4 0 0-0.1-0.2-0.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m832.2 736.4q4.9 0 9.8 0c0 0-0.2-0.2-0.2-0.2q0 4.1 0 8.2c0 0 0.2-0.3 0.2-0.3-5.7 0.5-11.8 0.5-8.9 10-3.7-0.4-6.5-0.6-9.2-0.9l0.1 0.2q0.2-4.6 0.4-9.3l-0.2 0.3c2.7 0 5.4 0 8.3 0 0-3.1 0-5.7 0-8.2 0 0-0.3 0.2-0.3 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m992.8 593.5c2.8 0 5.7 0 9 0 0 3.3 0 6 0 9.3q-4.5 0-9 0c0 0 0.2 0.2 0.2 0.2q0-4.8 0-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m823.9 753.2c0.1 2.9 0.3 5.7 0.5 9.2-3.2 0-5.9 0-9.1 0 0-2.6 0-5.1 0-8 3.1-0.3 5.9-0.7 8.7-1 0 0-0.1-0.2-0.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m868.8 744.2q0.2 4.6 0.4 9.2c0 0 0.2-0.2 0.2-0.2-3 0.3-6 0.6-9.9 0.9 0-3.8 0-6.9 0-9.9 0 0-0.2 0.2-0.2 0.2q4.8 0 9.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m832.4 656.9c0.3-2.9 0.5-5.8 0.8-9.1 2.7 0 5.2 0 8.6 0q0 4.5 0 9.1c0 0 0.1-0.2 0.1-0.2q-4.8 0-9.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m975.7 736q-7.3 0-14.7 0-0.2-0.5-0.5-1c4.4-2.8 8.8-5.6 14.4-9.1 0.3 5 0.4 7.7 0.6 10.3 0 0 0.2-0.2 0.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1037.3 744.3c2.8 0.3 5.6 0.6 8.9 1 0 2.7 0 5.2 0 8.3q-4.5 0-9 0c0 0 0.3 0.2 0.3 0.2q0-4.8 0-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m903.4 585.8c-2.5-0.3-5.1-0.7-8-1.1 0-2.7 0-5.2 0-8.1 2.8 0 5.1 0 8.6 0q-0.3 4.6-0.7 9.3c0 0 0.1-0.1 0.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m931.1 808q-0.1-4.9-0.1-9.9c0 0-0.2 0.2-0.2 0.2 2.6 0 5.2 0 8.5 0 0 2.9 0 5.6 0 8.8q-4.2 0.3-8.4 0.7c0.1 0 0.2 0.2 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m903.6 647.1c0.2 2.8 0.4 5.6 0.5 8.3-9.2 2.1-10.4 0.8-8.1-8.1 2.6 0 5.2 0 7.8 0 0 0-0.2-0.2-0.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m975.3 674.2q0 6.1 0 12.2-0.9 0.4-1.9 0.7-3.7-6.5-7.5-12.9c0 0-0.1 0.2-0.1 0.2q4.8 0 9.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m868.9 656.5c0-3.4 0-6 0-8.9 2.8 0 5.4 0 8.3 0 0 2.8 0 5.4 0 8.4-2.7 0.2-5.1 0.3-8.3 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m886 692.2c2.6-0.2 5.2-0.4 8.4-0.6 0 3.2 0 5.9 0 9-2.6 0-4.9 0-7.7 0-0.2-3-0.3-5.8-0.5-8.7 0 0.1-0.2 0.3-0.2 0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1064 657.3c-2.3-0.5-4.7-1-7.7-1.6-0.1-2.3-0.3-4.8-0.4-8 2.8 0 5.3 0 8.6 0q-0.3 4.9-0.7 9.7c0 0 0.2-0.1 0.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1037.1 657.1c-2.4-0.4-4.7-0.8-7.5-1.3 0-2.6 0-5.1 0-8.2 2.4 0 4.7 0 8 0q-0.3 4.8-0.7 9.7c0-0.1 0.2-0.2 0.2-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m824.4 744.1c-2.8 0.2-5.6 0.5-9 0.7 0-2.9 0-5.2 0-8.4 2.9 0 6 0 9 0l-0.2-0.2q0 4.1 0 8.2c0 0 0.2-0.3 0.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m985.3 719.2c-0.4 2.4-0.8 4.7-1.3 7.6-2.6 0-5.3 0-8.4 0 0-2.6 0-4.9 0-8.4 3.5 0.4 6.6 0.7 9.8 1 0-0.1-0.1-0.2-0.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m985.4 708.8c2.3 0.4 4.6 0.7 7.7 1.2q-0.4 4.7-0.8 9.5c0 0 0-0.1 0-0.1q-3.5-0.1-7.1-0.2c0.1 0 0.2 0.1 0.2 0.2q0-5.4 0.1-10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m851.9 657.4c-0.3-3-0.7-6.1-1.1-9.8 3-0.2 5.3-0.3 8.2-0.4 0 3.1 0 5.8 0 8.6-2.6 0.5-4.9 1-7.2 1.5 0 0 0.1 0.1 0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m921.5 638c0.1-2.4 0.2-4.8 0.3-7.7 2.9 0 5.6 0 9 0q0 3.8 0 7.7c0 0 0.2-0.2 0.2-0.2q-4.9 0-9.7 0c0 0 0.2 0.2 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1037.4 664.9q-0.1-3.9-0.3-7.8c0 0-0.2 0.1-0.2 0.2 3-0.4 6-0.7 9.4-1 0.2 3.4 0.4 6 0.5 8.6 0 0 0.2-0.2 0.2-0.2q-4.9 0-9.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m948.8 825.6c-0.3 2.6-0.5 5.2-0.8 8.1-2.6 0-5 0-7.7 0 0-2.9 0-5.4 0-8.8 3.1 0.3 5.9 0.6 8.6 0.8 0 0-0.1-0.1-0.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1064.1 815.5c0.2-2.4 0.4-4.8 0.7-7.6 2.6 0 5.2 0 8 0 0 2.5 0 4.8 0 8q-4.4-0.3-8.9-0.6c0 0 0.2 0.2 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m877 709.2c-2.9 0-5.2 0-8 0 0-2.5 0-4.9 0-7.9 2.4-0.1 4.9-0.3 8-0.4 0 2.9 0 5.4 0 8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m824.4 736.4c0-2.7 0-5.3 0-8.4 2.7 0 5.2 0 8.4 0-0.2 2.9-0.4 5.6-0.6 8.4 0 0 0.3-0.2 0.3-0.2q-4.1 0-8.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m894.9 593.3c-3.2 0-5.5 0-8.2 0 0-2.7 0-5 0-7.7 2.6 0 4.9 0 7.9 0 0.1 2.4 0.2 4.7 0.3 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m894.5 620.2c-2.8 0-4.9 0-7.8 0-0.1-2.4-0.3-4.7-0.4-7.7 2.8 0 5.2 0 8.2 0 0 2.3 0 4.7 0 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m894.6 630.3c0 2.7 0 4.8 0 7.4-2.6 0-4.9 0-7.9 0-0.1-2.2-0.3-4.5-0.4-7.4 3 0 5.6 0 8.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m868.8 736.3c2.6 0 5.2 0 8.3 0 0 2.8 0 5.1 0 8.3-2.9-0.1-5.6-0.3-8.3-0.4 0 0 0.1 0.2 0.1 0.2q0-4.1 0-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m913.2 682.1c0-2.4 0-4.8 0-7.5 2.9 0 5.3 0 7.6 0 0.8 6.8-1 8.5-7.8 7.3 0 0 0.2 0.2 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m985.5 708.7c-1.9 0.3-3.8 0.6-6.3 0.9 0-2.9 0-5.2 0-7.5 4.6-0.9 4.6-0.9 6.2 6.7 0 0 0.1-0.1 0.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m975.3 780.6q4.8 0 9.6 0c-0.2 2.6-0.4 5.3-0.7 8.3-2.8 0-5.4 0-8.9 0 0-2.7 0-5.5 0-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m965.8 815.8q0-4.1 0-8.2c2.9 0 5.8 0 9 0 0.3 3 0.5 5.6 0.7 8.2q-4.8 0-9.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1011.5 780.2c0-3 0-5.5 0-8.4 2.8 0 5.1 0 7.9 0 0 2.7 0 5.2 0 8.4-2.3 0-4.8 0-7.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m859.2 789.5c0 9.3 0 17.5 0 26-8.7 0-17.1 0-26.4 0 0-7.7-0.1-15.2 0.2-22.7 0.1-1.2 2.4-3.1 3.8-3.2 7.3-0.3 14.6-0.1 22.4-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m965.8 593.3q4.8 0 9.7 0c-0.2 2.9-0.3 5.8-0.5 9.7-3.1 0-6.2 0-9.2 0q0-4.9 0-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m833.2 620c0-8.8 0-17.2 0-26 8.7 0 16.9 0 25.7 0 0 8.6 0 17.2 0 26-8.5 0-16.9 0-25.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1055.4 620.4c-7.3 0-14.1 0-20.8 0-1.5 0-3 0-5 0 0-9 0-17.4 0-26.3 8.5 0 16.9 0 25.8 0 0 8.6 0 17 0 26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m953.3 718.5c-9.1 0-22.4-11.2-23.2-18.8-0.2-2.3 1.2-4.9 2.5-7.1 0.3-0.6 3.7-0.6 4 0 1.2 2.2 3 5.5 2.1 7.2-2.6 5.2 1.4 6.8 4 9.2 2.6 2.4 5.2 3.8 8.5 0.2 0.8-0.7 4.4 0.7 6.4 1.7 0.7 0.4 1.3 3.2 0.7 3.8-1.7 1.8-4 3.1-5 3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m23.1 739.7c0.8-2.2 2.2-3.4 4.3-3.4 2.2 0 3.7 1.2 4.4 3.3 2.5-5 7.5-3.9 9-0.2 0.6-0.8 1.2-1.8 2.1-2.3 0.9-0.6 2.1-0.8 3.1-0.7 2.1 0.3 3.5 1.9 3.7 4 0.2 2-0.9 3.6-3.1 4.6 1 1 2.2 2.1 3.3 3.2 0.9-2.1 2.6-3.4 5.3-2.9 1.8 0.4 3 1.6 3.3 3.4 0.4 2.6-0.8 4.4-3 5.2q1.7 1.7 3.3 3.3c0.7-1.9 2.1-3.2 4.4-3.1 2.1 0 3.5 1.3 4.2 3.4 2.4-5 7.4-4.2 9.1 0 0.7-2.3 2.3-3.5 4.6-3.4 2 0.1 3.4 1.3 4 3.1q1.6-1.6 3.2-3.3c-2.1-0.9-3.5-2.8-2.8-5.6 0.5-1.7 1.7-2.7 3.4-3 2.6-0.4 4.3 0.9 5.3 3.3 0.9-2.2 2.4-3.5 4.8-3.4 2 0.2 3.2 1.4 4 3.4 1.2-2.5 2.9-3.9 5.7-3.3 1.7 0.5 2.9 1.7 3.2 3.5 0.4 2.6-0.9 4.2-3.3 5.3 2.7 1.3 3.7 3 3.3 5.2-0.3 1.9-1.9 3.3-3.8 3.6-2 0.4-3.6-0.7-4.9-3-1 1-2.1 2.1-3.1 3.2 4.1 1.8 4.1 6.7-0.4 8.8 2.1 0.8 3.4 2.2 3.4 4.4 0 2.2-1.3 3.6-3.1 4.3 1.1 1 2.2 2.1 3.2 3.2 1.7-2.6 3.2-3.4 5.4-2.9 1.7 0.4 3.1 1.9 3.3 3.6 0.3 2.2-0.6 3.6-3.2 5.1 0.7 0.5 1.4 0.8 2 1.4 0.5 0.5 0.8 1.2 1.2 1.8 0.7-0.8 1.3-1.9 2.2-2.4 1-0.5 2.2-0.7 3.3-0.6 1.9 0.3 3.3 2 3.5 3.9 0.2 2-1 3.7-3.1 4.7 1 1 2.1 2.1 3.2 3.2 0.7-1.6 2-3 4.2-3 2.3-0.1 3.6 1.3 4.4 3q1.6-1.6 3.3-3.2c-1.9-0.7-3.2-2.2-3.1-4.4 0-2.1 1.3-3.6 3.1-4.2-0.8-0.8-2-1.5-2.5-2.5-0.5-1-0.6-2.3-0.4-3.4 0.4-2 2.3-3.2 4.3-3.1 2.1 0 3.6 1.3 4.2 3.3 0.6 2.2-0.3 3.8-3.2 5.6 2.1 0.7 3.4 2.2 3.4 4.4 0 2.1-1.3 3.6-3.5 4.3 2.6 1.3 4.1 3 3.2 6-0.5 1.7-2 2.9-3.8 3-2.2 0.1-3.6-0.8-4.8-3.4-0.9 1.9-2.1 3.4-4.5 3.4-2.3 0-3.5-1.4-4.5-3.4-0.8 2.1-2.1 3.4-4.4 3.4-2.2 0-3.5-1.3-4.4-3.4-1.1 2.5-2.8 3.8-5.5 3.3-1.8-0.4-3-1.6-3.3-3.4-0.5-2.6 0.8-4.3 2.9-5.2-1.1-1.1-2.2-2.2-3.2-3.3-0.6 1.9-2.1 3.1-4.3 3.1-2.1 0-3.6-1.2-4.2-3.1-1.1 1.1-2.2 2.2-3.3 3.3 2.2 0.9 3.5 2.6 3 5.3-0.4 1.7-1.9 3.1-3.6 3.3-2.6 0.4-4.2-0.9-5-3-1.1 1.1-2.2 2.2-3.2 3.2 0.7 0.6 1.8 1.3 2.3 2.3 0.5 0.9 0.6 2.3 0.4 3.4-0.4 1.9-2.4 3.2-4.3 3.1-2.1 0-3.8-1.5-4.3-3.8-0.4-2 0.8-3.8 3.1-4.9-1.1-1-2.2-2.1-3.2-3.2-1 2.1-2.7 3.4-5.4 2.9-1.7-0.3-3.1-1.9-3.3-3.6-0.3-2.5 0.9-4.1 3-5-1.1-1.1-2.2-2.1-3.2-3.1-0.5 0.6-1.1 1.6-2 2.2-0.8 0.5-2 0.7-3 0.6-2.2-0.2-3.6-1.9-3.8-4-0.2-1.9 1-3.6 3.1-4.6-1-1-2.1-2.1-3.2-3.2-0.9 2.1-2.7 3.4-5.4 2.9-1.7-0.3-3.1-1.9-3.3-3.6-0.3-2.2 0.5-3.6 3.3-5.2-2.2-0.9-3.5-2.4-3.3-4.8 0.1-2.1 1.4-3.3 3.2-4-4.4-2-4.4-6.9 0-9-2-0.8-3.3-2.2-3.2-4.4 0-1.8 0.8-3 2.2-3.8-1.1-1-2.2-1.9-3-2.7-0.7 1.4-2.2 2.3-4.5 2-1.8-0.3-3.2-1.7-3.6-3.5-0.5-2.1 0.4-3.5 2.9-5.2-1-1.1-2.1-2.1-3.1-3.2-1.8 4.2-6.8 4.2-8.8-0.3-0.8 2.1-2.3 3.4-4.5 3.4-2.2-0.1-3.6-1.4-4.3-3.4-3 4.6-6.5 4.6-8.8 0.3q-1.5 1.5-3.2 3.2c2.2 1 3.6 2.8 2.8 5.7-0.5 1.7-2 2.9-3.8 3-2.2 0.2-3.6-0.8-4.8-3.2-0.4 0.6-0.8 1.4-1.4 2-0.5 0.5-1.3 0.8-1.9 1.3 2.6 1.4 3.5 2.9 3.2 5.2-0.3 1.7-1.7 3.1-3.5 3.6-2.2 0.4-3.5-0.4-5.2-3-1.1 1.1-2.1 2.1-3.1 3.1 3.7 1.7 4.4 6.5 0 8.8 1 1 2 2 3.1 3.1 0.7-1.6 2-3 4.2-3 2.2-0.1 3.6 1.2 4.4 3q1.6-1.6 3.2-3.2c-2.1-1-3.6-2.7-2.8-5.5 0.4-1.8 1.9-3 3.6-3.2 2.3-0.2 3.7 0.7 4.4 2.1 0.9-0.8 2-1.9 2.9-2.7-1.5-0.8-2.5-2.3-2.2-4.6 0.3-1.8 1.7-3.3 3.6-3.6 2.1-0.5 3.6 0.5 5.2 3 0.7-0.8 1.3-1.9 2.3-2.4 0.9-0.5 2.3-0.7 3.4-0.5 2 0.4 3.4 2.4 3.3 4.4-0.2 2.1-1.8 3.9-3.9 4.2-2.1 0.4-3.9-0.8-4.9-3.1-1 1.1-2.1 2.2-3.2 3.3 2 0.9 3.3 2.5 2.9 5.1-0.2 1.7-1.7 3.3-3.3 3.5-2.7 0.5-4.4-0.8-5.3-2.9-1.1 1.1-2.2 2.2-3.2 3.2 2.2 1.1 3.4 2.9 3 4.9-0.3 2.1-1.9 3.6-4 3.8-1.9 0.3-3.6-0.9-4.8-3.3-0.9 1.9-2.3 3.4-4.5 3.3-2.2 0-3.6-1.3-4.5-3.5-0.8 2.3-2.3 3.6-4.5 3.5-2.2 0-3.5-1.3-4.2-3.3-1.9 3-3.5 3.8-5.8 3.2-2-0.6-3.2-2.2-3.2-4.3 0-2.1 1.2-3.6 3.2-4.3 2.3-0.6 3.8 0.2 5.5 2.9 1.1-1 2.2-2.1 3.2-3.1-4.4-2.1-3.9-7 0-8.7-1-1-2.1-2.1-3.2-3.2-0.6 1.7-2 3-4.2 3.1-2.2 0-3.7-1.3-4.4-3.2-1 1.1-2.1 2.2-3.2 3.3 2.7 1.7 3.6 3.2 2.9 5.5-0.6 2.1-2.3 3.3-4.5 3.2-2 0-3.6-1.4-4.1-3.4-0.5-2.2 0.4-3.8 2.9-5.3q-1.5-1.6-3.2-3.2c-0.6 1.7-2 3.1-4.3 3.1-2.2-0.1-3.6-1.3-4.4-3.6-0.9 2.3-2.3 3.6-4.6 3.6-2.1-0.1-3.5-1.3-4.3-3.6-0.8 2.2-2.2 3.5-4.4 3.6-2.2 0-3.6-1.3-4.5-3.6-0.9 2.3-2.4 3.7-4.7 3.6-2-0.1-3.4-1.4-4.1-3.6-1 2.2-2.3 3.6-4.6 3.6-2.2-0.1-3.6-1.4-4.4-3.5-1.3 2.8-3.2 3.9-5.4 3.4-2.1-0.6-3.5-2.4-3.5-4.4 0-2.2 1.6-4 3.8-4.4 2.1-0.4 3.9 0.8 5.1 3.4 0.8-2.1 2.2-3.4 4.5-3.4 2.2 0 3.6 1.4 4.4 3.5 0.8-2.3 2.3-3.5 4.4-3.5 2.2 0 3.7 1.2 4.4 3.3 2.2-4.7 7.2-4.2 8.9-0.3 1-1 2.1-2.1 3-3.1-0.6-0.6-1.8-1.3-2.3-2.4-0.5-1-0.5-2.4-0.3-3.5 0.5-1.9 2.4-3 4.5-2.9 2 0.1 3.5 1.5 4 3.6 0.5 2-0.6 3.7-3 5.1q1.6 1.6 3.2 3.2c0.7-1.7 2.1-3.1 4.4-3 2.2 0 3.6 1.4 4.4 3.5 0.8-2.3 2.3-3.5 4.5-3.5 2.1 0 3.5 1.2 4.2 3.1 1-1.1 2.1-2.2 3.1-3.2-3.9-1.9-4.1-6.8 0.1-8.8-1-1-2.2-2.1-3.2-3.1-1.1 2.2-2.9 3.4-4.9 3-2.1-0.4-3.6-1.9-3.8-4-0.3-1.9 1-3.7 3.5-4.8-2.1-0.8-3.5-2.2-3.5-4.4-0.1-2.2 1.2-3.6 3.1-4.4-1.1-1-2.2-2.1-3.2-3.1-1.9 4.2-7 4-8.7-0.1-1 1.1-2.1 2.1-3.2 3.2 2.1 1 3.6 2.6 2.9 5.5-0.4 1.7-1.9 3-3.6 3.2-2.3 0.3-3.8-0.6-5.1-3.3-1.1 2.4-2.8 3.7-5.4 3.3-1.6-0.3-3.2-1.9-3.4-3.5-0.4-2.3 0.5-3.7 2.9-5.2-1-1-2.1-2.1-3.1-3.1-0.6 0.7-1.2 1.8-2.2 2.3-1 0.5-2.3 0.6-3.4 0.4-2-0.4-3.4-2.4-3.2-4.4 0.1-2.1 1.7-3.8 3.8-4.2 2.1-0.3 3.9 0.9 4.9 3.1 1-1 2.1-2.1 3.2-3.2-1.5-0.8-3-2-3-4.3 0-2.3 1.3-3.6 3.1-4.4-1.1-1-2.2-2.1-3.2-3-0.6 0.6-1.2 1.7-2.2 2.2-1 0.5-2.3 0.6-3.4 0.4-2-0.3-3.3-2.3-3.2-4.2 0-2.2 1.6-4 3.8-4.4 2.1-0.3 3.9 0.9 5 3.3 1.8-2.8 3.3-3.7 5.4-3.2 2 0.5 3.3 1.9 3.5 3.7 0.3 2.3-0.7 3.9-2.2 4.5 0.8 0.8 1.9 1.8 3 2.8 0.4-0.6 0.8-1.1 1.4-1.4 0.9-0.5 2.2-0.7 3.2-0.6 1.8 0.1 3.3 1.7 3.5 3.6 0.4 2.6-1.1 4.1-3 5q1.6 1.5 3.2 3.2c0.6-1.7 2.1-3.1 4.3-3.1 2.2 0 3.6 1.2 4.3 3.1 1.1-1.1 2.2-2.2 3.2-3.2-4.2-1.9-4.2-6.8 0.3-8.8q-4-2-3.2-5.4c0.5-2 2.3-3.5 4.3-3.5 2.2 0 4 1.5 4.4 3.7 0.4 2.1-0.8 4.1-3.5 5.2 2.2 0.8 3.6 2.2 3.6 4.5 0 2.2-1.4 3.6-3.6 4.4 2.3 0.8 3.6 2.2 3.6 4.4 0 2.3-1.3 3.7-3.4 4.4 4.8 2.2 4.2 7.3 0.1 9 0.6 0.4 1.4 0.8 1.9 1.3 0.6 0.5 0.9 1.3 1.4 1.9 1.1-2.2 2.7-3.7 5.5-3 1.9 0.4 3.2 1.9 3.3 3.8 0.2 2.3-0.8 3.7-3.3 4.8 1.9 0.9 3.3 2.2 3.3 4.4 0 2.3-1.3 3.7-3 4.4q1.6 1.6 3.2 3.2c0.7-1.8 2.2-3.1 4.5-3 2.1 0.1 3.5 1.3 4.1 3.1 1-1.1 2.1-2.2 3.2-3.2-4.3-2-3.9-7 0.1-8.8-0.8-0.6-1.9-1.2-2.3-2.1-0.6-1-0.8-2.2-0.7-3.3 0.1-1.7 1.7-3.1 3.5-3.4 2.7-0.5 4.2 1 5.3 3.3 0.8-2.1 2.2-3.4 4.4-3.4 2.2 0 3.7 1.3 4.4 3.4 2.1-4.7 7.2-4.4 9 0zm28.9 15q0.1 0.1 0.3 0.2 0.3-0.4 0.7-0.7-0.5 0.2-1 0.5zm-99.4-42.9q-0.4 0.5-0.8 0.9 0.5-0.4 0.9-0.8 0 0-0.1-0.1zm115 48.1c-1 1.1-2.1 2.2-3.1 3.2 4.1 1.7 4.2 6.8-0.4 8.8 2.1 0.7 3.3 2.1 3.4 4.2 0.1 2.3-1.2 3.8-3.5 4.6 2.3 0.9 3.5 2.4 3.5 4.6 0 2.2-1.4 3.6-3.1 4.2q1.7 1.6 3.3 3.2c0.7-1.8 2.1-3.1 4.3-3.1 2.3 0 3.6 1.5 4.4 3.6 0.8-2.3 2.2-3.5 4.3-3.5 2.3-0.1 3.7 1.2 4.6 3.5 0.8-2.3 2.3-3.6 4.5-3.5 2.2 0 3.6 1.3 4.2 3 1.1-1.1 2.2-2.2 3.2-3.2-4-1.7-4.3-6.6 0.4-8.8-2.1-0.8-3.4-2.2-3.4-4.4 0-2.2 1.2-3.7 3.6-4.4-2.3-0.8-3.6-2.2-3.6-4.5-0.1-2.2 1.4-3.6 3-4.3-1.1-1.1-2.1-2.2-3.1-3.2-1.7 3.9-6.7 4.4-8.9-0.3-0.7 2.1-2.2 3.4-4.4 3.4-2.2 0-3.6-1.3-4.3-3.4-2.3 4.8-7.3 4.1-8.9 0.3zm14.8 38.6c0.9 0.9 2 2 2.9 2.9 0.9-0.9 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9zm-8.9 0c1 1 2 2.1 2.9 3 1-1 2.1-2.1 2.9-3-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9zm23.6-44.4c-0.6-0.7-1.4-1.4-2.2-2.3q-1.5 1.5-3 2.9c0.9 0.8 1.6 1.7 2.3 2.3 0.9-0.9 2-2 2.9-2.9zm-2.2-2.3q0 0 0.1-0.1-0.5-0.4-1-0.7 0.5 0.4 0.9 0.8zm-3 2.9q-0.3-0.4-0.7-0.8 0.2 0.5 0.5 1 0.1-0.1 0.2-0.2zm14.1-0.6c-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9 0.9 0.9 2 2 2.9 2.9 0.8-0.9 1.9-2 2.9-2.9zm-46.9 11.3q-0.3 0.3-0.6 0.6 0.3-0.2 0.7-0.5-0.1 0-0.1-0.1zm2.4-2.4c-0.9-1-2-2.1-2.9-3-0.7 0.8-1.6 1.7-2.5 2.6q1.5 1.4 3 2.8c0.9-0.9 1.7-1.7 2.4-2.4zm-5.4-0.4q-0.1-0.1-0.2-0.2-0.2 0.3-0.3 0.7 0.2-0.3 0.5-0.5zm44.1 27c0.9 1 2 2.1 2.9 3 0.9-1 2-2 2.9-2.9-0.9-1-2-2.1-2.9-3-0.9 0.9-2 2-2.9 2.9zm14.7 8.9c-0.9-0.9-2-2-2.9-2.9-0.7 0.7-1.5 1.5-2.3 2.3q1.5 1.4 3 2.8c0.8-0.8 1.6-1.5 2.2-2.2zm-5.2-0.6q-0.1-0.1-0.1-0.2-0.4 0.5-0.7 1 0.4-0.4 0.8-0.8zm3 2.8q-0.4 0.4-0.9 0.9 0.6-0.3 1.1-0.7-0.1-0.1-0.2-0.2zm-57-28.8c1 0.9 2.1 2 2.9 2.9 0.9-0.9 2-2 2.9-3-0.8-0.8-1.9-1.9-2.9-2.8-0.9 0.9-2 1.9-2.9 2.9zm-47.5-26.7c-0.9-1-2-2.1-2.9-3-0.7 0.7-1.5 1.5-2.3 2.3q1.5 1.4 2.9 2.9c0.8-0.8 1.6-1.6 2.3-2.2zm-5.2-0.7q-0.1-0.1-0.2-0.2-0.3 0.5-0.6 1 0.4-0.4 0.8-0.8zm2.9 2.9q-0.4 0.4-0.8 0.8 0.6-0.3 1.1-0.6-0.1-0.1-0.3-0.2zm55.6 33.3c-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9 0.9 1 2 2.1 2.9 3 1-1 2-2 2.9-3zm-109.6-50.4c0.9-1 2.1-2.1 2.9-2.9-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9 0.9 0.9 2 2 2.9 2.9zm-2.9-11.8c0.9 0.9 2 2 2.9 2.9 0.9-1 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m18.7 734.1c0-6.7 0-13.4 0-20.3q3 0 5.9 0c2.3 0 2.6-0.4 2.8-2.7 0.2-1.6 0.5-3.3 0.6-4.9 0.2-1.7-0.3-2.2-2-2.2-2.4 0-4.7 0-7.3 0 0-2.3-0.1-4.4 0.1-6.5 0.1-2.1 1.5-3 3.6-3q1.7-0.1 3.4 0c1.3 0 2-0.6 2-1.9-0.1-1.7 0.1-3.4-0.1-5.1-0.1-0.6-0.8-1.6-1.3-1.6-3 0-6-0.1-9 0.4-4.5 0.7-7.7 4.7-8 9.3-0.1 2.7-0.2 5.4-0.4 8.4-1.5 0-3 0-4.5 0-1.3-0.1-2 0.6-1.9 1.9q0 2.9-0.1 5.8c0 1.4 0.7 2 2 2.1q1.8 0 3.6 0c0.8-0.1 1.1 0.2 1.1 1 0 6.4 0 12.8 0 19.3-0.5 0.1-0.9 0.2-1.3 0.2-6.6 0-13.2 0-19.8-0.1-3.5 0-6.5-2.3-7.3-5.8-0.2-0.7-0.2-1.4-0.2-2.1 0-14 0.1-27.9-0.1-41.8 0-5 3.7-8.6 8.5-8.5q20.9 0.2 41.8 0c4.5-0.1 8.1 3.8 8.1 8.1q-0.2 20.9 0 41.8c0 5.1-4 8.7-8.4 8.4-3.8-0.2-7.6-0.1-11.4-0.1-0.1 0-0.2 0-0.4-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m121 662.1c-1 1-2.1 2.1-3.1 3.1 0.6 0.5 1.7 1.1 2.2 2 0.5 0.9 0.8 2.1 0.7 3.1-0.2 2-1.9 3.4-3.9 3.7-2 0.3-3.7-0.8-4.8-3-1 1-2.1 2.1-3.1 3.1 2.5 1.7 3.4 3.3 2.8 5.5-0.3 1.6-1.9 3-3.6 3.2-2.2 0.4-3.6-0.5-5-3-1.1 1.1-2.2 2.3-3.2 3.3 1.8 0.6 3.1 2.1 3.1 4.3-0.1 2.2-1.3 3.6-3.2 4.2 0.9 0.9 2.1 1.6 2.6 2.6 0.5 1.1 0.5 2.5 0.2 3.6-0.4 1.9-2.4 3-4.5 2.9-1.9-0.2-3.4-1.5-3.9-3.5-0.5-2.2 0.4-3.8 3-5.3-1.1-1-2.2-2.1-3.2-3.1-1.9 4.2-6.8 4.1-8.9-0.4-0.7 2.2-2.2 3.5-4.5 3.4-2.1 0-3.5-1.3-4.1-3.1-1 1-2.1 2.1-3.3 3.3 1.6 0.7 3.1 1.9 3.1 4.2 0 2.3-1.4 3.6-3 4.4 1 1 2.1 2.1 3.1 3.1 0.5-0.6 1.1-1.7 2-2.2 0.9-0.5 2.1-0.8 3.1-0.7 2 0.2 3.4 1.9 3.7 3.9 0.3 2-0.9 3.7-3.1 4.7 1.1 1.1 2.2 2.2 3.2 3.2 2.2-4.5 7.2-3.6 8.7 0.1 0.8-0.8 1.4-2 2.4-2.5 1-0.4 2.4-0.6 3.5-0.3 1.9 0.3 3.3 2.5 3.1 4.4-0.2 2-1.7 3.8-3.6 4.1-2.3 0.4-4.1-0.7-5.3-3.3-0.9 1.9-2.1 3.3-4.4 3.4-2.3 0-3.6-1.4-4.5-3.4-0.9 2.1-2.2 3.4-4.4 3.3-2.3 0-3.6-1.2-4.3-3-1.1 1.1-2.2 2.2-3.3 3.3 1.8 0.7 3.1 2 3.1 4.3-0.1 2.2-1.3 3.5-3 4.2 0.9 1 2 2 2.7 3.3 0.4 0.7 0.3 1.8 0 2.7-0.4 1.9-2.2 3.1-4.3 3-1.9 0-3.7-1.4-4.1-3.2-0.6-2.2 0.3-4 2.9-5.5-1.1-1-2.2-2.1-3.3-3.2-0.7 1.8-2.1 3.1-4.4 3.1-2.1-0.1-3.5-1.3-4.2-3.4-2.4 5-7.4 4-8.9 0.3-0.7 0.8-1.3 1.9-2.3 2.4-0.9 0.5-2.3 0.6-3.4 0.4-2-0.3-3.4-2.3-3.3-4.3 0.1-2.1 1.7-3.9 3.8-4.3 2.1-0.3 4 0.9 4.9 3.1 1.1-1 2.2-2.1 3.2-3.2-1.5-0.8-2.9-2-2.9-4.3-0.1-2.3 1.3-3.6 3-4.3-1.1-1.1-2.2-2.2-3.2-3.3-1.2 2.4-3.1 3.5-5.2 3-2.2-0.5-3.6-2.4-3.6-4.4 0-2.1 1.6-3.9 3.8-4.3 2.1-0.5 4 0.8 5.1 3.3 1.1-2.3 2.7-3.9 5.5-3.3 1.9 0.5 3.2 2 3.4 3.8 0.1 2.3-0.8 3.7-3.3 4.9 4.9 2.4 3.9 7.5 0.3 8.9q1.5 1.5 3.2 3.2c0.7-1.9 2.1-3.2 4.5-3.1 2.1 0.1 3.4 1.4 4 3.1 1.1-1.1 2.2-2.2 3.2-3.2-4.5-2.2-3.7-7.2 0.4-8.8-2.2-1-3.5-2.4-3.3-4.9 0.1-1.6 0.9-2.6 2.1-3.4-1-1-2-2-2.7-2.8-0.8 1.5-2.3 2.4-4.6 2.1-1.8-0.2-3.2-1.5-3.6-3.3-0.6-2.8 0.9-4.4 3.2-5.5-2.4-1.1-3.7-2.9-3.4-4.9 0.3-2.1 1.8-3.6 3.9-4 2-0.3 3.7 0.8 4.9 3.3 2.4-4.6 7.1-4.2 8.9-0.3 1-1 2.1-2.1 3.1-3.1-4.4-2.1-3.9-6.9 0.4-8.8-2.2-0.8-3.4-2.3-3.4-4.5 0.1-2.2 1.3-3.6 3.1-4.2-1.1-1-2.2-2.1-3.2-3.2-2.1 4.3-6.8 4-8.8-0.2-1.4 2.6-3.2 3.7-5.6 3.1-1.8-0.5-3.3-2.3-3.3-4.2 0-2 1.4-3.9 3.3-4.4 2.4-0.6 4.2 0.5 5 2 0.9-0.8 2-1.9 2.9-2.7-1.6-0.8-2.7-2.8-2.2-5 0.5-1.9 2.4-3.4 4.4-3.4 2 0 3.9 1.6 4.3 3.5 0.5 2.3-0.6 4.1-3 5.3 1.1 1 2.2 2.1 3.2 3.1 0.5-0.6 1.1-1.7 2-2.2 0.9-0.5 2.1-0.7 3.1-0.6 1.8 0.1 3.2 1.5 3.6 3.4 0.5 2.1-0.4 3.6-3.3 5.4 2.1 0.8 3.4 2.2 3.4 4.4 0 2.2-1.3 3.7-3.4 4.3 4.5 2.1 4.6 7 0.4 8.9 1 1 2.1 2.1 3.1 3.2 0.7-1.7 2.1-3.1 4.3-3.1 2.2 0 3.7 1.3 4.3 3.2q1.6-1.7 3.2-3.3c-1.6-0.7-3-2.1-3-4.3 0-2.2 1.3-3.7 3.5-4.4-2.6-1.3-3.8-3-3.5-5 0.3-2.1 1.9-3.7 4-4 2-0.2 3.8 1 4.8 3.5 0.9-2.1 2.3-3.5 4.6-3.5 2.2 0.1 3.6 1.4 4.2 3.1 1.1-1.1 2.2-2.1 3.2-3.1-4.7-2.3-3.6-7.3 0.1-8.8-0.8-0.7-1.8-1.2-2.3-2.1-0.6-0.9-0.8-2.1-0.7-3.1 0.2-2.1 1.9-3.6 4-3.8 1.9-0.2 3.6 1 4.7 3.4 1.8-2.9 3.3-3.7 5.4-3.2 2 0.4 3.3 1.9 3.5 3.7 0.2 2.3-0.7 3.8-3.4 5 2.6 1.1 3.9 2.9 3.3 5.6-0.4 1.8-1.7 3-3.5 3.2-2.6 0.4-4.2-0.9-5.1-2.9zm-51.3 39.2q0.2 0.1 0.3 0.3 0.4-0.4 0.8-0.8-0.6 0.2-1.1 0.5zm33.4-30.2c-1 1-2 2-2.9 2.9 0.9 0.9 2 2 2.9 2.9 0.9-0.9 2-2 2.9-2.9-1-0.9-2-2-2.9-2.9zm17.8-17.8c-1 1-2.1 2-2.9 2.9 0.9 0.9 2 2 2.9 3 0.9-1 2-2.1 2.9-3-0.9-0.9-2-2-2.9-2.9zm-56.3 38.5c0.6 0.6 1.4 1.4 2.2 2.2q1.4-1.5 2.9-2.9c-0.8-0.8-1.5-1.5-2.2-2.2-0.9 0.9-2 2-2.9 2.9zm2.2 2.2q-0.1 0.1-0.2 0.1 0.6 0.4 1.1 0.8-0.5-0.4-0.9-0.9zm2.9-2.9q0.4 0.4 0.8 0.8-0.3-0.5-0.6-1.1-0.1 0.2-0.2 0.3zm6.7 15.6c-0.9 0.8-2 2-2.9 2.9 0.9 0.9 2 2 2.9 2.9 1-0.9 2-2 2.9-2.9-1-1-2-2-2.9-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-68.9 665.1c1 1 2.1 2.1 3.2 3.1 1.1-2.4 2.9-3.5 5.2-2.9 2.1 0.5 3.6 2.3 3.5 4.3 0 2.1-1.6 3.9-3.7 4.4-2.1 0.4-4-0.8-5-3.1-1.1 1.1-2.1 2.2-3.2 3.3 1.5 0.7 3 2 3 4.3 0 2.3-1.4 3.5-3 4.3 1.1 1.1 2.1 2.2 3.2 3.2 1.1-2.3 2.9-3.5 5.1-3 2.1 0.5 3.7 2.3 3.6 4.4 0 2.1-1.6 4-3.8 4.4-2 0.4-3.9-0.9-4.9-3.1q-1.6 1.6-3.2 3.2c2.1 1 3.5 2.8 2.8 5.5-0.4 1.7-1.6 2.9-3.4 3.2-2.6 0.4-4.3-0.9-5.1-3q-1.7 1.7-3.3 3.3c1.9 0.6 3.1 2.1 3.1 4.3 0 2.2-1.3 3.6-3.5 4.3 2.4 1.1 3.9 2.7 3.4 5.4-0.4 2-1.9 3.3-3.7 3.5-2.3 0.3-3.7-0.6-4.9-3-1.1 1.1-2.2 2.2-3.3 3.3 1.8 0.7 3.1 2 3.1 4.3-0.1 2.2-1.3 3.5-3.4 4.3 1.9 1 3.4 2.2 3.4 4.5 0 2.3-1.3 3.6-3.4 4.4 2.8 1.5 3.8 3.3 3.3 5.6-0.5 2-2.4 3.4-4.4 3.4-1.9 0-3.8-1.5-4.2-3.3-0.6-2.3 0.4-4.2 2.9-5.5-1.1-1-2.2-2.1-3.2-3.2-1.3 2.5-3.2 3.5-5.5 2.9-1.9-0.5-3.4-2.4-3.3-4.4 0.1-2 1.6-3.8 3.5-4.2 2.3-0.5 4.1 0.6 4.8 2.1 0.8-0.9 1.9-2 3-3.1-1.2 0-2.5-1.5-2.3-3.8 0.1-2.2 1.3-3.4 3-4-1.1-1.1-2.2-2.2-3.3-3.3-0.7 1.9-2.1 3.1-4.4 3-2.2 0-3.4-1.3-4.1-3-1 1-2.1 2.1-3.1 3.1 0.7 0.7 1.8 1.4 2.3 2.4 0.5 0.9 0.6 2.3 0.3 3.4-0.4 1.9-2.4 3.2-4.3 3.1-2-0.1-3.8-1.6-4.2-3.6-0.4-2.3 0.6-4 2-4.7-0.7-0.7-1.7-1.7-2.7-2.8-0.5 0.6-0.9 1.1-1.5 1.4-0.9 0.5-2.1 0.7-3.2 0.6-1.8-0.1-3.2-1.7-3.5-3.6-0.4-2 0.7-3.6 3.3-5.1-2.2-0.9-3.5-2.4-3.4-4.7 0.2-2.1 1.4-3.4 3.1-4-0.9-1-2-1.9-2.7-3.1-0.4-0.7-0.3-1.9-0.1-2.8 0.5-2 2.3-3.2 4.3-3.2 2 0.1 3.6 1.3 4.1 3.3 0.7 2.3-0.1 3.8-3.1 5.7 2.1 0.7 3.3 2.2 3.3 4.4 0 2.1-1.3 3.5-3 4.2 1 1.1 2.1 2.2 3.1 3.2 2.1-4.4 7-3.8 8.9 0.4 0.8-2.1 2.1-3.3 4.3-3.4 2.3 0 3.6 1.3 3.7 2.5 1.1-1.1 2.2-2.2 3-3-1.3-0.5-2.5-2.3-2.1-5 0.3-1.7 2-3.2 3.9-3.4 2.4-0.2 4 1.2 4.8 3.1 1-1.1 2.1-2.2 3.1-3.2-4.2-2.1-4-6.9 0-8.7-1-1-2.1-2.1-3.1-3.1-1.8 4-6.6 4.3-8.7 0-1 1-2.1 2.1-3.1 3.1 2.3 1.1 3.7 3 2.7 6-0.6 1.9-2.6 2.9-4.6 2.7-1.9-0.1-3.4-1.5-3.9-3.5-0.5-2.1 0.5-3.7 3.3-5.3-2.1-0.8-3.5-2.3-3.4-4.6 0.1-2.1 1.4-3.5 3.5-4.2-2-0.9-3.4-2.2-3.5-4.4 0-2.2 1.2-3.7 3.1-4.4q-1.6-1.6-3.2-3.2c-0.7 1.7-2.1 3-4.2 3-2.3 0.1-3.7-1.2-4.4-3.1-1.1 1.1-2.1 2.2-3.1 3.2 0.7 0.6 1.8 1.3 2.3 2.3 0.5 1 0.5 2.4 0.3 3.6-0.5 1.9-2.4 3-4.5 2.9-1.9-0.1-3.5-1.5-4-3.6-0.4-2.1 0.6-3.8 3.1-5.2-0.8-0.7-1.9-1.2-2.4-2.1-0.5-0.9-0.7-2.2-0.6-3.3 0.3-2 1.9-3.3 3.9-3.6 2-0.2 3.7 1 4.7 3.1 1-1 2.1-2.1 3.2-3.2-2.7-1.8-3.6-3.4-2.8-5.7 0.6-1.9 2.3-3.1 4.4-3 1.9 0 3.6 1.4 4.1 3.2 0.6 2.2-0.4 3.9-2.9 5.5 1 1.1 2.1 2.1 3.1 3.1 0.5-0.6 1-1.6 1.9-2.1 0.9-0.5 2-0.9 3.1-0.8 2 0.2 3.4 1.7 3.8 3.8 0.3 1.9-0.8 3.7-3 4.9 1 1 2.1 2.1 3.1 3.1 1.7-3.8 6.7-4.3 8.9 0.3 0.8-2 2.2-3.3 4.4-3.2 2.3 0 3.6 1.3 4.2 3 1.1-1 2.2-2.1 3.3-3.2-1.9-0.8-3.2-2.3-3-4.7 0.1-2 1.3-3.3 3.3-4-1.9-1-3.4-2.2-3.4-4.5 0-2.3 1.4-3.6 3.4-4.5-2.6-1.2-3.6-2.8-3.3-5.1 0.2-1.8 1.7-3.3 3.7-3.7 2-0.4 3.6 0.6 5.1 3.3 0.9-2.2 2.4-3.5 4.7-3.3 2 0.1 3.4 1.3 4 3.1 0.8-0.8 1.5-2 2.5-2.5 1-0.5 2.5-0.6 3.6-0.3 1.9 0.4 3 2.3 2.9 4.4 0 1.9-1.3 3.5-3.3 4-2.2 0.6-3.8-0.3-5.6-3.2-0.7 2.1-2.2 3.3-4.4 3.3-2.1 0-3.6-1.2-4.2-3.1-1.1 1.1-2.2 2.2-3.2 3.2 4.1 2 4.1 6.8 0 8.8zm-42.1 51.2q0.3-0.5 0.7-1-0.4 0.4-0.9 0.8 0.1 0.1 0.2 0.2zm36.2-36.3c-1 1-2.1 2.1-2.9 2.9 0.9 0.9 2 2 2.9 2.9 1-0.9 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9zm-6 2.9c-0.6-0.6-1.4-1.5-2.2-2.3q-1.5 1.5-3 2.9c0.9 0.9 1.7 1.7 2.3 2.3 0.9-0.9 2-2 2.9-2.9zm-2.2-2.3q0 0 0.1-0.1-0.5-0.4-0.9-0.7 0.4 0.4 0.8 0.8zm-3 2.9q-0.3-0.3-0.7-0.7 0.2 0.5 0.5 1 0.1-0.2 0.2-0.3zm5.2 26.1c-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9 0.9 0.9 2 2 2.9 2.9 1-1 2.1-2.1 2.9-2.9zm6-20.7c-1 1-2 2-2.9 2.9 0.9 0.9 2 2 2.9 2.9 0.9-0.9 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9zm-17.8-8.9c-0.9 1-2 2.1-2.9 2.9 0.9 1 2 2 2.9 2.9 1-0.9 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-83.6 775.4c0.7-2.3 2.2-3.5 4.3-3.5 2.2 0 3.7 1.1 4.4 3.3 2.4-4.7 7.2-4.3 9 0 1.3-2.5 3-3.7 5-3.3 2.1 0.3 3.6 1.9 3.9 3.9 0.3 2-0.9 3.8-3.3 4.9 4.6 2.2 4.3 7-0.1 9 2.2 0.8 3.4 2.3 3.4 4.5-0.1 2.1-1.3 3.5-3.6 4.3 2.2 0.8 3.6 2.2 3.6 4.4 0 2.2-1.2 3.7-3.6 4.5 2.4 0.9 3.7 2.4 3.6 4.7q-0.2 3.1-3.6 4.2c2.2 0.9 3.6 2.2 3.6 4.5 0 2.2-1.4 3.6-3.5 4.4 2.5 1.1 3.8 3 3.5 5-0.3 2-1.9 3.6-3.9 3.9-2 0.3-3.8-0.9-5-3.5-0.8 2.1-2.1 3.5-4.3 3.5-2.2 0.1-3.7-1.2-4.6-3.5-0.9 2.4-2.4 3.6-4.7 3.5-2.1-0.1-3.4-1.4-4.1-3.4-2.2 4.6-7 4.4-9.1 0.1-0.8 2.1-2.3 3.4-4.5 3.3-2.1-0.1-3.5-1.3-4.2-3.5-0.9 2.2-2.3 3.5-4.6 3.5-2.2 0-3.6-1.4-4.4-3.5-1.1 2.6-3 3.8-4.9 3.5-2.1-0.3-3.7-1.9-3.9-3.9-0.3-2.1 0.9-3.9 3.4-5-2-0.8-3.4-2.1-3.5-4.3 0-2.2 1.2-3.7 3.6-4.6-2.4-0.9-3.7-2.4-3.5-4.8q0.2-3 3.5-4c-2.2-0.9-3.6-2.3-3.6-4.5 0-2.3 1.4-3.6 3.6-4.5-2.3-0.8-3.5-2.2-3.6-4.4 0-2.2 1.3-3.6 3.4-4.4-4.6-2.1-4.4-7-0.2-8.9-0.8-0.6-1.8-1.2-2.3-2-0.5-0.9-0.8-2.1-0.8-3.1 0.1-2 1.9-3.6 3.9-3.8 1.9-0.3 3.7 0.9 4.9 3.3 2-4.5 7-4.4 9 0 0.8-2.1 2.2-3.3 4.4-3.3 2.1 0 3.5 1.2 4.4 3.5 0.8-2.2 2.2-3.5 4.4-3.5 2.2-0.1 3.7 1.3 4.6 3.5zm17.6 2.4c-2.1 4.3-6.8 3.8-8.9-0.4-0.7 2.1-2.1 3.3-4.2 3.3-2.3 0.1-3.7-1.2-4.6-3.5-0.8 2.3-2.3 3.6-4.5 3.5-2.2 0-3.5-1.3-4.4-3.4-0.9 2.2-2.3 3.5-4.5 3.4-2.1 0-3.6-1.3-4.3-3.3-2 4.4-7 4.6-8.9 0.3-1 1-2.1 2.1-3.2 3.2 1.7 0.6 3.1 2 3.1 4.2 0.1 2.3-1.3 3.7-3.5 4.6 2.3 0.8 3.5 2.3 3.5 4.4 0 2.2-1.3 3.6-3.5 4.4 2.2 0.9 3.5 2.2 3.5 4.5 0 2.2-1.4 3.6-3.5 4.5q3.4 1.1 3.5 4.2c0.1 2.2-1.2 3.7-3.3 4.5 4.5 2.2 4.5 7.1 0.3 8.9 1 1 2.1 2.1 3.2 3.2 0.6-1.7 2-3.1 4.3-3.1 2.2 0 3.6 1.4 4.5 3.6 0.7-2.3 2.1-3.5 4.2-3.6 2.3-0.1 3.7 1.2 4.6 3.5 0.9-2.3 2.3-3.5 4.5-3.5 2.2 0 3.6 1.4 4.4 3.6 0.8-2.3 2.3-3.5 4.4-3.6 2.2 0 3.6 1.3 4.4 3.3 2.1-4.3 6.9-4.5 8.9-0.3 1-1 2.1-2.1 3.1-3.1-4.2-2-4.1-6.8 0.4-8.9-2.2-0.7-3.4-2.2-3.4-4.3 0-2.2 1.3-3.7 3.4-4.4-4.6-2.1-4.5-7 0-9-2.1-0.8-3.4-2.2-3.4-4.4 0-2.2 1.2-3.7 3.4-4.4-4.6-2.1-4.5-7-0.4-8.9-1-1-2.1-2-3.1-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m79.8 611.9c-4.7-2.4-4.3-7.2 0-9.1-2.2-0.8-3.5-2.3-3.4-4.6 0.1-2.1 1.4-3.4 3.6-4.2-2.2-0.8-3.6-2.2-3.6-4.4 0-2.2 1.3-3.7 3.2-4.4-0.8-0.7-1.9-1.3-2.4-2.2-0.5-0.9-0.8-2.2-0.6-3.2 0.2-2.1 1.9-3.5 3.9-3.6 2-0.2 3.7 1 4.7 3.3 2.5-5 7.4-3.9 9 0.1 0.8-2.2 2.3-3.4 4.6-3.4 2.1 0.1 3.5 1.3 4.3 3.6 0.7-2.2 2.2-3.6 4.4-3.6q3.3 0 4.4 3.6c0.9-2.4 2.4-3.7 4.7-3.6 2.1 0.1 3.5 1.3 4.2 3.6 0.9-2.3 2.3-3.6 4.6-3.6 2.2 0 3.6 1.4 4.4 3.5 1.1-2.6 2.9-3.8 4.9-3.5 2 0.3 3.6 1.8 3.9 3.9 0.4 2-0.8 3.8-3.4 5 2.1 0.8 3.4 2.2 3.5 4.4 0 2.2-1.3 3.6-3.6 4.5 2.3 0.9 3.7 2.4 3.5 4.7q-0.1 3-3.5 4.1c2.2 0.9 3.5 2.2 3.6 4.4 0 2.2-1.3 3.7-3.5 4.6 2.2 0.8 3.5 2.3 3.5 4.4-0.1 2.2-1.3 3.7-3.4 4.4 4.6 2.1 4.3 7.1 0.3 8.9 0.8 0.7 1.9 1.3 2.4 2.3 0.5 0.9 0.6 2.2 0.5 3.2-0.3 2-2 3.3-4 3.5-1.9 0.1-3.6-1-4.7-3.4-2.2 4.8-7.2 4.2-9-0.1-0.8 2.2-2.2 3.5-4.5 3.4-2.1 0-3.5-1.2-4.3-3.5-0.8 2.1-2.2 3.5-4.4 3.5-2.2 0.1-3.7-1.2-4.5-3.5-0.9 2.3-2.4 3.7-4.7 3.5-2-0.1-3.4-1.3-4.1-3.5-1 2.2-2.3 3.6-4.6 3.6-2.2-0.1-3.6-1.4-4.4-3.5-1.2 2.5-2.9 3.7-4.9 3.4-2.1-0.2-3.6-1.7-4-3.8-0.3-2 0.8-3.8 3.4-5-2-0.9-3.4-2.2-3.4-4.5 0-2.2 1.3-3.6 3.5-4.5-2.3-0.8-3.5-2.3-3.5-4.5 0.1-2.1 1.3-3.5 3.4-4.2zm53.4-9.1c-2.1-0.8-3.3-2.1-3.4-4.2-0.1-2.3 1.2-3.7 3.5-4.6-2.3-0.9-3.6-2.4-3.5-4.6 0-2.2 1.4-3.5 3-4.2q-1.6-1.6-3.2-3.2c-0.7 1.8-2.1 3.1-4.3 3.1-2.2 0-3.6-1.3-4.4-3.5-0.9 2.3-2.3 3.5-4.5 3.5-2.2 0-3.6-1.3-4.4-3.5-0.8 2.1-2.2 3.5-4.4 3.5-2.3 0-3.7-1.4-4.6-3.6-0.7 2.3-2.2 3.5-4.3 3.6-2.2 0-3.6-1.3-4.4-3.3-2.4 4.7-7.3 4.1-8.9 0.3-1 1-2.1 2.1-3.2 3.2 1.9 0.7 3.1 2.1 3.1 4.4 0 2.1-1.4 3.5-3.5 4.3 2.2 0.8 3.4 2.2 3.5 4.3 0.1 2.2-1.2 3.7-3.5 4.6 2.2 0.8 3.5 2.3 3.5 4.5 0 2.2-1.4 3.6-3.5 4.4 2.2 0.8 3.4 2.2 3.5 4.3 0 2.3-1.2 3.7-3.4 4.5 4.2 1.8 4.9 6.8 0.4 8.9 1 1 2.1 2.1 3.1 3.1 0.7-1.6 2.1-3 4.3-3 2.3-0.1 3.7 1.3 4.5 3.6 0.8-2.4 2.2-3.6 4.3-3.6 2.2-0.1 3.8 1.2 4.5 3.4 1.8-4.3 6.8-4.9 9.1-0.1 0.7-2.1 2.2-3.3 4.4-3.3 2.1 0 3.6 1.2 4.3 3.6 0.9-2.3 2.3-3.6 4.5-3.6 2.2-0.1 3.6 1.3 4.3 3 1.1-1.1 2.2-2.1 3.2-3.1-3.8-1.6-4.6-6.6 0.3-8.9-2-0.7-3.3-2.1-3.3-4.3-0.1-2.2 1.2-3.7 3.3-4.5-4.7-2.2-4.1-7.2 0.1-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-110.4 579.6c1.9-4.5 6.9-4.6 9 0 0.8-2.2 2.3-3.4 4.5-3.4 2.2 0.1 3.5 1.3 4.2 3.4 3-4.6 6.6-4.6 9.1 0 0.8-2.2 2.3-3.5 4.6-3.4 2.1 0.1 3.4 1.4 4.1 3.4 2.1-4.7 7.2-4.4 8.9-0.3 0.7-0.7 1.3-1.8 2.2-2.3 0.8-0.5 2-0.8 3-0.7 2.1 0.2 3.5 1.8 3.8 3.8 0.3 2-0.9 3.8-3.5 5 2.1 0.8 3.5 2.2 3.5 4.4 0 2.2-1.3 3.6-3.5 4.5 2.2 0.9 3.5 2.3 3.5 4.6-0.1 2.1-1.3 3.4-3.5 4.3 2.2 0.8 3.5 2.2 3.5 4.3 0 2.2-1.2 3.7-3.6 4.5 2.4 1 3.7 2.4 3.6 4.7q-0.2 3.1-3.5 4.2c2.1 0.9 3.5 2.3 3.5 4.6 0 2.2-1.4 3.6-3.5 4.4 2.6 1.1 3.8 2.9 3.5 4.9-0.3 2.1-1.9 3.7-4 3.9-2 0.3-3.8-0.9-4.9-3.4-0.8 2-2.1 3.4-4.3 3.5-2.2 0-3.7-1.3-4.6-3.5-0.9 2.2-2.3 3.5-4.6 3.4-2.1 0-3.5-1.3-4.2-3.3-2.4 5-7.4 3.9-9 0-1 2.2-2.4 3.6-4.8 3.3-2-0.2-3.3-1.4-4-3.5-0.9 2.2-2.2 3.5-4.4 3.5-2.3 0.1-3.7-1.2-4.4-3.2-0.8 0.9-1.3 1.9-2.2 2.4-0.9 0.6-2.2 0.8-3.2 0.7-2.1-0.2-3.4-1.9-3.7-3.9-0.2-2 1-3.7 3.5-4.8-2-0.8-3.4-2.2-3.5-4.4 0-2.2 1.2-3.7 3.6-4.5-2.3-0.9-3.7-2.4-3.6-4.7q0.2-3.1 3.6-4.2c-2.2-0.9-3.6-2.3-3.6-4.5 0.1-2.2 1.4-3.6 3.6-4.4-2.2-0.8-3.5-2.2-3.6-4.3 0-2.3 1.2-3.8 3.4-4.5-4.4-2-4.6-7-0.1-9.1-2.4-1.2-3.6-3-3.2-5 0.3-2 1.9-3.6 4-3.8 1.9-0.2 3.7 1 4.8 3.4zm47.9 23.2c-2.1-0.7-3.4-2.2-3.4-4.4 0-2.2 1.3-3.6 3.4-4.3-4.6-2.2-4.4-7.1-0.4-8.9-1-1-2.1-2.1-3.2-3.1-0.7 1.7-2.1 3-4.3 3-2.2 0-3.6-1.4-4.4-3.5-0.8 2.2-2.2 3.4-4.4 3.5-2.2 0-3.6-1.3-4.4-3.4-1.7 4-6.7 5-9.1 0-0.7 2.1-2.1 3.3-4.2 3.4-2.2 0-3.7-1.2-4.5-3.4-2 4.5-7 4.6-8.9 0.4-1 1-2.1 2.1-3.1 3.1 1.7 0.7 3 2.1 3 4.3 0.1 2.3-1.3 3.7-3.5 4.5 2.3 0.8 3.5 2.3 3.5 4.4 0 2.2-1.2 3.6-3.3 4.4 4.5 2.1 4.4 6.9 0 9 2 0.8 3.3 2.2 3.3 4.3 0.1 2.2-1.2 3.7-3.4 4.5 3.9 1.6 5.2 6.5 0.4 8.9 1 1 2.1 2.1 3.1 3.1 1.9-4.2 6.9-4.2 8.9 0.4 0.7-2.1 2.1-3.3 4.2-3.4 2.3-0.1 3.7 1.2 4.6 3.4 0.9-2.2 2.4-3.5 4.6-3.4 2.2 0 3.5 1.4 4.4 3.5 0.7-2.3 2.2-3.5 4.3-3.5 2.2 0 3.7 1.2 4.4 3.3 2.3-4.6 7.1-4.3 8.9-0.3 1-1 2.1-2.1 3.1-3.1-4.1-2-4.2-6.8 0.4-8.9-2-0.7-3.3-2.1-3.4-4.1-0.1-2.3 1.2-3.8 3.4-4.7-4.1-1.8-4.9-6.7 0-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m40.8 670.7c-1.8 4.3-6.8 4.6-8.9 0-0.8 2-2.1 3.2-4.3 3.3-2.3 0.1-3.7-1.2-4.5-3.3-1.6 2.7-3.2 3.7-5.3 3.3-2-0.5-3.4-2-3.6-3.9-0.2-2.3 0.7-3.7 3.3-4.9-0.7-0.5-1.5-0.9-2-1.4-0.6-0.6-0.9-1.3-1.3-1.8-0.7 0.8-1.2 1.8-2.1 2.3-0.9 0.6-2.2 0.8-3.3 0.7-1.8-0.1-3.1-1.7-3.5-3.7-0.4-2 0.6-3.5 3-4.9q-1.5-1.6-3.2-3.2c-0.7 1.6-2.1 3.1-4.4 3-2.2 0-3.5-1.4-4.2-3-1.1 1-2.1 2.1-3.2 3.1 4.1 1.9 4.3 6.8-0.2 8.9 2.5 1.2 3.7 3.1 3.2 5.2-0.5 2.2-2.3 3.7-4.4 3.7-2.1 0-3.9-1.6-4.4-3.8-0.4-2.1 0.8-4 3.5-5.2-2.1-0.8-3.5-2.1-3.5-4.3-0.1-2.2 1.2-3.7 3.2-4.4-0.9-0.8-2-1.4-2.5-2.3-0.5-0.9-0.7-2.2-0.5-3.3 0.2-1.9 1.9-3.3 3.8-3.5 2-0.2 3.7 1 4.8 3.5 0.9-2 2.2-3.4 4.4-3.5 2.2 0 3.7 1.3 4.4 3.3 0.8-0.9 1.3-2 2.2-2.5 0.9-0.5 2.2-0.7 3.3-0.6 2 0.3 3.3 1.9 3.5 4 0.2 1.9-0.9 3.6-3 4.6 1 1 2.1 2.1 3.2 3.2 0.9-2.2 2.7-3.5 5.5-2.9 1.5 0.3 2.9 1.9 3.1 3.5 0.4 2.6-0.9 4.2-2.9 5.1 1.1 1.1 2.2 2.2 3.2 3.2 0.6-1.8 2.1-3.1 4.3-3.1 2.2 0 3.6 1.3 4.3 3.1 1-1.1 2.1-2.1 3.1-3.2-4.3-2-3.7-7.1 0.4-8.8-2.1-0.9-3.4-2.3-3.3-4.7 0.1-2.1 1.4-3.3 3.4-4.1-2.5-1.1-3.8-2.8-3.4-5.4 0.3-1.7 1.9-3.2 3.5-3.5 2.3-0.3 3.8 0.5 5.2 3 1.1-1 2.2-2.2 3.2-3.2-2.4-1.2-3.5-3-2.9-5.2 0.5-2.1 2.3-3.6 4.3-3.6 2.1 0 4 1.7 4.4 3.8 0.4 2.1-0.9 4-3.5 5.1 2.2 0.9 3.5 2.3 3.5 4.5 0 2.3-1.4 3.6-3.5 4.5 2.3 0.8 3.5 2.2 3.5 4.4q0 3.2-3.6 4.4c2.3 0.9 3.6 2.3 3.6 4.5 0 2.2-1.3 3.6-3.4 4.4 2.5 1.3 3.7 3 3.4 4.9-0.3 2.1-1.8 3.7-3.8 4-2 0.3-3.7-0.8-5.1-3.3zm0-2.7c1-0.9 2-2 3-2.9-0.7-0.6-1.4-1.3-2.2-2.1q-1.5 1.4-3 2.8c0.8 0.8 1.5 1.5 2.2 2.2zm0.8-5q0.1-0.1 0.1-0.2-0.5-0.4-1-0.8 0.4 0.5 0.9 1zm-3 2.8q-0.4-0.4-0.8-0.8 0.2 0.5 0.5 1 0.2-0.1 0.3-0.2zm-0.7-9.6c0.9 0.9 2 2 2.9 2.9 1-0.9 2.1-2 3-2.8-1-1-2.1-2.1-3-3-0.9 0.9-2 2-2.9 2.9zm5.8-8.8c-0.9-0.9-2-2-2.9-3-0.9 0.9-2 2-2.9 2.9 1 1 2 2.1 2.9 3 0.9-0.9 2-2 2.9-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m64.1 585c4.1 1.7 5 6.7 0 9.1 2.1 0.7 3.4 2.1 3.4 4.3 0 2.2-1.3 3.7-3.4 4.4 2.8 1.7 3.8 3.3 3.3 5.4-0.4 1.9-1.9 3.3-3.7 3.5-2.3 0.2-3.8-0.7-4.9-3-1.1 1-2.2 2.1-3.2 3.2 0.7 0.5 1.7 1.1 2.2 1.9 0.5 1 0.7 2.2 0.7 3.3-0.1 1.8-1.8 3.2-3.7 3.5-2 0.4-3.5-0.6-5.1-3.3-0.8 2.1-2.3 3.4-4.6 3.4-2.1-0.1-3.5-1.3-4.1-3.1-1 1-2.1 2.1-3.2 3.2 2.7 1.8 3.5 3.4 2.8 5.7-0.6 1.9-2.3 3.1-4.4 3-1.9 0-3.6-1.4-4.1-3.2-0.6-2.3 0.3-4 3-5.6-0.8-0.7-1.9-1.3-2.4-2.2-0.5-0.8-0.7-2-0.6-3.1 0.1-1.7 1.5-3.1 3.4-3.5 2.7-0.5 4.3 1 5.2 3q1.6-1.6 3.2-3.3c-1.7-0.7-3.1-2-3.1-4.2 0-2.3 1.3-3.7 3.5-4.5-2.2-0.9-3.5-2.3-3.5-4.6 0.1-2.1 1.4-3.5 3.4-4.2-4.8-2.3-4.2-7.3-0.2-9-0.8-0.7-2-1.3-2.5-2.2-0.5-1-0.6-2.3-0.4-3.4 0.3-2.1 2.3-3.4 4.3-3.3 2.1 0.1 3.9 1.7 4.3 3.8 0.3 2.1-0.9 3.9-3.5 5.1 2.2 0.8 3.5 2.2 3.5 4.5 0 2.2-1.4 3.6-3.5 4.4 2.3 0.8 3.5 2.3 3.5 4.5 0 2.1-1.2 3.5-3.1 4.2 1.1 1 2.2 2.1 3.2 3.2 1.9-4.1 6.8-4.2 8.7 0 1.1-1.1 2.2-2.2 3.2-3.2-1.8-0.6-3.1-2.1-3.1-4.3 0-2.1 1.3-3.6 3.5-4.4-2.1-0.9-3.5-2.2-3.5-4.5 0-2.2 1.4-3.6 3.5-4.4-2.8-1.3-3.9-3.2-3.4-5.4 0.6-2.1 2.3-3.5 4.4-3.5 2.1 0 3.9 1.6 4.4 3.8 0.4 2-0.9 3.9-3.4 5zm-14.4 29.7c0.7-0.7 1.5-1.5 2.3-2.3q-1.4-1.5-2.9-2.9c-0.8 0.8-1.6 1.6-2.3 2.3 0.9 0.9 2 2 2.9 2.9zm2.3-2.3q0.1 0.1 0.1 0.1 0.4-0.4 0.7-0.9-0.4 0.4-0.8 0.8zm-2.9-2.9q0.4-0.4 0.8-0.8-0.5 0.3-1 0.6 0.1 0.1 0.2 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m8.4 807.6c-1.1-1-2.2-2.1-3.3-3.2-0.7 1.5-2 3-4.3 3-2.3 0-3.5-1.4-4.3-3q-1.6 1.6-3.2 3.2c1.8 0.6 3.1 2.1 3.1 4.3 0 2.1-1.3 3.6-3.4 4.3 3 1.9 3.8 3.5 3.2 5.8-0.7 2-2.3 3.2-4.5 3.2-2-0.1-3.7-1.5-4.1-3.6-0.5-2.1 0.5-3.8 3.3-5.3-2.2-0.8-3.5-2.3-3.4-4.6 0.1-2.1 1.3-3.5 3.1-4.1q-1.6-1.5-3.3-3.2c-1.1 2.3-2.9 3.7-5.9 2.7-1.9-0.7-2.9-2.4-2.8-4.6 0.2-1.8 1.6-3.4 3.4-3.8 2.2-0.6 3.9 0.4 5.5 3.2 0.9-2.2 2.4-3.5 4.8-3.3 1.8 0.1 2.9 1 4 3.2 2.9-4.4 6.5-4.4 9 0.1 0.9-2.2 2.5-3.5 4.9-3.3 2 0.2 3.2 1.4 3.8 3.1 0.8-0.8 1.4-2 2.5-2.5 1-0.5 2.4-0.6 3.5-0.4 1.9 0.4 3 2.3 3 4.3 0 1.9-1.4 3.7-3.2 4.2-2.3 0.6-3.8-0.3-5.5-2.9-1.1 1-2.2 2.1-3.2 3.2 1.8 0.7 3.1 2.2 3 4.4 0 2.1-1.3 3.5-3.1 4.1 1.1 1.1 2.2 2.2 3.3 3.2 1.8-2.7 3.4-3.5 5.7-2.8 1.9 0.7 3.1 2.5 3 4.6-0.1 1.9-1.5 3.5-3.3 4-2.3 0.5-4-0.4-5.5-3.2-0.5 0.7-0.8 1.4-1.4 2-0.5 0.5-1.2 0.9-2 1.4 2.3 0.9 3.6 2.5 3.3 5-0.3 2.1-1.9 3.5-3.9 3.8-1.9 0.3-3.6-0.9-4.9-3.2-2 2.9-3.4 3.7-5.7 3-2-0.6-3.2-2.2-3.2-4.3 0-2 1.2-3.6 3.1-4.2 2.3-0.7 3.9 0.1 5.6 2.8 1.1-1 2.2-2.1 3.2-3.1-4-1.8-4.3-6.7 0.3-8.9-2.1-0.7-3.4-2.2-3.3-4.5 0-2.1 1.3-3.5 3.1-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m120.7 686c1-1 2.1-2.1 3.2-3.2-2.1-0.9-3.4-2.7-2.9-5.4 0.3-1.5 1.8-3 3.4-3.3 2.7-0.4 4.3 0.9 5.4 3.3 1.3-2.6 2.8-3.6 5.1-3.3 1.8 0.2 3.3 1.7 3.7 3.7 0.4 2-0.6 3.6-3.3 5.2 2.1 0.8 3.4 2.2 3.4 4.4-0.1 2.2-1.3 3.6-3.3 4.3 3 2.1 3.8 3.6 3 5.9-0.6 2-2.3 3.1-4.4 3.1-2-0.1-3.6-1.4-4.1-3.5-0.6-2.2 0.4-3.8 3-5.3q-1.6-1.5-3.3-3.1c-0.7 1.6-2.1 3-4.3 3-2.2 0-3.7-1.3-4.3-3.1q-1.6 1.6-3.2 3.3c1.7 0.7 3.1 2 3.1 4.3 0 2.2-1.4 3.6-3.1 4.3 1.1 1 2.2 2.1 3.2 3.2 1.6-2.7 3.2-3.6 5.5-2.9 2 0.6 3.2 2.2 3.2 4.3 0 2-1.2 3.6-3.2 4.2-2.3 0.7-3.9-0.2-5.5-2.9-1 1.1-2.1 2.2-3.2 3.2 2.7 1.8 3.6 3.4 2.9 5.7-0.7 1.9-2.3 3.1-4.4 3-2 0-3.6-1.2-4.2-3.3-0.6-2.2 0.3-3.8 2.9-5.4-1-1-2.1-2.1-3.1-3.1-1.8 2.7-3.3 3.5-5.7 2.8-1.9-0.6-3.1-2.3-3.1-4.4 0.1-2 1.4-3.6 3.4-4.1 2.2-0.6 3.8 0.2 5.4 2.9 1-1.1 2.1-2.2 3.1-3.2-4.2-2.9-4.2-6.2 0.1-8.7-0.7-0.7-1.8-1.3-2.3-2.2-0.5-0.9-0.8-2.1-0.7-3.2 0.3-2 2-3.4 4-3.6 1.9-0.2 3.6 1 4.6 3.1zm6.8-2.5q-0.4-0.3-0.7-0.7 0.2 0.5 0.5 0.9 0.1-0.1 0.2-0.2zm2.2 2.3c1-0.9 2.1-2 3-2.9-0.7-0.7-1.5-1.5-2.3-2.3q-1.5 1.5-2.9 2.9c0.8 0.9 1.6 1.7 2.2 2.3zm0.7-5.2q0.1-0.1 0.2-0.2-0.5-0.3-1-0.6 0.4 0.4 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m5.1 623.7c1.1-1.1 2.2-2.2 3.3-3.2-1.9-0.6-3.1-2.1-3.1-4.3 0-2.2 1.2-3.6 3.3-4.3-4.8-2.3-4.2-7.3-0.2-9-0.8-0.6-1.8-1.2-2.4-2.1-0.5-0.8-0.7-2-0.6-3.1 0.2-2 1.9-3.5 3.9-3.7 2-0.2 3.8 1 4.8 3.3 0.4-0.6 0.8-1.4 1.4-2 0.5-0.5 1.2-0.9 1.9-1.3-2.3-1.1-3.7-2.9-3.1-5.6 0.3-1.6 1.9-3 3.5-3.2 2.2-0.4 3.5 0.4 5.3 3.1 1.4-2.6 3-3.5 5.2-3.1 1.9 0.3 3.3 1.8 3.6 3.8 0.3 2-0.7 3.5-3.1 4.9 0.8 0.7 1.9 1.3 2.4 2.3 0.5 0.9 0.7 2.2 0.5 3.2-0.3 2-2 3.4-4 3.5-2 0.1-3.6-1.1-4.6-3.5-0.9 2-2.3 3.5-4.5 3.5-2.3 0-3.6-1.4-4.3-3.1-1.1 1.1-2.1 2.2-3.1 3.2 4.5 2.2 3.6 7.2-0.5 8.8 2.2 0.8 3.5 2.3 3.4 4.5 0 2.1-1.2 3.6-3.5 4.3 2.1 0.9 3.5 2.2 3.5 4.5 0.1 2.2-1.2 3.6-3.1 4.3 0.9 0.8 2 1.5 2.5 2.5 0.5 0.9 0.6 2.3 0.4 3.4-0.4 2-2.5 3.3-4.4 3.2-2.2-0.2-3.8-1.7-4.2-3.8-0.4-2.2 0.8-4 3.1-5-1.1-1-2.2-2.1-3.2-3.1-0.6 0.7-1.4 1.9-2.4 2.4-1 0.4-2.5 0.5-3.6 0.2-1.9-0.5-3-2.4-2.8-4.5 0.1-1.8 1.6-3.5 3.3-3.9 2.3-0.5 4.1 0.5 5.4 2.9zm17.9-26.8c1-1 2.1-2 3-2.9-1-0.9-2-2-2.9-2.9-1 0.9-2.1 2-3 2.9 1 0.9 2.1 2 2.9 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-30.2 581.7c-2 3.1-3.5 3.9-5.9 3.2-1.9-0.6-3.1-2.3-3.1-4.4 0.1-2 1.3-3.6 3.4-4.1 2.2-0.6 3.7 0.2 5.6 3.2 0.7-2.1 2.1-3.4 4.3-3.4 2.2 0 3.7 1.2 4.4 3.4 2.3-4.8 7.1-4.3 9 0 0.8-2.2 2.3-3.4 4.5-3.4 2.2 0.1 3.6 1.3 4.3 3.5 0.9-2.1 2.2-3.5 4.6-3.5 2.2 0 3.6 1.4 4.3 3.5 1.3-2.8 3.1-3.9 5.4-3.4 2.1 0.5 3.6 2.3 3.6 4.4 0 2-1.6 3.9-3.8 4.3-2 0.5-4-0.8-5-3-1 1-2.1 2.1-3.2 3.2 2.1 0.9 3.5 2.7 2.9 5.4-0.4 1.7-1.6 2.9-3.4 3.3-2.6 0.4-4.3-0.9-5.3-3.3-1.3 2.6-2.9 3.6-5.2 3.3-1.8-0.2-3.3-1.7-3.7-3.7-0.4-2 0.6-3.6 3-5q-1.5-1.5-3.2-3.2c-0.6 1.7-2 3.1-4.2 3.1q-3.2 0-4.5-3.5c-0.9 2.3-2.4 3.6-4.6 3.5-2.1-0.1-3.6-1.3-4.2-3.4zm28.7 2.7q0.5 0.4 0.9 0.8-0.4-0.5-0.7-1-0.1 0.1-0.2 0.2zm-2.1-2.2c-1 1-2.1 2-3 2.9 0.7 0.6 1.5 1.4 2.3 2.2q1.4-1.4 2.8-2.9c-0.7-0.8-1.5-1.6-2.1-2.2zm-0.7 5.1q-0.1 0.2-0.2 0.3 0.5 0.3 1 0.6-0.4-0.5-0.8-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-24.5 638.3c1 1 2.1 2.1 3.2 3.2 1.8-2.7 3.5-3.6 5.8-2.8 1.9 0.6 3 2.4 2.9 4.5-0.1 1.9-1.5 3.6-3.3 4-2.3 0.5-4-0.4-5.4-2.9-1 1-2.1 2.1-3.1 3.1 0.6 0.6 1.7 1.2 2.2 2.1 0.5 0.9 0.7 2.2 0.6 3.3-0.3 2-2.1 3.3-4.1 3.5-1.9 0.1-3.5-1.1-4.6-3.5-1.1 2.4-2.7 4-5.6 3.3-1.8-0.5-3.1-2-3.3-3.7-0.2-2.3 0.8-3.8 3.4-5-2.5-1.1-3.8-2.8-3.3-5.5 0.3-1.7 1.9-3.1 3.5-3.4 2.6-0.3 4.3 1 5.1 3 1.1-1.1 2.2-2.2 3.1-3.1-0.6-0.6-1.7-1.2-2.2-2.2-0.5-0.9-0.7-2.2-0.5-3.2 0.3-2.1 2.4-3.6 4.4-3.5 2 0.1 3.7 1.5 4.2 3.6 0.5 2.2-0.6 4-3 5.2zm-5.8 6.1c-0.9 0.9-2 2-2.9 2.9 0.9 1 2 2.1 2.9 3 0.9-1 2-2 2.9-2.9-0.9-0.9-2-2-2.9-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-39.4 804.4c-1.3 2.5-3.1 3.5-5.4 2.9-1.9-0.5-3.4-2.4-3.3-4.4 0-1.9 1.4-3.7 3.3-4.2 2.3-0.6 4.1 0.4 5.6 3.2 1-2.4 2.7-3.7 5.4-3.2 1.7 0.2 3.1 1.7 3.4 3.4 0.4 2.2-0.5 3.7-3.3 5.4 2.1 0.8 3.4 2.2 3.3 4.5 0 2.2-1.3 3.5-3.3 4.3 4.8 2.2 4.2 7.2 0.3 8.8 1.1 1 2.1 2.1 3.1 3.1 0.6-0.7 1.3-1.9 2.3-2.3 1-0.5 2.4-0.6 3.5-0.4 1.9 0.4 3.2 2.5 3.1 4.4-0.2 2.1-1.8 3.9-4 4.2-2 0.3-3.8-0.9-4.9-3.4-1.1 2.3-2.6 3.8-5.3 3.3-2-0.4-3.3-1.9-3.5-3.7-0.3-2.2 0.6-3.7 3.1-5.1-4.6-2.2-4-7.2 0.2-8.9-2.2-0.9-3.5-2.3-3.4-4.7 0.1-2.1 1.4-3.3 3.1-4-1.1-1.1-2.2-2.2-3.3-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-36.9 683.5c-1-0.9-2.2-1.9-3-2.6-0.6 1.4-2.5 2.5-4.9 1.9-1.9-0.5-3.4-2.5-3.3-4.4 0-2 1.6-3.9 3.5-4.3q3.5-0.7 5.3 3.3c0.5-0.7 0.8-1.5 1.4-2 0.5-0.6 1.3-0.9 1.8-1.3-0.8-0.8-2-1.4-2.5-2.4-0.4-1-0.6-2.4-0.4-3.4 0.4-1.9 2.5-3.3 4.4-3.2 1.9 0.1 3.7 1.5 4.2 3.4 0.5 2.3-0.5 4-3 5.4 1.1 1 2.2 2.1 3.2 3.2 1.3-2.5 3.2-3.6 5.5-2.9 1.9 0.5 3.4 2.5 3.3 4.5-0.1 1.9-1.6 3.7-3.4 4.1-2.4 0.5-4.3-0.6-4.9-2.1-0.9 0.8-2 1.9-3.1 2.9q-0.3-0.4-0.6-0.8c0.8 0.8 2 1.5 2.4 2.5 0.5 1 0.6 2.4 0.3 3.5-0.4 2-2.4 3.2-4.3 3-2.1-0.1-3.8-1.7-4.1-3.7-0.4-2.2 0.7-4 2.2-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-101.6 757.1c1.1-1 2.1-2.1 3.1-3.1-2.7-1.9-3.5-3.6-2.7-5.9 0.7-1.9 2.4-3 4.5-2.9 2 0.1 3.5 1.5 4 3.6 0.5 2.1-0.5 3.8-3.1 5.2 0.9 0.7 2 1.3 2.5 2.2 0.5 0.9 0.7 2.2 0.5 3.3-0.3 2-2 3.3-4 3.5-1.9 0.1-3.6-1.1-4.6-3.5-0.9 2.1-2.3 3.5-4.6 3.5-2.2-0.1-3.6-1.4-4.4-3.5-1.1 2.5-2.9 3.7-4.9 3.5-2-0.3-3.6-1.8-3.9-3.9-0.4-2 0.8-3.7 3.2-5-2.9-1.8-3.7-3.4-3.1-5.7 0.6-2 2.3-3.2 4.3-3.2 2.1 0 3.7 1.3 4.3 3.3 0.6 2.2-0.3 3.8-2.9 5.4 1 1.1 2.1 2.2 3.1 3.2 2.2-4.6 7.2-3.7 8.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m85.1 828.3q1.6-1.6 3.2-3.2c-2.6-1.6-3.5-3.3-2.8-5.6 0.5-1.8 2.2-3.1 4.2-3.1 2-0.1 3.8 1.2 4.3 3.1 0.7 2.3-0.2 3.9-3.1 5.8 2.6 1.3 3.6 2.9 3.2 5.2-0.3 1.8-1.7 3.2-3.7 3.6-1.9 0.4-3.6-0.7-5.2-3.4-0.8 2.2-2.3 3.5-4.6 3.4-2-0.1-3.4-1.3-4-3.1-0.8 0.8-1.6 2-2.6 2.5-1 0.5-2.4 0.5-3.6 0.3-1.9-0.5-3-2.4-2.8-4.5 0.1-2 1.5-3.5 3.5-4 2.1-0.5 3.8 0.5 5.4 3.3 0.8-2.2 2.3-3.5 4.6-3.4 2 0.1 3.4 1.3 4 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-44.6 780.7c-2.6-1.1-3.8-2.9-3.5-4.9 0.3-2.2 1.9-3.7 4.1-4 1.9-0.2 3.7 1.1 4.7 3.5 1.1-2.4 2.8-3.9 5.5-3.3 1.9 0.4 3.2 1.9 3.4 3.6 0.3 2.3-0.7 3.8-3.3 5.2 2.4 1 3.7 2.7 3.3 5.4-0.3 1.7-1.9 3.1-3.7 3.4-2.2 0.3-3.6-0.6-5-3.1-0.8 0.8-1.4 1.9-2.3 2.4-0.9 0.5-2.2 0.7-3.2 0.6-1.8-0.2-3.3-1.8-3.5-3.8-0.2-2.4 1.1-4 3.5-5zm5.4-2.9c-0.9 0.9-2 2-2.9 2.9 0.6 0.7 1.4 1.5 2.2 2.3q1.5-1.4 2.9-2.9c-0.8-0.8-1.6-1.6-2.2-2.3zm-0.7 5.2q0 0.1-0.1 0.2 0.5 0.3 0.9 0.7-0.4-0.4-0.8-0.9zm2.9-2.9q0.4 0.4 0.8 0.8-0.3-0.5-0.5-1-0.1 0.1-0.3 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-68.9 736.2c1 1 2.1 2.1 3.2 3.1 1.2-2.4 3-3.5 5.3-2.9 2 0.5 3.5 2.4 3.4 4.4-0.1 2.1-1.6 3.9-3.7 4.3-2.2 0.4-4-0.7-5.1-3.3-2 3-3.3 3.8-5.6 3.2-1.8-0.4-3.2-1.9-3.3-3.8-0.2-2.2 0.8-3.7 3.3-4.9-2.7-1.3-4.1-3.2-3-6.2 0.6-1.8 2.4-2.8 4.4-2.7 1.9 0.2 3.5 1.5 4 3.3 0.5 2.3-0.4 3.9-2.9 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m115.1 825.4c-1.1-1.1-2.2-2.2-3.2-3.2-1.7 2.6-3.4 3.5-5.6 2.8-1.9-0.5-3.2-2.2-3.2-4.3 0.1-2 1.4-3.8 3.3-4.2 2.2-0.6 4 0.4 5.5 3 0.7-0.8 1.3-1.9 2.2-2.4 0.9-0.5 2.1-0.7 3.2-0.6 1.8 0.1 3.2 1.7 3.5 3.6 0.3 2.6-1 4.1-3.1 5 0.9 0.8 2 1.4 2.5 2.4 0.5 0.9 0.6 2.2 0.5 3.2-0.4 2.1-2.4 3.6-4.4 3.4-2.1-0.1-3.8-1.6-4.3-3.7-0.4-2.1 0.8-4 3.1-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m103 732.9c-0.8 2.1-2.1 3.3-4.3 3.3-2.3 0.1-3.6-1.2-4.4-3.2-2 3-3.6 3.8-5.9 3.1-1.9-0.6-3.1-2.4-3.1-4.4 0.1-1.9 1.4-3.7 3.3-4.2 2.2-0.6 4 0.4 5.6 3.2 0.9-2.2 2.4-3.5 4.9-3.3 2 0.2 3.2 1.5 3.9 3.3 2-3 3.6-3.8 5.9-3.1 1.9 0.7 3.1 2.3 3 4.4 0 1.9-1.3 3.6-3.2 4.1-2.2 0.6-4-0.4-5.7-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-33.7 620.6c2.8 1.5 3.8 3.3 3.3 5.6-0.5 1.9-2.3 3.3-4.2 3.3-2.1 0.1-4-1.3-4.5-3.2-0.6-2.2 0.4-4 3.2-5.7-2-0.8-3.3-2.2-3.3-4.5 0.1-2.2 1.3-3.5 3.3-4.3-2.9-1.8-3.8-3.5-3.1-5.8 0.5-1.8 2.2-3.1 4.2-3.1 2 0 3.6 1.2 4.2 3 0.8 2.3 0 3.9-3 6 2 0.8 3.2 2.1 3.2 4.4 0 2.2-1.3 3.5-3.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m133 718.5c-2.9-1.9-3.8-3.5-3-5.9 0.6-1.8 2.3-3 4.3-3 2.1 0.1 3.7 1.4 4.2 3.5 0.6 2.2-0.3 3.8-3 5.3 0.8 0.7 2 1.3 2.4 2.3 0.5 0.9 0.7 2.3 0.5 3.4-0.3 2-2.3 3.4-4.3 3.3-1.9 0-3.7-1.5-4.2-3.5-0.5-2.2 0.5-3.9 3.1-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m58.6 819.6c1.5-2.7 3.4-3.8 5.7-3.1 1.8 0.5 3.3 2.4 3.2 4.3 0 2-1.5 3.9-3.4 4.3-2.4 0.5-4.2-0.6-5.3-3-0.8 0.8-1.5 2-2.5 2.5-1 0.4-2.4 0.5-3.6 0.3-1.8-0.4-3-2.2-2.9-4.2 0-2 1.3-3.7 3.1-4.2 2.3-0.6 4 0.2 5.7 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m129.8 759.7c-1.7 2.8-3.3 3.7-5.5 3.1-2.1-0.6-3.3-2.1-3.4-4.1 0-2.2 1.2-3.8 3.2-4.4 2.3-0.7 3.8 0.1 5.7 3.1 1.2-2.6 3-3.7 5.2-3.3 2.2 0.5 3.7 2.3 3.7 4.4 0 2.1-1.5 3.9-3.6 4.4-2.2 0.5-4-0.6-5.3-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-44.7 594c-2.9-1.6-3.9-3.3-3.3-5.6 0.6-2 2.3-3.3 4.4-3.3 2 0.1 3.7 1.3 4.2 3.3 0.6 2.3-0.3 4-2.9 5.5 0.8 0.8 1.9 1.4 2.4 2.4 0.5 1 0.6 2.3 0.4 3.4-0.4 2-2.4 3.3-4.4 3.2-2.1-0.2-3.9-1.8-4.2-3.9-0.3-2.1 0.9-3.9 3.4-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-87.1 656.2c2.9 1.6 3.9 3.4 3.2 5.7-0.5 1.9-2.2 3.2-4.2 3.2-2 0-3.8-1.3-4.3-3.2-0.6-2.3 0.4-4.1 2.9-5.6-0.8-0.7-2-1.4-2.4-2.4-0.5-1-0.6-2.4-0.4-3.4 0.4-1.9 2.4-3.3 4.3-3.2 2.1 0.1 3.9 1.7 4.2 3.6 0.4 2.3-0.6 4.1-3.3 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m40.9 830.8c-1.8 2.8-3.4 3.8-5.6 3.2-2.1-0.6-3.3-2.2-3.3-4.4 0-2 1.2-3.6 3.2-4.2 2.3-0.7 3.8 0.2 5.7 3.1 1.2-2.5 3-3.7 5.1-3.2 2.2 0.4 3.7 2.2 3.7 4.4 0.1 2-1.4 3.8-3.5 4.3-2.1 0.5-4-0.6-5.3-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-43.6 638.5c-2.4 0-4.5-2.1-4.5-4.4-0.1-2.4 2-4.5 4.4-4.6 2.3 0 4.5 2.1 4.5 4.5 0 2.3-2 4.4-4.4 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m32 794.2c-0.1 2.3-2.2 4.4-4.6 4.4-2.4-0.1-4.4-2.2-4.4-4.6 0.1-2.4 2.2-4.4 4.5-4.4 2.4 0.1 4.5 2.2 4.5 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m138.7 829.7c0 2.3-2.1 4.4-4.5 4.4-2.3 0.1-4.4-2.1-4.5-4.4 0-2.4 2.1-4.5 4.5-4.5 2.4 0 4.5 2 4.5 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-3.6 634.1c-0.1 2.4-2.2 4.4-4.6 4.4-2.4-0.1-4.4-2.2-4.4-4.6 0.1-2.4 2.3-4.5 4.6-4.4 2.4 0.1 4.5 2.3 4.4 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-21.4 598.5c0-2.5 2-4.5 4.4-4.5 2.5 0 4.4 2 4.4 4.5 0 2.4-1.9 4.4-4.3 4.4-2.4 0.1-4.5-2-4.5-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m116.4 763c2.5 0 4.5 2 4.5 4.4 0 2.4-2 4.4-4.5 4.4-2.4 0-4.4-2-4.4-4.4-0.1-2.4 2-4.4 4.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-43.7 700.7c-2.4 0-4.4-2-4.4-4.4-0.1-2.5 1.9-4.4 4.4-4.4 2.5-0.1 4.5 1.9 4.5 4.4 0 2.4-2 4.4-4.5 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m36.3 789.6c-2.5 0-4.4-2-4.3-4.5 0-2.5 2-4.4 4.5-4.3 2.5 0 4.3 2 4.3 4.4 0 2.5-1.9 4.4-4.5 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-8.2 611.7c2.4 0 4.5 2.1 4.6 4.5 0 2.3-2 4.5-4.4 4.5-2.4 0-4.5-2-4.6-4.4 0-2.4 2.1-4.5 4.4-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m63.1 629.5c2.3 0 4.5 2.1 4.4 4.5 0 2.4-2.1 4.5-4.4 4.5-2.4 0-4.5-2.1-4.5-4.5 0-2.4 2.1-4.5 4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m62.9 745.2c-2.4-0.1-4.4-2.2-4.3-4.6 0.1-2.4 2.2-4.4 4.6-4.3 2.4 0 4.4 2.2 4.3 4.5 0 2.4-2.2 4.5-4.6 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m32 776.3c0 2.3-2.1 4.4-4.5 4.5-2.3 0-4.4-2-4.5-4.5 0-2.3 2.1-4.5 4.4-4.5 2.4 0 4.5 2.1 4.6 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m40.8 812c0 2.4-2.1 4.4-4.5 4.3-2.5 0-4.3-2-4.3-4.5 0-2.5 2.1-4.5 4.5-4.4 2.4 0.1 4.3 2.1 4.3 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m-101.5 740.8c0 2.4-2.1 4.5-4.5 4.4-2.5-0.1-4.4-2.1-4.3-4.5 0-2.5 2-4.5 4.5-4.4 2.4 0 4.3 2 4.3 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m23 634c0-2.3 2.1-4.5 4.5-4.5 2.3 0 4.4 2.1 4.5 4.5 0 2.4-2.1 4.5-4.5 4.5-2.4 0-4.4-2.1-4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m76.4 776.3c-0.1-2.3 2.1-4.4 4.4-4.5 2.4 0 4.5 2.1 4.5 4.5 0 2.4-2.1 4.5-4.4 4.5-2.4 0-4.5-2.1-4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-83.6 813c-2.2 4.5-7 4.4-9 0-1.4 2.6-3 3.6-5 3.3-2.1-0.4-3.6-1.9-3.9-4-0.2-1.9 0.9-3.7 3.3-4.8-4.4-2-4.4-7-0.1-8.9-0.8-0.7-1.8-1.2-2.3-2-0.5-0.9-0.9-2.1-0.8-3.1 0.2-2 1.7-3.4 3.7-3.8 2.1-0.4 3.7 0.7 5.1 3.2 2-4.4 6.9-4.4 9 0 1.2-2.4 3-3.6 5-3.2 2.1 0.4 3.6 2 3.8 4.1 0.2 2-1 3.6-3.5 4.7 2.1 0.8 3.5 2.2 3.5 4.5 0 2.2-1.3 3.6-3.2 4.3 0.8 0.7 1.8 1.2 2.3 2.1 0.6 0.8 0.9 2 0.8 3-0.1 2.2-1.8 3.6-3.9 3.9-1.9 0.3-3.6-0.9-4.8-3.3zm-3-14.5c1 1 2.1 2.1 2.9 3 1-1 2.1-2.1 2.9-3-0.9-0.9-2-2-2.9-2.9-0.8 0.9-1.9 2-2.9 2.9zm2.9 6c-0.9 0.9-2 2-2.9 2.9 1 1 2.1 2.1 3 3.1 0.4-0.5 0.7-1.2 1.2-1.7 0.6-0.6 1.3-0.9 1.7-1.2-1-1.1-2.1-2.2-3-3.1zm-8.9-8.9c-0.9 0.9-2 2-2.9 2.9 0.7 0.7 1.5 1.5 2.3 2.3q1.5-1.4 2.9-2.9c-0.8-0.8-1.6-1.6-2.3-2.3zm-0.6 5.2q-0.1 0.1-0.2 0.2 0.5 0.3 1 0.6-0.4-0.4-0.8-0.8zm2.9-2.9q0.4 0.4 0.8 0.8-0.3-0.5-0.5-1-0.2 0.1-0.3 0.2zm-0.1 10.3q0.1 0.1 0.2 0.2 0.3-0.6 0.7-1.1-0.5 0.4-0.9 0.9zm-2.8-3.1q0.4-0.3 0.8-0.7-0.5 0.2-1 0.5 0.1 0.1 0.2 0.2zm-2.3 2.3c1 1 2 2.1 2.9 2.9 0.7-0.6 1.4-1.4 2.2-2.1q-1.4-1.6-2.8-3.1c-0.8 0.9-1.6 1.7-2.3 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m112 617.2c-1.8 4.4-6.9 4.8-9 0.1-1.2 2.5-2.9 3.7-5 3.3-2-0.3-3.5-1.8-3.8-3.9-0.3-2 1-3.8 3.3-4.9-4.7-2.2-4.2-7.2-0.2-8.9-0.7-0.6-1.8-1.2-2.3-2.1-0.5-0.9-0.8-2.1-0.7-3.1 0.2-2 1.8-3.4 3.8-3.7 2.1-0.3 3.8 0.9 4.9 3.3 2.4-5 7.5-3.9 8.9-0.1 0.7-0.8 1.3-1.9 2.1-2.4 0.9-0.5 2.2-0.8 3.3-0.7 2 0.3 3.3 1.9 3.6 4 0.2 1.9-1 3.7-3.5 4.8 2.1 0.8 3.4 2.1 3.5 4.3 0 2.3-1.3 3.7-3.2 4.5 0.8 0.7 1.8 1.2 2.3 2.1 0.6 0.9 0.9 2.2 0.7 3.2-0.2 2.1-2 3.5-4 3.7-2 0.1-3.7-1.1-4.7-3.5zm0-2.5c0.9-1 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9-1 0.9-2.1 2-2.9 2.9 1 0.9 2 2 2.9 2.9zm-8.9-5.8c-1 1-2.1 2-2.9 2.8 0.9 1 2 2.1 2.9 3 0.9-0.9 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9zm11.8-6c-1-1-2-2.1-2.9-2.9-0.7 0.7-1.5 1.5-2.3 2.3q1.4 1.4 2.9 2.9c0.8-0.8 1.6-1.6 2.3-2.3zm-5.2-0.6q-0.1-0.1-0.2-0.2-0.3 0.5-0.6 0.9 0.4-0.3 0.8-0.7zm2.9 2.9q-0.4 0.4-0.8 0.8 0.5-0.3 1-0.6-0.1-0.1-0.2-0.2zm-7.2-2.9q0.4 0.4 0.7 0.8-0.2-0.5-0.5-1-0.1 0.1-0.2 0.2zm-2.3-2.3c-1 0.9-2.1 2-2.9 2.8 0.7 0.8 1.5 1.6 2.3 2.4q1.4-1.5 2.9-2.9c-0.8-0.9-1.6-1.7-2.3-2.3zm-0.6 5.2q-0.1 0.1-0.2 0.2 0.5 0.3 0.9 0.6-0.3-0.4-0.7-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m-78.2 611.8c2.4 1.1 3.7 2.9 3.4 4.8-0.3 2.1-1.8 3.7-3.9 4.1-2 0.3-3.9-1-5-3.5-0.8 2-2.1 3.4-4.4 3.5-2.2 0-3.6-1.3-4.4-3.2-0.7 0.8-1.2 1.8-2.1 2.4-0.9 0.5-2.1 0.8-3.1 0.7-2-0.2-3.4-1.8-3.8-3.9-0.3-1.9 0.8-3.5 3.3-4.9-4.4-2.1-4.4-6.9 0-9-2.4-1.2-3.6-3-3.2-5 0.3-2.1 1.9-3.6 4-3.8 1.9-0.3 3.7 1 4.8 3.4 0.9-2 2.2-3.4 4.5-3.4 2.2 0 3.6 1.3 4.4 3.4 1.3-2.6 3.1-3.7 5.1-3.4 2 0.4 3.5 1.9 3.8 4 0.3 2-0.9 3.7-3.3 4.8 4.7 2.2 4.2 7.2-0.1 9zm-15-2.3q0.4-0.4 0.7-0.7-0.4 0.2-0.8 0.5 0 0.1 0.1 0.2zm-2.3 2.2c1 1 2 2.1 2.9 3 0.7-0.7 1.5-1.5 2.3-2.3q-1.4-1.5-2.9-2.9c-0.8 0.8-1.6 1.6-2.3 2.2zm5.2 0.7q0.1 0.1 0.2 0.1 0.3-0.4 0.6-0.9-0.4 0.4-0.8 0.8zm-2.3-12.4c-0.9 0.9-2 2-2.9 2.8 0.7 0.7 1.4 1.5 2.2 2.2q1.5-1.4 3-2.8c-0.8-0.8-1.6-1.6-2.3-2.2zm-0.7 5q-0.1 0.1-0.2 0.2 0.5 0.4 1.1 0.8-0.5-0.5-0.9-1zm3-2.8q0.4 0.4 0.8 0.8-0.3-0.5-0.6-1-0.1 0.1-0.2 0.2zm4.4 0q-0.1 0-0.2-0.1-0.3 0.4-0.6 0.9 0.4-0.4 0.8-0.8zm2.9 2.9q-0.4 0.4-0.8 0.8 0.5-0.3 1.1-0.6-0.2-0.1-0.3-0.2zm2.2-2.2c-0.9-0.9-2-2.1-2.9-3-0.7 0.7-1.4 1.5-2.2 2.3q1.4 1.5 2.9 2.9c0.8-0.8 1.6-1.6 2.2-2.2zm-5.8 8.9c1 0.9 2 2 2.9 2.9 0.9-0.9 2-2 2.9-2.9-0.9-0.9-2-2-2.9-2.9-0.9 0.9-2 2-2.9 2.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1fbec63786108870d24af9777c3228bc.svg";
export { ForwardRef as ReactComponent };